webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(273),
  /* template */
  __webpack_require__(588),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(272),
  /* template */
  __webpack_require__(600),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = smartFocus;
/* harmony export (immutable) */ __webpack_exports__["b"] = loadThemeColor;
/* harmony export (immutable) */ __webpack_exports__["c"] = setThemeColor;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(81);



function smartFocus() {
  __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].nextTick(function () {
    var iFlds = document.querySelectorAll('.w-input .w-input__input');
    if (!iFlds.length) return;

    // eslint-disable-next-line func-names
    var f = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(iFlds).filter(function (el) {
      return !el.value;
    });
    if (f.length === 0) f = [iFlds[iFlds.length - 1]];
    f[0].focus();

    // eslint-disable-next-line func-names
    iFlds.forEach(function (el) {
      if (el.value && el.parentElement) el.parentElement.classList.add('is-moved');
    });
  });
}

function loadThemeColor() {
  var color = localStorage.getItem('launchpad-theme-color');
  var el = document.querySelector('.b-app-structure__secondary');
  if (color && el) el.style.background = color;
}

function setThemeColor(color, hasLocalStorage) {
  var el = document.querySelector('.b-app-structure__secondary');

  if (color) {
    if (el) el.style.background = color;
    if (hasLocalStorage) localStorage.setItem('launchpad-theme-color', color);
  } else {
    if (el) el.style.background = '';
    if (hasLocalStorage) localStorage.removeItem('launchpad-theme-color');
  }
}

/***/ }),
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = redirectToApp;
/* harmony export (immutable) */ __webpack_exports__["a"] = redirectToAppWithError;
/* harmony export (immutable) */ __webpack_exports__["b"] = filterAccounts;
function redirectToApp(appInfo, code) {
  var location = appInfo.redirect_uri;
  location += location.indexOf('?') > -1 ? '&code=' + code : '?code=' + code;
  if (appInfo.state) location += '&state=' + encodeURIComponent(appInfo.state);
  if (appInfo.client_id) location += '&client_id=' + appInfo.client_id;
  if (appInfo.nonce) location += '&nonce=' + encodeURIComponent(appInfo.nonce);
  window.location.href = location;
}

function redirectToAppWithError(appInfo, error, description) {
  var location = appInfo.redirect_uri;
  location += location.indexOf('?') > -1 ? '&error=' : '?error=';
  location += error || 'unknown_error';
  if (description) location += '&error_description=' + encodeURIComponent(description);
  if (appInfo.client_id) location += '&client_id=' + appInfo.client_id;
  window.location.href = location;
}

function filterAccounts(accounts, productCode) {
  var key = '';
  switch (productCode) {
    case 'projects':
      key = 'projectsEnabled';
      break;
    case 'desk':
      key = 'deskEnabled';
      break;
    case 'chat':
      key = 'chatEnabled';
      break;
    default:
      return accounts;
  }
  return accounts.filter(function (acc) {
    return acc.installation[key];
  });
}

/***/ }),
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ERROR_TYPE; });
/* harmony export (immutable) */ __webpack_exports__["a"] = handleAPIError;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

var ERROR_TYPE = {
  FORM_ERROR: 1,
  FATAL_ERROR: 2,
  TFA_REQUIRED: 3,
  TFA_SETUP_REQUIRED: 4,
  INSTALLATION_PROVISIONING: 5,
  INSTALLATION_VALIDATION_PENDING: 6
};

function handleAPIError(store, err, defaultMessage) {
  if (!err) return null;

  if (!err.response || !err.response.data) {
    // eslint-disable-next-line
    console.error('unknown error', err);
    return { type: ERROR_TYPE.FORM_ERROR, err: defaultMessage };
  }

  if (err.response.status === 502) {
    store.commit('showFatalError', {
      error: 'Internal Server Error',
      message: 'An error has occurred, please try again later.',
      appError: 'server_error',
      appErrorExplanation: '502 bad gateway'
    });
    return { type: ERROR_TYPE.FATAL_ERROR, err: '502 bad gateway' };
  }

  var data = err.response.data;

  if (err.response.status === 429 && data.status === 'Too many attempts') {
    return { type: ERROR_TYPE.FORM_ERROR, err: data.error };
  }

  if (err.response.status === 401 && data.status === 'two factor auth setup required') {
    return { type: ERROR_TYPE.TFA_SETUP_REQUIRED, err: data.error };
  }

  if (err.response.status === 401 && data.status === 'Wrong credentials') {
    return { type: ERROR_TYPE.FORM_ERROR, err: data.error };
  }

  if (err.response.status === 401 && data.status === 'email verification required') {
    return { type: ERROR_TYPE.INSTALLATION_VALIDATION_PENDING, err: data.error };
  }

  if (data.status && data.status.indexOf('twoFactorPasscode') > -1) {
    if (data.status.indexOf('required') > -1) {
      return { type: ERROR_TYPE.TFA_REQUIRED, err: data.status };
    }
    if (data.status.indexOf('incorrect') > -1) {
      return { type: ERROR_TYPE.FORM_ERROR, err: 'Two Factor Authentication code is incorrect.' };
    }
  }

  // Try and figure out the error from all the random formats we have :/
  var error = '';
  if (data.error) error = data.error;
  if (data.errors && data.errors.length) error = data.errors[0].message || data.errors[0];
  if (!error && data.message) error = data.message;

  // Errors provided by validate lib.
  if (data.errors && data.errors.constructor === Object) {
    error = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(data.errors).map(function (key) {
      return key + ' ' + data.errors[key];
    }).join(',');
    store.commit('showFatalError', {
      error: 'Validation failed',
      message: error,
      appError: 'validation_failed',
      appErrorExplanation: error
    });
    return { type: ERROR_TYPE.FATAL_ERROR, err: error };
  }

  // Hopefully we have something to handle now
  switch (error) {// eslint-disable-line
    case 'Site not found':
      store.commit('setSiteNotFound');
      return { type: ERROR_TYPE.FATAL_ERROR, err: error };
    case 'Internal server error':
      store.commit('showFatalError', {
        error: 'Internal Server Error',
        message: 'An error has occurred, please try again later.',
        appError: 'server_error',
        appErrorExplanation: 'an internal server error has occurred'
      });
      return { type: ERROR_TYPE.FATAL_ERROR, err: error };
    case 'new user provisioning is disabled':
      store.commit('showFatalError', {
        error: 'Failed to Login',
        explanation: data.explanation,
        appError: 'access_denied',
        appErrorExplanation: 'new saml user was denied access'
      });
      return { type: ERROR_TYPE.FATAL_ERROR, err: error };
    case 'not enough seats':
      store.commit('showFatalError', {
        error: 'Failed to Login',
        explanation: data.explanation,
        appError: 'access_denied',
        appErrorExplanation: 'not enough seats for new saml user'
      });
      return { type: ERROR_TYPE.FATAL_ERROR, err: error };
    case 'Authentication timed out':
      store.commit('showFatalError', {
        error: 'Failed to Login',
        explanation: 'Authentication timed out, please log in again.',
        appError: 'access_denied',
        appErrorExplanation: 'saml login token has expired'
      });
      return { type: ERROR_TYPE.FATAL_ERROR, err: error };
    case 'your IP address is not in the whitelist':
      store.commit('showFatalError', {
        error: 'Access Denied',
        message: 'Access from your IP address is not enabled.',
        explanation: 'Please contact your administrator to give access to your current IP address or log in from an allowed IP.',
        appError: 'access_denied',
        appErrorExplanation: 'user ip is not whitelisted'
      });
      return { type: ERROR_TYPE.FATAL_ERROR, err: error };
    case 'Invite Expired':
      return { type: ERROR_TYPE.FORM_ERROR, err: 'Invite Expired' };
    case 'User not invited':
      return { type: ERROR_TYPE.FORM_ERROR, err: 'User not invited' };
    case 'User not found':
      return { type: ERROR_TYPE.FORM_ERROR, err: 'User not found' };
    case 'Invalid password. Cannot be blank':
      return { type: ERROR_TYPE.FORM_ERROR, err: 'Password cannot be blank.' };
    case 'your password must contain at least 8 characters':
      return { type: ERROR_TYPE.FORM_ERROR, err: 'Password must be at least 8 characters long.' };
    case 'your password must include at least 2 numeric characters':
      return { type: ERROR_TYPE.FORM_ERROR, err: 'Password must contain at least 2 numeric characters.' };
    case 'your password must include at least one letter':
      return { type: ERROR_TYPE.FORM_ERROR, err: 'Password must contain at least one letter.' };
    case 'User handle is not available':
      return { type: ERROR_TYPE.FORM_ERROR, err: 'The handle you have chosen is already in use.' };
    case 'Standard login is not available on your account':
      return { type: ERROR_TYPE.FORM_ERROR, err: 'Standard login is not available on your account.' };
    case 'Installation is being setup':
      return { type: ERROR_TYPE.INSTALLATION_PROVISIONING, err: 'Installation is provisioning' };
    // app login flow errors:
    case 'app has not yet been verified':
      store.commit('showFatalError', {
        error: 'App not yet verified',
        message: 'This app has not yet been verified.',
        explanation: 'Please check your app status in the Developer Portal.',
        appError: 'access_denied',
        appErrorExplanation: 'app has not yet been verified'
      });
      return { type: ERROR_TYPE.FATAL_ERROR, err: error };
    case 'provided redirect_uri is not on the allowed list':
      store.commit('showFatalError', {
        error: 'Invalid redirect_uri',
        message: 'The redirect_uri provided is not on the list of allowed URIs.',
        explanation: 'Please check your parameters and your app settings in the Developer Portal.',
        appError: 'access_denied',
        appErrorExplanation: 'provided redirect_uri is not on the allowed list'
      });
      return { type: ERROR_TYPE.FATAL_ERROR, err: error };
    case 'requested scope does not match app scope':
      store.commit('showFatalError', {
        error: 'Invalid scope',
        message: 'The requested scope is invalid.',
        explanation: 'Please check your parameters and your app settings in the Developer Portal.',
        appError: 'invalid_scope',
        appErrorExplanation: 'requested scope does not match app scope'
      });
      return { type: ERROR_TYPE.FATAL_ERROR, err: error };
    case 'client_id is invalid':
      store.commit('showFatalError', {
        error: 'App not found',
        message: 'The client_id was either not provided or does not match any app.',
        explanation: 'Please update your app or contact the app developer if the issue persists. If you are the developer, please check your parameters and your app settings in the Developer Portal.',
        appError: 'access_denied',
        appErrorExplanation: 'invalid client_id'
      });
      return { type: ERROR_TYPE.FATAL_ERROR, err: error };
    case 'client_secret is invalid':
      store.commit('showFatalError', {
        error: 'Invalid client secret',
        message: 'The client_secret provided is invalid.',
        explanation: 'Please check your parameters and your app settings in the Developer Portal.',
        appError: 'access_denied',
        appErrorExplanation: 'invalid client_secret'
      });
      return { type: ERROR_TYPE.FATAL_ERROR, err: error };
    case 'origin is invalid':
      store.commit('showFatalError', {
        error: 'Invalid origin',
        message: 'The origin provided is invalid.',
        explanation: 'Please check your parameters and your app settings in the Developer Portal.',
        appError: 'access_denied',
        appErrorExplanation: 'invalid origin'
      });
      return { type: ERROR_TYPE.FATAL_ERROR, err: error };
    case 'The token provided is invalid or has expired':
      store.commit('showFatalError', {
        error: 'Invalid token',
        message: 'The token provided is invalid or has expired.',
        explanation: 'Please try again.',
        appError: 'access_denied',
        appErrorExplanation: 'invalid token'
      });
      return { type: ERROR_TYPE.FATAL_ERROR, err: error };
    case 'requested scope requires admin access':
      store.commit('showFatalError', {
        error: 'Access denied',
        message: 'This action requires admin permissions.',
        explanation: 'Please contact a site administrator.',
        appError: 'access_denied',
        appErrorExplanation: 'user requires admin permissions'
      });
      return { type: ERROR_TYPE.FATAL_ERROR, err: error };
    case 'app cannot be authorized':
      store.commit('showFatalError', {
        error: 'App cannot be authorized',
        message: 'The app must be installed.',
        explanation: 'Please contact a site administrator.',
        appError: 'app_cannot_be_authorized',
        appErrorExplanation: 'app must be installed'
      });
      return { type: ERROR_TYPE.FATAL_ERROR, err: error };
    case 'app does not support oauth':
      store.commit('showFatalError', {
        error: 'App does not support OAUTH',
        message: 'This app does not support authorization',
        appError: 'app_does_not_support_oauth',
        appErrorExplanation: 'app does not support oauth'
      });
      return { type: ERROR_TYPE.FATAL_ERROR, err: error };
  }

  // SAML auth error
  if (error.indexOf('illegal base64 data at input byte') > -1) {
    store.commit('showFatalError', {
      error: 'Login Failed',
      message: 'Single Sign On failed, we received invalid parameters.',
      appError: 'server_error',
      appErrorExplanation: 'saml authentication failed, invalid iv and samlauth params'
    });
    return { type: ERROR_TYPE.FATAL_ERROR, err: error };
  }

  return { type: ERROR_TYPE.FORM_ERROR, err: defaultMessage };
}

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isCurrentDomain */
/* harmony export (immutable) */ __webpack_exports__["b"] = sanitiseURL;
/* harmony export (immutable) */ __webpack_exports__["c"] = fixProtocol;
/* harmony export (immutable) */ __webpack_exports__["d"] = navigateExternalURL;
/* harmony export (immutable) */ __webpack_exports__["a"] = buildQueryString;
function isCurrentDomain(url) {
  if (!url) return false;
  return new RegExp('^http(s)?://' + window.location.host + '/', 'i').test(url);
}

function sanitiseURL(url) {
  var prepend = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  if (!url) return null;

  var u = url;

  // Strip out @'s
  if (url.indexOf('@') !== -1) {
    u = url.replace('@', '');
  }

  // Skip the check if URL provided is relative and prepend current domain if needed
  if (u.indexOf('http') !== 0) {
    if (u.indexOf('/') !== 0) u = '/' + u;
    if (prepend) u = window.location.href.replace(/\/launchpad(.*)/, '') + u;
    return u;
  }

  // Prevent XSS and restrict URLs to current domain
  if (isCurrentDomain(u)) {
    return u;
  }

  return null;
}

// fixProtocol changes the url's protocol
// from http to https, if it ends with
// "teamwork.com" - this is to make sure
// that secure cookies are set correctly
// during generic login (we redirect to
// HTTPS but cookie could be set as secure
// on the HTTP url)
function fixProtocol(url) {
  var end = '.teamwork.com/';
  if (url.indexOf(end) !== url.length - end.length) return url;
  if (url.indexOf('https://') === 0) return url;
  return url.replace('http://', 'https://');
}

function navigateExternalURL(url, isIframe) {
  if (!url) return;
  if (!isIframe) {
    window.location.href = url;
    return;
  }
  if (sessionStorage) sessionStorage.setItem('shouldCloseOpener', 'true');
  window.open(url, '_blank');
}

function buildQueryString() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var params = [];
  for (var k in data) {
    // eslint-disable-line
    if (data.hasOwnProperty(k)) {
      // eslint-disable-line
      params.push(encodeURIComponent(k) + '=' + encodeURIComponent(data[k]));
    }
  }
  return params.join('&');
}

/***/ }),
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isDevelopment; });
/* eslint-disable import/prefer-default-export */

var isDevelopment = "production" !== 'production' || window.location.hostname.indexOf('localhost') !== -1;



/***/ }),
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(535)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(244),
  /* template */
  __webpack_require__(593),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3317b7a0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(534)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(264),
  /* template */
  __webpack_require__(591),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-239200ad",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(266),
  /* template */
  __webpack_require__(601),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(531)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(247),
  /* template */
  __webpack_require__(587),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1a4c85c3",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 212 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDAwIDEwMDAiIHdpZHRoPSIxMDAwIiBoZWlnaHQ9IjEwMDAiPgoJPHN0eWxlPgoJCXRzcGFuIHsgd2hpdGUtc3BhY2U6cHJlIH0KCQkuc2hwMCB7IGZpbGw6ICMxZDFjMzkgfSAKCQkuc2hwMSB7IGZpbGw6ICNmZjIyYjEgfSAKCTwvc3R5bGU+Cgk8ZyBpZD0iQ1JNIj4KCQk8cGF0aCBpZD0icGF0aDM2IiBjbGFzcz0ic2hwMCIgZD0iTTg2NC4wNywxNjguNDJjLTI0LjQsLTI0LjM2IC02My44NCwtMjQuMzYgLTg4LjE3LDBsLTYyMi4xNSw2MjIuMTNjLTI0LjMyLDI0LjMzIC0yNC4zMiw2My44IDAsODguMTNjMTIuMTgsMTIuMTkgMjguMTYsMTguMjggNDQuMSwxOC4yOGMxNS45NCwwIDMxLjkyLC02LjA5IDQ0LjA2LC0xOC4yOGw2MjIuMTUsLTYyMi4xMmMyNC4zMiwtMjQuMzMgMjQuMzIsLTYzLjgzIDAsLTg4LjE0IiAvPgoJCTxwYXRoIGlkPSJwYXRoMzAiIGNsYXNzPSJzaHAwIiBkPSJNNjUxLjU4LDYyNC4yNGwtMjQ5LjMxLDI0OS4zNWMtMjQuNCwyNC4zMyAtMjQuNCw2My44IDAsODguMTdjMTIuMTQsMTIuMTYgMjguMDgsMTguMjQgNDQuMDYsMTguMjRjMTUuOTQsMCAzMS44OCwtNi4wNyA0NC4wNiwtMTguMjRsMjQ5LjM1LC0yNDkuMzVjMjQuMzYsLTI0LjMzIDI0LjM2LC02My44IDAsLTg4LjE4Yy0yNC4zMiwtMjQuMzMgLTYzLjg0LC0yNC4zMyAtODguMTcsMHoiIC8+CgkJPHBhdGggaWQ9InBhdGgzMiIgY2xhc3M9InNocDAiIGQ9Ik0xMjIuMjYsMzA5LjQ2YzE1Ljk0LDAgMzEuODgsLTYuMDggNDQuMDYsLTE4LjI0bDExMC4yNiwtMTEwLjIyYzI0LjMyLC0yNC4zNCAyNC4zMiwtNjMuODIgMCwtODguMThjLTI0LjM2LC0yNC4zNCAtNjMuODEsLTI0LjM0IC04OC4xNywtMC4wMmwtMTEwLjIyLDExMC4yMmMtMjQuMzYsMjQuMzcgLTI0LjM2LDYzLjgyIC0wLjA0LDg4LjE4YzEyLjE4LDEyLjE4IDI4LjEyLDE4LjI1IDQ0LjEsMTguMjUiIC8+CgkJPHBhdGggaWQ9InBhdGgzNCIgY2xhc3M9InNocDAiIGQ9Ik02NDIuMDIsNTguOTJjLTI0LjMyLC0yNC4zNCAtNjMuODQsLTI0LjM0IC04OC4xNywwbC01MDkuNTgsNTA5LjZjLTI0LjM2LDI0LjMxIC0yNC4zNiw2My44MSAwLDg4LjE2YzEyLjE0LDEyLjE3IDI4LjEyLDE4LjI0IDQ0LjA2LDE4LjI0YzE1Ljk0LDAgMzEuOTIsLTYuMDggNDQuMDYsLTE4LjI0bDUwOS42MiwtNTA5LjZjMjQuMzYsLTI0LjM0IDI0LjM2LC02My44MyAwLC04OC4xNiIgLz4KCQk8cGF0aCBpZD0icGF0aDM4IiBjbGFzcz0ic2hwMSIgZD0iTTg1OC4wMywzODkuMDZjLTY0LjQzLDAgLTExNi44OCw1Mi40MyAtMTE2Ljg4LDExNi44OWMwLDY0LjQ4IDUyLjQ1LDExNi45MSAxMTYuODgsMTE2LjkxYzY0LjQ3LDAgMTE2LjkyLC01Mi40MyAxMTYuOTIsLTExNi45MWMwLC02NC40NiAtNTIuNDUsLTExNi44OSAtMTE2LjkyLC0xMTYuODl6IiAvPgoJPC9nPgo8L3N2Zz4="

/***/ }),
/* 213 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 214 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 215 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDAwIDEwMDAiIHdpZHRoPSIxMDAwIiBoZWlnaHQ9IjEwMDAiPgoJPHN0eWxlPgoJCXRzcGFuIHsgd2hpdGUtc3BhY2U6cHJlIH0KCQkuc2hwMCB7IGZpbGw6ICMxZDFjMzkgfSAKCQkuc2hwMSB7IGZpbGw6ICNmZjIyYjEgfSAKCTwvc3R5bGU+Cgk8ZyBpZD0iU3BhY2VzIj4KCQk8cGF0aCBpZD0icGF0aDQyIiBjbGFzcz0ic2hwMCIgZD0iTTk4MCwyODYuNjVjMCwxNDcuMDQgLTExOS42NCwyNjYuNjYgLTI2Ni42NywyNjYuNjZoLTE1OS45OHYxNTkuOThjMCwxNDcuMDcgLTExOS42MSwyNjYuNjkgLTI2Ni42NCwyNjYuNjljLTE0Ny4xLDAgLTI2Ni43MSwtMTE5LjYyIC0yNjYuNzEsLTI2Ni42OWMwLC0xNDcuMDMgMTE5LjYxLC0yNjYuNjUgMjY2LjcxLC0yNjYuNjVoMTU5Ljk1di0xNTkuOTljMCwtMTQ3LjAzIDExOS42MSwtMjY2LjY1IDI2Ni42NywtMjY2LjY1YzE0Ny4wMywwIDI2Ni42NywxMTkuNjIgMjY2LjY3LDI2Ni42NXpNNDQ2LjY2LDU1My4zMWgtMTU5Ljk1Yy04OC4yNSwwIC0xNjAuMDIsNzEuNzYgLTE2MC4wMiwxNTkuOThjMCw4OC4yNSA3MS43NiwxNjAuMDIgMTYwLjAyLDE2MC4wMmM4OC4xOSwwIDE1OS45NSwtNzEuNzYgMTU5Ljk1LC0xNjAuMDJ6TTcxMy4zMyw0NDYuNjRjODguMjUsMCAxNTkuOTgsLTcxLjc2IDE1OS45OCwtMTU5Ljk5YzAsLTg4LjIyIC03MS43MywtMTU5Ljk5IC0xNTkuOTgsLTE1OS45OWMtODguMjIsMCAtMTU5Ljk4LDcxLjc3IC0xNTkuOTgsMTU5Ljk5djE1OS45OXoiIC8+CgkJPHBhdGggaWQ9InBhdGg0MCIgY2xhc3M9InNocDEiIGQ9Ik05MzMuOTEsODMzLjk4YzAsLTU1LjI1IC00NC43NCwtMTAwIC05OS45OCwtMTAwYy01NS4yMSwwIC05OS45OCw0NC43NSAtOTkuOTgsMTAwYzAsNTUuMiA0NC43Nyw5OS45OSA5OS45OCw5OS45OWM1NS4yNCwwIDk5Ljk4LC00NC43OSA5OS45OCwtOTkuOTkiIC8+CgkJPHBhdGggaWQ9InBhdGg0NCIgY2xhc3M9InNocDEiIGQ9Ik04MzMuOTMsNzMzLjk4Yy01NS4xNSwwIC05OS45OCw0NC44NSAtOTkuOTgsMTAwYzAsNTUuMTQgNDQuODQsOTkuOTkgOTkuOTgsOTkuOTljNTUuMTUsMCA5OS45OCwtNDQuODUgOTkuOTgsLTk5Ljk5YzAsLTU1LjE1IC00NC44NCwtMTAwIC05OS45OCwtMTAweiIgLz4KCTwvZz4KPC9zdmc+"

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(538)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(250),
  /* template */
  __webpack_require__(603),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-67e314e6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(271),
  /* template */
  __webpack_require__(594),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(251),
  /* template */
  __webpack_require__(599),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(533)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(252),
  /* template */
  __webpack_require__(590),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-232e329e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_raven_js__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_raven_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_raven_js_plugins_vue__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_raven_js_plugins_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_raven_js_plugins_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_App_vue__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_App_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_environment__ = __webpack_require__(105);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
/* eslint-disable */








/* eslint-enable */

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

// Don't set up sentry on localhost/sunbeam
if (!__WEBPACK_IMPORTED_MODULE_6__utils_environment__["a" /* isDevelopment */] && 'https://777359282ec94fb698eb2a934cd2dc29@o7434.ingest.us.sentry.io/266740') {
  // process vars get set by Docker during build
  __WEBPACK_IMPORTED_MODULE_1_raven_js___default.a.config('https://777359282ec94fb698eb2a934cd2dc29@o7434.ingest.us.sentry.io/266740', {
    release: "v2f2573d",
    environment: 'production'
  }).addPlugin(__WEBPACK_IMPORTED_MODULE_2_raven_js_plugins_vue___default.a, __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]).install();
}

__WEBPACK_IMPORTED_MODULE_1_raven_js___default.a.context(function () {
  /* eslint-disable no-new */
  new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
    el: '#app',
    router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
    store: __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */],
    template: '<App/>',
    components: { App: __WEBPACK_IMPORTED_MODULE_3__components_App_vue___default.a }
  });
});

// fix for back-forward cache for Safari, see
// https://stackoverflow.com/questions/8788802/prevent-safari-loading-from-cache-when-back-button-is-clicked
window.onpageshow = function (event) {
  // eslint-disable-line func-names
  if (event.persisted) {
    window.location.reload();
  }
};

/***/ }),
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_pages_Login_Login_vue__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_pages_Login_Login_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_pages_Login_Login_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_pages_ForgotPassword_ForgotPassword_vue__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_pages_ForgotPassword_ForgotPassword_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_pages_ForgotPassword_ForgotPassword_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_pages_ResetPassword_ResetPassword_vue__ = __webpack_require__(571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_pages_ResetPassword_ResetPassword_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_pages_ResetPassword_ResetPassword_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_pages_Logout_Logout_vue__ = __webpack_require__(570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_pages_Logout_Logout_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_pages_Logout_Logout_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_pages_AccountNotSetup_vue__ = __webpack_require__(567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_pages_AccountNotSetup_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_pages_AccountNotSetup_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_pages_TokenAuth_TokenAuth_vue__ = __webpack_require__(575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_pages_TokenAuth_TokenAuth_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_pages_TokenAuth_TokenAuth_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_pages_SAMLAuth_SAMLAuth_vue__ = __webpack_require__(572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_pages_SAMLAuth_SAMLAuth_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_pages_SAMLAuth_SAMLAuth_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_pages_AcceptInvite_AcceptInvite_vue__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_pages_AcceptInvite_AcceptInvite_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_pages_AcceptInvite_AcceptInvite_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_pages_SelectAccount_SelectAccount_vue__ = __webpack_require__(573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_pages_SelectAccount_SelectAccount_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_pages_SelectAccount_SelectAccount_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_pages_Welcome_Welcome_vue__ = __webpack_require__(576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_pages_Welcome_Welcome_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_pages_Welcome_Welcome_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_pages_Success_Success_vue__ = __webpack_require__(574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_pages_Success_Success_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_pages_Success_Success_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_sections_EmailValidation_EmailValidation_vue__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_sections_EmailValidation_EmailValidation_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_sections_EmailValidation_EmailValidation_vue__);
















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  base: '/launchpad/',
  routes: [{
    path: '/login/:productCode?',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_2__components_pages_Login_Login_vue___default.a,
    meta: {
      title: 'Log in'
    }
  }, {
    path: '/forgotpassword/:productCode?',
    name: 'Recover Password',
    component: __WEBPACK_IMPORTED_MODULE_3__components_pages_ForgotPassword_ForgotPassword_vue___default.a,
    meta: {
      title: 'Recover password'
    }
  }, {
    path: '/resetpassword/:userId/:token',
    name: 'Reset Password',
    component: __WEBPACK_IMPORTED_MODULE_4__components_pages_ResetPassword_ResetPassword_vue___default.a,
    meta: {
      title: 'Reset password'
    }
  }, {
    path: '/logout/:productCode?',
    name: 'Logout',
    component: __WEBPACK_IMPORTED_MODULE_5__components_pages_Logout_Logout_vue___default.a,
    meta: {
      title: 'Log out'
    }
  }, {
    path: '/notsetup/:productCode',
    name: 'Account Not Setup',
    component: __WEBPACK_IMPORTED_MODULE_6__components_pages_AccountNotSetup_vue___default.a,
    meta: {
      title: 'Account not setup'
    }
  }, {
    path: '/saml/auth',
    name: 'Single Sign On',
    component: __WEBPACK_IMPORTED_MODULE_8__components_pages_SAMLAuth_SAMLAuth_vue___default.a,
    meta: {
      title: 'Log in'
    }
  }, {
    path: '/tokenauth',
    name: 'Token Login',
    component: __WEBPACK_IMPORTED_MODULE_7__components_pages_TokenAuth_TokenAuth_vue___default.a,
    meta: {
      title: 'Log in'
    }
  }, {
    path: '/acceptinvite/:productCode?',
    name: 'Accept Invite',
    component: __WEBPACK_IMPORTED_MODULE_9__components_pages_AcceptInvite_AcceptInvite_vue___default.a,
    meta: {
      title: 'Get Started'
    }
  }, {
    path: '/join/:productCode?',
    name: 'Join Teamwork',
    component: __WEBPACK_IMPORTED_MODULE_9__components_pages_AcceptInvite_AcceptInvite_vue___default.a,
    meta: {
      title: 'Get started'
    }
  }, {
    path: '/googleSSO/select-account',
    name: 'Google Sign-In',
    component: __WEBPACK_IMPORTED_MODULE_10__components_pages_SelectAccount_SelectAccount_vue___default.a,
    meta: {
      title: 'Log in'
    }
  }, {
    path: '/welcome',
    name: 'Welcome',
    component: __WEBPACK_IMPORTED_MODULE_11__components_pages_Welcome_Welcome_vue___default.a,
    meta: {
      title: 'Welcome',
      hideSiteLogo: true
    }
  }, {
    path: '/success',
    name: 'Success',
    component: __WEBPACK_IMPORTED_MODULE_12__components_pages_Success_Success_vue___default.a,
    meta: {
      title: 'Log in'
    }
  }, {
    path: '/verifyemail/:productCode/:token',
    name: 'Success',
    component: __WEBPACK_IMPORTED_MODULE_13__components_sections_EmailValidation_EmailValidation_vue___default.a,
    meta: {
      title: 'Verify email'
    }
  }]
}));

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_dist_logger__ = __webpack_require__(617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_dist_logger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuex_dist_logger__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_site__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_login__ = __webpack_require__(241);







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* default */]);

var debug = "production" !== 'production' && "production" !== 'test';

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* default */].Store({
  modules: {
    site: __WEBPACK_IMPORTED_MODULE_3__modules_site__["a" /* default */],
    login: __WEBPACK_IMPORTED_MODULE_4__modules_login__["a" /* default */]
  },
  strict: debug,
  plugins: debug ? [__WEBPACK_IMPORTED_MODULE_2_vuex_dist_logger___default()()] : []
}));

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export mutations */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_urlHelper__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_uiHelper__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_environment__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_raven_js__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_raven_js__);











var getEmptyFatalError = function getEmptyFatalError() {
  return {
    error: '', // main message
    message: '', // subtitle
    explanation: '', // HTML content

    appError: '', // code for app login
    appErrorExplanation: '' // explanation for app login
  };
};

// initial state
var initialState = {
  // available types: account, generic, app
  loginType: '',

  // available types: standard, saml-first, saml-email
  loginState: 'standard',

  // meta contains current metadata that may affect rendering
  // or behaviour
  meta: {
    productCode: '',
    hasLocalStorage: true,
    isIframe: false,
    source: '',
    product: '',
    extra: '',
    admin: false,
    ignoreInstallations: '',
    generic: false
  },

  loggedIn: false,

  fatalError: getEmptyFatalError(),

  samlBaseURL: '',
  afterLoginURL: '',
  formState: '',

  // appInfo stores app authentication info
  appInfo: {
    redirect_uri: '',
    state: '',
    client_id: '',
    scope: [],
    install: false,
    nonce: ''
  },

  waf: null,

  selectedAccount: {
    installation: {
      apiEndPoint: ''
    }
  }
};

// getters
var getters = {
  twAuthBaseURL: function twAuthBaseURL(state, getters, rootState) {
    // eslint-disable-line
    if (__WEBPACK_IMPORTED_MODULE_8__utils_environment__["a" /* isDevelopment */]) return 'https://tw-auth-dev.teamwork.com';
    return rootState.site.siteInfo.twAuthBaseURL;
  },
  googleSSOURL: function googleSSOURL(state, getters) {
    // eslint-disable-line
    var url = getters.twAuthBaseURL + '/launchpad/googleSSO/start';
    var params = {};

    if (state.afterLoginURL) params.retURL = state.afterLoginURL;

    if (state.loginType === 'app') {
      params.appLoginRedirectURI = state.appInfo.redirect_uri;
      if (state.appInfo.state) params.state = state.appInfo.state;
      if (state.appInfo.client_id) params.appLoginClientID = state.appInfo.client_id;
      if (state.appInfo.scope) params.appLoginScope = state.appInfo.scope;
      if (state.appInfo.install) params.install = state.appInfo.install;
      if (state.appInfo.nonce) params.nonce = state.appInfo.nonce;
      if (state.meta.ignoreInstallations) params.ignoreInstallations = state.meta.ignoreInstallations; // eslint-disable-line
    }

    if (state.meta.source) params.source = state.meta.source;
    if (state.meta.product) params.product = state.meta.product;
    if (state.meta.extra) params.extra = state.meta.extra;

    return url + '?' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_urlHelper__["a" /* buildQueryString */])(params);
  },
  samlURL: function samlURL(state) {
    var url = state.samlBaseURL.length ? state.samlBaseURL + 'launchpad/saml/start' : '/launchpad/saml/start';
    var params = {};

    switch (state.loginType) {// eslint-disable-line
      case 'account':
      case 'generic':
        if (state.afterLoginURL) params.SAMLAfterLoginURL = state.afterLoginURL;
        break;
      case 'app':
        params.appAuth = true;
        params.redirect_uri = state.appInfo.redirect_uri;
        if (state.appInfo.state) params.state = state.appInfo.state;
        if (state.appInfo.scope) params.scope = state.appInfo.scope;
        if (state.appInfo.client_id) params.client_id = state.appInfo.client_id;
        if (state.appInfo.install) params.install = state.appInfo.install;
        if (state.appInfo.nonce) params.nonce = state.appInfo.nonce;
        if (state.meta.ignoreInstallations) params.ignoreInstallations = state.meta.ignoreInstallations; // eslint-disable-line
        break;
    }

    if (state.meta.source) params.source = state.meta.source;
    if (state.meta.product) params.product = state.meta.product;
    if (state.meta.extra) params.extra = state.meta.extra;

    return url + '?' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_urlHelper__["a" /* buildQueryString */])(params);
  },
  bodyClasses: function bodyClasses(state) {
    var classes = [];
    if (state.meta.isIframe) classes.push('in-iframe');
    if (state.meta.source) classes.push('source-' + state.meta.source);
    if (state.meta.product) classes.push('product-' + state.meta.product);
    if (state.meta.extra && typeof state.meta.extra === 'string') {
      state.meta.extra.split(',').forEach(function (s) {
        classes.push('extra-' + s);
      });
    }
    return classes.join(' ');
  },
  allowStandardLogin: function allowStandardLogin(state, getters, rootState) {
    // eslint-disable-line
    if (state.meta.admin) return true;
    if (state.loginState === 'saml-first') return !rootState.site.siteInfo.sso.hideStandardLoginLink;
    return rootState.site.siteInfo.displayOptions.allowStandardLogin;
  }
};

// actions
var actions = {
  setupBasicInfo: function setupBasicInfo(_ref, _ref2) {
    var commit = _ref.commit,
        dispatch = _ref.dispatch;
    var query = _ref2.query,
        params = _ref2.params;

    var host = window.location.host;
    var generic = host === 'www.teamwork.com' || host === 'teamwork.com' || query.generic || query.gad && host.indexOf('tw-auth') > -1 || host === 'staging.teamwork.com' || host === 'www.staging.teamwork.com';

    var appInfo = {};
    if (query.redirect_uri) appInfo.redirect_uri = query.redirect_uri;
    if (query.state) appInfo.state = query.state;
    if (query.client_id) appInfo.client_id = query.client_id;
    if (query.install) appInfo.install = !!query.install;
    if (query.scope) appInfo.scope = query.scope.split(/[\s,]+/);
    if (query.nonce) appInfo.nonce = query.nonce;

    var loginType = 'account';
    if (generic) {
      loginType = 'generic';
      dispatch('loadAwsWaf');
    }
    if (appInfo.redirect_uri) loginType = 'app';

    var afterLoginURL = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_urlHelper__["b" /* sanitiseURL */])(query.continue, loginType === 'account');
    if (loginType === 'account' && !afterLoginURL) {
      afterLoginURL = window.location.href.replace(/\/launchpad(.*)/, '');
      if (params.productCode && params.productCode !== 'projects') {
        afterLoginURL += '/' + params.productCode;
      } else {
        afterLoginURL += '/app';
      }
    }

    var meta = {
      isIframe: false,
      hasLocalStorage: true,
      generic: generic
    };
    if (params.productCode) meta.productCode = params.productCode;
    if (query.source) meta.source = query.source;
    if (query.product) meta.product = query.product;
    if (query.extra) meta.extra = query.extra;
    if (query.ignore_installations) meta.ignoreInstallations = query.ignore_installations;

    // check if in iframe
    try {
      meta.isIframe = window.self !== window.top;
    } catch (e) {
      meta.isIframe = true;
    }

    // check if localStorage is supported, as Safari
    // throws errors when in private browsing mode.
    try {
      localStorage.getItem('test');
    } catch (err) {
      meta.hasLocalStorage = false;
    }

    if (meta.hasLocalStorage) __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_uiHelper__["b" /* loadThemeColor */])();
    if (query.admin) meta.admin = true;

    window.addEventListener('storage', function (eventInfo) {
      if (eventInfo.key === 'loggedIn') {
        dispatch('setLoggedIn', {
          loggedIn: true,
          ignoreLS: true
        });
      }
    });

    commit('setBasicInfo', { loginType: loginType, appInfo: appInfo, meta: meta, afterLoginURL: afterLoginURL });
    if (meta.isIframe) dispatch('setupIFrame', meta.isIframe);
  },
  appendExperimentTracking: function appendExperimentTracking(_ref3, _ref4) {
    var state = _ref3.state,
        commit = _ref3.commit;
    var campaign = _ref4.campaign,
        variation = _ref4.variation;

    var continueURL = state.afterLoginURL || '';
    var parameter = 'utm_content=vwo-' + campaign + '-' + variation;
    var url = void 0;

    if (continueURL.includes('?')) url = continueURL + '&' + parameter;else if (continueURL.endsWith('/')) url = continueURL + '?' + parameter;else url = continueURL + '/?' + parameter;

    commit('setAfterLoginURL', url);
  },
  setupIFrame: function setupIFrame(_ref5, isIframe) {
    var state = _ref5.state,
        commit = _ref5.commit;

    if (!isIframe) return;

    document.body.style.background = 'transparent';
    document.body.classList.add('in-iframe');

    window.addEventListener('beforeunload', function () {
      window.parent.postMessage('pageChanged', '*');
    });

    var pageResized = function pageResized() {
      return window.parent.postMessage('pageResized', '*');
    };
    document.addEventListener('transitionend', pageResized);
    document.addEventListener('webkitTransitionEnd', pageResized);
    document.addEventListener('oTransitionEnd', pageResized);
  },
  loadAwsWaf: function loadAwsWaf(_ref6) {
    var _this = this;

    var commit = _ref6.commit;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
      var wafjs;
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (true) {
                _context.next = 2;
                break;
              }

              return _context.abrupt('return');

            case 2:
              wafjs = document.createElement('script');

              wafjs.src = 'https://e95bdf14f2e1.us-east-1.sdk.awswaf.com/e95bdf14f2e1/d6d9937277be/challenge.js';
              wafjs.setAttribute('defer', '');
              document.head.appendChild(wafjs);
              wafjs.onabort = function () {
                return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.reject(new Error("Couldn't load WAF"));
              };
              wafjs.onerror = wafjs.onabort;
              wafjs.onload = function () {
                commit('setWAF', window.AwsWafIntegration);
                return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.resolve();
              };

            case 9:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  getWafToken: function getWafToken() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;

              if (true) {
                _context2.next = 3;
                break;
              }

              return _context2.abrupt('return', null);

            case 3:
              return _context2.abrupt('return', window.AwsWafIntegration.getToken());

            case 6:
              _context2.prev = 6;
              _context2.t0 = _context2['catch'](0);

              __WEBPACK_IMPORTED_MODULE_9_raven_js___default.a.captureException(_context2.t0, { fingerprint: ['waf library not loaded'] });
              return _context2.abrupt('return', null);

            case 10:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[0, 6]]);
    }))();
  }
};

// export `mutations` as a named export
var mutations = {
  setLoggedIn: function setLoggedIn(state, _ref7) {
    var loggedIn = _ref7.loggedIn,
        userId = _ref7.userId,
        ignoreLS = _ref7.ignoreLS;

    state.loggedIn = loggedIn;
    if (loggedIn && state.meta.hasLocalStorage && !ignoreLS) {
      localStorage.setItem('loggedIn', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()({
        userId: userId,
        dateTimeUTC: new Date().toISOString()
      }));
      // ensure we wipe any previous stale sessionTimeout keys on fresh login
      localStorage.removeItem('twProjects-sessionTimeout');
    }
  },
  setBasicInfo: function setBasicInfo(state, _ref8) {
    var loginType = _ref8.loginType,
        appInfo = _ref8.appInfo,
        meta = _ref8.meta,
        afterLoginURL = _ref8.afterLoginURL;

    if (appInfo && (typeof appInfo === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(appInfo)) === 'object') {
      state.appInfo = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(state.appInfo, appInfo);
    }
    state.meta = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(state.meta, meta);
    state.loginType = loginType;
    state.afterLoginURL = afterLoginURL;
  },
  showFatalError: function showFatalError(state, errorData) {
    state.fatalError = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(state.fatalError, errorData);
  },
  resetFatalError: function resetFatalError(state) {
    state.fatalError = getEmptyFatalError();
  },
  setSAMLBaseURL: function setSAMLBaseURL(state, url) {
    state.samlBaseURL = url;
  },
  setLoginState: function setLoginState(state, loginState) {
    state.loginState = loginState;
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_uiHelper__["a" /* smartFocus */])();
  },
  setSelectedAccount: function setSelectedAccount(state, _ref9) {
    var installation = _ref9.installation;

    state.selectedAccount.installation = installation;
  },
  setFormState: function setFormState(state, formState) {
    state.formState = formState;
  },
  setWAF: function setWAF(state, waflib) {
    state.waf = waflib;
  },
  setAfterLoginURL: function setAfterLoginURL(state, url) {
    state.afterLoginURL = url;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: initialState,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export mutations */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_cookieHelper__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_uiHelper__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_environment__ = __webpack_require__(105);





// initial state
var initialState = {
  siteInfo: {
    name: 'Teamwork.com',
    logo: '',
    url: '',
    displayOptions: {
      allowRememberMe: false,
      hasTeamworkBranding: false,
      showSiteNameOnLoginScreen: false,
      themeColor: '',
      useBackgroundColorOnLogin: false,
      allowStandardLogin: true
    },
    integrations: {
      googleSignIn: {
        enabled: true
      }
    },
    sso: {
      enabled: true,
      loginStyle: '',
      hideStandardLoginLink: false
    },
    apps: {
      projects: false,
      chat: false,
      desk: false
    },
    twAuthBaseURL: 'https://tw-auth.teamwork.com',
    isEnterprise: false,
    installationState: ''
  },

  siteLoading: true,
  siteNotFound: false,

  productInfo: [{
    code: 'projects',
    title: 'Teamwork',
    description: 'The project management app for professionals'
  }, {
    code: 'chat',
    title: 'Teamwork Chat',
    description: 'Instant chat software to keep your team connected'
  }, {
    code: 'desk',
    title: 'Teamwork Desk',
    description: 'The helpdesk that\'s invisible for your customers'
  }, {
    code: 'crm',
    title: 'Teamwork CRM',
    description: 'Sales pipeline management for small businesses ready to take the next step'
  }, {
    code: 'spaces',
    title: 'Teamwork Spaces',
    description: 'A new kind of collaboration software'
  }, {
    code: 'developer',
    title: 'Teamwork Developer Portal',
    description: 'Create and manage integrations for Teamwork products'
  }]
};

// getters
var getters = {};

// actions
var actions = {
  getSiteInfo: function getSiteInfo(_ref, currentRoute) {
    var commit = _ref.commit,
        rootState = _ref.rootState,
        dispatch = _ref.dispatch;
    var isIframe = rootState.login.meta.isIframe;


    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/launchpad/v1/info.json?isIframe=' + isIframe).then(function (response) {
      var info = response.data.info;

      // check if their domain has changed and this is an old url
      var parts = info.url.split('//');
      if (!__WEBPACK_IMPORTED_MODULE_3__utils_environment__["a" /* isDevelopment */] && parts.length > 1) {
        parts = parts[1].split('/');
        var newHost = parts[0].toLowerCase();
        var oldHost = window.location.host.toLowerCase();
        if (newHost.indexOf('sunbeam.teamwork.localhost') === -1 && newHost !== oldHost) {
          // the basehref has changed, redirect to new url
          var base = info.url.substr(0, info.url.length - 1); // remove trailing slash
          var url = '' + base + window.location.pathname + window.location.search.replace(oldHost, newHost);
          window.location.href = url;
          return;
        }
      }

      commit('setLoggedIn', {
        loggedIn: response.data.loggedIn,
        userId: response.data.userId
      });

      if (info.sso.enabled) {
        if (info.sso.loginStyle === 'SSO automatic-start' && currentRoute.path.indexOf('/login') === 0) {
          if (!isIframe) {
            window.location.href = '/launchpad/saml/start?SAMLAfterLoginURL=' + encodeURIComponent(rootState.login.afterLoginURL);
            return;
          }
          /**
           * We need to show button if we're in iframe because otherwise we
           * get 'popup blocked' browser message.
           */
          commit('setLoginState', 'saml-first', { root: true });
        } else if (info.sso.loginStyle === 'dual-login SSO-first') {
          commit('setLoginState', 'saml-first', { root: true });
        }
      }

      commit('setSiteInfo', info);

      var color = info.displayOptions.useBackgroundColorOnLogin ? info.displayOptions.themeColor : '';
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_uiHelper__["c" /* setThemeColor */])(color, rootState.login.meta.hasLocalStorage);

      dispatch('setPageTitle', currentRoute.meta.title);
    }).catch(function (e) {
      // eslint-disable-next-line
      console.error(e);
      commit('setSiteNotFound');
    });
  },
  setPageTitle: function setPageTitle(_ref2, pageTitle) {
    var state = _ref2.state;

    var title = pageTitle + ' - ' + state.siteInfo.name;
    if (state.siteInfo.displayOptions.hasTeamworkBranding) title += ' - Teamwork.com';

    var launchpadLB = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_cookieHelper__["a" /* getCookie */])('LAUNCHPADLB');
    if (launchpadLB === 'beta') title = '\uD83D\uDD25 BETA - ' + title;

    document.title = title;
  }
};

// export `mutations` as a named export
var mutations = {
  setSiteInfo: function setSiteInfo(state, data) {
    state.siteInfo = data;
    state.siteLoading = false;
  },
  setSiteNotFound: function setSiteNotFound(state) {
    state.siteNotFound = true;
    state.siteLoading = false;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: initialState,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getCookie;
function getCookie(name) {
  // eslint-disable-line
  var value = '; ' + document.cookie;
  var parts = value.split('; ' + name + '=');
  if (parts.length === 2) return parts.pop().split(';').shift();
  return '';
}

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_images_icon_visible_svg__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_images_icon_visible_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_images_icon_visible_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_images_icon_invisible_svg__ = __webpack_require__(560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_images_icon_invisible_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_images_icon_invisible_svg__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/** Password input with 'reveal password' button */
/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    label: {
      type: String,
      default: undefined
    },

    value: {
      type: String,
      required: true
    }
  },

  data: function data() {
    return {
      isVisible: false,
      iconVisible: __WEBPACK_IMPORTED_MODULE_0__assets_images_icon_visible_svg___default.a,
      iconInvisible: __WEBPACK_IMPORTED_MODULE_1__assets_images_icon_invisible_svg___default.a
    };
  }
});

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_widgets_PageHeader_PageHeader_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_widgets_PageHeader_PageHeader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_widgets_PageHeader_PageHeader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_widgets_ProductList_vue__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_widgets_ProductList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_widgets_ProductList_vue__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// eslint-disable-next-line @teamwork/cfb-rules/component-paths





/* harmony default export */ __webpack_exports__["default"] = ({
  components: { PageHeader: __WEBPACK_IMPORTED_MODULE_2__components_widgets_PageHeader_PageHeader_vue___default.a, ProductList: __WEBPACK_IMPORTED_MODULE_3__components_widgets_ProductList_vue___default.a },

  data: function data() {
    var _$route = this.$route,
        params = _$route.params,
        query = _$route.query;


    return {
      productCode: params.productCode,
      customMessage: query.message || ''
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])({
    siteInfo: function siteInfo(state) {
      return state.site.siteInfo;
    },
    productInfo: function productInfo(state) {
      return state.site.productInfo;
    },
    title: function title(state) {
      return state.site.siteInfo.displayOptions.showSiteNameOnLoginScreen ? state.site.siteInfo.name : '';
    }
  }), {
    productName: function productName() {
      var productCode = this.productCode,
          productInfo = this.productInfo;

      var product = productInfo.find(function (_ref) {
        var code = _ref.code;
        return code === productCode;
      });

      return product ? product.title : productCode;
    },
    subTitle: function subTitle() {
      return this.title ? this.productName + ' unavailable' : '';
    },
    continueItems: function continueItems() {
      var productCode = this.productCode,
          productInfo = this.productInfo,
          siteInfo = this.siteInfo;


      return productInfo.filter(function (_ref2) {
        var code = _ref2.code;
        return ![productCode, 'developer'].includes(code);
      }).map(function (_ref3) {
        var code = _ref3.code,
            title = _ref3.title,
            description = _ref3.description;

        var productUrl = code === 'projects' ? '' : code;

        return { code: code, title: title, description: description, url: '' + siteInfo.url + productUrl };
      });
    }
  })
});

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_widgets_PageHeader_PageHeader_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_widgets_PageHeader_PageHeader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_widgets_PageHeader_PageHeader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_widgets_Loading_Loading_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_widgets_Loading_Loading_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_widgets_Loading_Loading_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_email_verified_png__ = __webpack_require__(556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_email_verified_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_images_email_verified_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_email_expired_png__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_email_expired_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_images_email_expired_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_images_email_send_png__ = __webpack_require__(555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_images_email_send_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_images_email_send_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_errorHelper__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_urlHelper__ = __webpack_require__(49);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












var STATE_EMAIL_VERIFIED = 'verified';
var STATE_EMAIL_ERROR = 'error';
var STATE_EMAIL_RESENT = 'resent';
var STATE_EMAIL_INITIAL_SEND = 'firstsend';
var STATE_EMAIL_ALREADY_VALIDATED = 'already-validated';

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    PageHeader: __WEBPACK_IMPORTED_MODULE_6__components_widgets_PageHeader_PageHeader_vue___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_7__components_widgets_Loading_Loading_vue___default.a
  },

  data: function data() {
    return {
      emailVerified: __WEBPACK_IMPORTED_MODULE_8__assets_images_email_verified_png___default.a,
      emailExpired: __WEBPACK_IMPORTED_MODULE_9__assets_images_email_expired_png___default.a,
      emailSend: __WEBPACK_IMPORTED_MODULE_10__assets_images_email_send_png___default.a,
      isLoading: false,
      isCTALoading: false,
      errorMessage: undefined,
      state: STATE_EMAIL_ERROR,
      email: null,
      product: 'projects',
      token: '',
      tokenResponse: null,
      loginCode: null
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapState */])({
    isAlreadyVerified: function isAlreadyVerified(state) {
      return state.site.siteInfo.installationState === 'active';
    },
    siteURL: function siteURL(state) {
      return state.site.siteInfo.url;
    }
  }), {
    stateContent: function stateContent() {
      var _this = this,
          _ref;

      return _ref = {}, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, STATE_EMAIL_VERIFIED, {
        image: this.emailVerified,
        headerText: 'Your email address has been verified',
        bodyText: 'We\u2019ve successfully verified your email address as <strong>' + this.email + '</strong> <br> You\u2019re one step closer to completing your account setup.',
        footerText: 'Ready to continue?',
        nextText: 'Click below to move on to the next step',
        ctaText: 'Continue account setup',
        dataIdentifier: 'continue-setup',
        ctaAction: function ctaAction() {
          return _this.continueToApp();
        }
      }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, STATE_EMAIL_ERROR, {
        image: this.emailExpired,
        headerText: 'Email validation link has expired',
        bodyText: 'It looks like your email validation link has expired. <br> Click below to resend the verification email.',
        footerText: 'Didn’t receive the email?',
        nextText: 'Check your spam folder or click below to resend.',
        ctaText: 'Resend email',
        dataIdentifier: 'resend-email-expired',
        ctaAction: function ctaAction() {
          return _this.resendEmail();
        }
      }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, STATE_EMAIL_ALREADY_VALIDATED, {
        image: this.emailVerified,
        headerText: 'Email already verified',
        bodyText: 'The email address associated with this account has already been validated. <br> Click below to go to your Teamwork.com account.',
        ctaText: 'Go to your account',
        dataIdentifier: 'go-to-app',
        ctaAction: function ctaAction() {
          return _this.continueToOnboarding();
        }
      }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, STATE_EMAIL_RESENT, {
        image: this.emailSend,
        headerText: 'Email validation link has been resent',
        bodyText: 'Your email validation link has been resent to <strong>' + this.email + '</strong>. <br> Click below to send another.',
        footerText: 'Your email has been resent',
        nextText: 'Check your spam folder or click below to send another',
        ctaText: 'Resend email',
        dataIdentifier: 'resend-email-expired',
        ctaAction: function ctaAction() {
          return _this.resendEmail();
        }
      }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, STATE_EMAIL_INITIAL_SEND, {
        image: this.emailSend,
        headerText: 'Please verify your email address',
        bodyText: 'We\u2019ve sent a verification link to <strong>' + this.email + '</strong> <br> Please check your inbox and click the verification link we\u2019ve sent to confirm your email address.',
        footerText: 'Didn’t receive the email?',
        nextText: 'Check your spam folder or click below to resend.',
        ctaText: 'Resend email',
        dataIdentifier: 'resend-email-initial',
        ctaAction: function ctaAction() {
          return _this.resendEmail();
        }
      }), _ref;
    }
  }),

  methods: {
    resendEmail: function resendEmail() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var data;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_this2.email) {
                  _this2.redirectToLogin();
                }

                _this2.isCTALoading = true;
                data = {
                  email: _this2.email,
                  product: _this2.product,
                  unvalidatedAccountLoginCode: _this2.loginCode
                };
                _context.next = 5;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post('/launchpad/v1/emailvalidation.json', data).then(function (resp) {
                  _this2.state = STATE_EMAIL_RESENT;
                  _this2.errorMessage = '';
                  _this2.email = resp.data.email;
                }).catch(function (err) {
                  switch (err.response.status) {
                    case 401:
                      _this2.redirectToLogin();
                      break;
                    case 409:
                      _this2.state = STATE_EMAIL_ALREADY_VALIDATED;
                      _this2.errorMessage = 'The email address associated with this account has already been validated';
                      break;
                    default:
                      _this2.state = STATE_EMAIL_ERROR;
                      _this2.errorMessage = 'Something went wrong, please try again';
                      break;
                  }
                }).finally(function () {
                  _this2.isCTALoading = false;
                });

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    continueToApp: function continueToApp() {
      window.location.href = this.tokenResponse.redirectURL;
    },
    continueToOnboarding: function continueToOnboarding() {
      window.location.href = this.siteURL + 'app/getting-started';
    },
    redirectToLogin: function redirectToLogin() {
      var params = {};
      params.continue = '/launchpad/verifyemail/' + this.product + '/' + this.token;
      window.location.href = '/launchpad/login/?' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_urlHelper__["a" /* buildQueryString */])(params);
    }
  },
  created: function created() {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this3.isLoading = true;
              _this3.$store.commit('setFormState', 'email-validation');
              _this3.token = _this3.$route.params.token;
              _this3.product = _this3.$route.params.productCode;
              _this3.loginCode = _this3.$route.query.auth ? _this3.$route.query.auth : 'none';
              _this3.email = _this3.$route.query.email ? _this3.$route.query.email : null;

              if (!_this3.isAlreadyVerified) {
                _context2.next = 10;
                break;
              }

              _this3.state = STATE_EMAIL_ALREADY_VALIDATED;
              _this3.isLoading = false;
              return _context2.abrupt('return');

            case 10:
              if (!(_this3.token === STATE_EMAIL_INITIAL_SEND)) {
                _context2.next = 14;
                break;
              }

              _this3.state = STATE_EMAIL_INITIAL_SEND;
              _this3.isLoading = false;
              return _context2.abrupt('return');

            case 14:
              _context2.next = 16;
              return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get('/launchpad/v1/verifyemailtoken.json?token=' + _this3.token).then(function (resp) {
                _this3.tokenResponse = resp.data;
                _this3.state = STATE_EMAIL_VERIFIED;
                _this3.email = resp.data.email;
              }).catch(function (err) {
                var error = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_errorHelper__["a" /* handleAPIError */])(_this3.$store, err, 'Something went wrong, please try again');
                switch (err.response.status) {
                  case 409:
                    _this3.state = STATE_EMAIL_ALREADY_VALIDATED;
                    break;
                  default:
                    _this3.state = STATE_EMAIL_ERROR;
                    _this3.errorMessage = error.err;
                    break;
                }
              }).finally(function () {
                _this3.isLoading = false;
              });

            case 16:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this3);
    }))();
  },
  unmounted: function unmounted() {
    this.$store.commit('setFormState', '');
  }
});

/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_widgets_PageHeader_PageHeader_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_widgets_PageHeader_PageHeader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_widgets_PageHeader_PageHeader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_widgets_Loading_Loading_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_widgets_Loading_Loading_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_widgets_Loading_Loading_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_widgets_TwSelect_vue__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_widgets_TwSelect_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_widgets_TwSelect_vue__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// eslint-disable-next-line @teamwork/cfb-rules/component-paths






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    PageHeader: __WEBPACK_IMPORTED_MODULE_5__components_widgets_PageHeader_PageHeader_vue___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_6__components_widgets_Loading_Loading_vue___default.a,
    TwSelect: __WEBPACK_IMPORTED_MODULE_7__components_widgets_TwSelect_vue___default.a
  },

  props: {
    defaultInfo: {
      type: Object,
      default: function _default() {
        return { industryCategoryId: undefined, sizeId: undefined };
      }
    }
  },

  data: function data() {
    return {
      isLoading: false,
      errorMessage: undefined,

      companySizes: [],
      industryCategories: [],

      model: {
        size: this.defaultInfo.sizeId,
        industryCategory: this.defaultInfo.industryCategoryId
      }
    };
  },
  created: function created() {
    this.init();
  },


  computed: {
    sizeOptions: function sizeOptions() {
      return this.companySizes.map(function (_ref) {
        var id = _ref.id,
            label = _ref.label;
        return { value: id, label: label };
      });
    },
    industryCategoryOptions: function industryCategoryOptions() {
      return this.industryCategories.map(function (_ref2) {
        var id = _ref2.id,
            name = _ref2.name;
        return { value: id, label: name };
      });
    }
  },

  methods: {
    init: function init() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var sizesPromise, industryCategoriesPromise, _ref3, _ref4, companySizes, industryCategories;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.isLoading = true;

                _context.prev = 1;
                sizesPromise = __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get('/launchpad/v1/companysizes.json');
                industryCategoriesPromise = __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get('/launchpad/v1/industrycategories.json');
                _context.next = 6;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([sizesPromise, industryCategoriesPromise]);

              case 6:
                _ref3 = _context.sent;
                _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref3, 2);
                companySizes = _ref4[0].data.companysizes;
                industryCategories = _ref4[1].data.industrycategories;


                _this.companySizes = companySizes;
                _this.industryCategories = industryCategories;
                _context.next = 17;
                break;

              case 14:
                _context.prev = 14;
                _context.t0 = _context['catch'](1);

                _this.errorMessage = 'Something went wrong. Please try again later.';

              case 17:

                _this.isLoading = false;

              case 18:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[1, 14]]);
      }))();
    },
    save: function save() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _model, size, industryCategory, industryCategoryId, companySizeId;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _model = _this2.model, size = _model.size, industryCategory = _model.industryCategory;

                if (!(!size || !industryCategory)) {
                  _context2.next = 4;
                  break;
                }

                _this2.errorMessage = 'Please fill in all fields';

                return _context2.abrupt('return');

              case 4:
                _context2.prev = 4;

                _this2.isLoading = true;
                _this2.errorMessage = undefined;

                industryCategoryId = parseInt(industryCategory, 10);
                companySizeId = parseInt(size, 10);
                _context2.next = 11;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post('/launchpad/v1/industry.json', { industryCategoryId: industryCategoryId, companySizeId: companySizeId });

              case 11:

                _this2.$emit('saved');
                _context2.next = 17;
                break;

              case 14:
                _context2.prev = 14;
                _context2.t0 = _context2['catch'](4);

                _this2.errorMessage = 'Something went wrong. Please try again later.';

              case 17:

                _this2.isLoading = false;

              case 18:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[4, 14]]);
      }))();
    }
  }
});

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_widgets_Loading_Loading_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_widgets_Loading_Loading_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_widgets_Loading_Loading_vue__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// eslint-disable-next-line @teamwork/cfb-rules/component-paths




/* harmony default export */ __webpack_exports__["default"] = ({
  components: { Loading: __WEBPACK_IMPORTED_MODULE_3__components_widgets_Loading_Loading_vue___default.a },

  props: {
    forced: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {
      isLoading: false,
      errorMessage: undefined,

      isSeedShown: false,
      isOnBackupCodesScreen: false,

      seed: undefined,
      codeModel: undefined,
      backupCodes: undefined
    };
  },


  computed: {
    backupCodesFormatted: function backupCodesFormatted() {
      var _this = this;

      var halfSize = this.backupCodes.length / 2;

      return this.backupCodes.slice(0, halfSize).map(function (code, index) {
        return code + '      ' + _this.backupCodes[halfSize + index];
      }).join('\n');
    }
  },

  methods: {
    getSeed: function getSeed() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _ref, data;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.isLoading = true;
                _this2.errorMessage = undefined;

                _context.prev = 2;
                _context.next = 5;
                return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/launchpad/2fa/login/setup/secretkey.json');

              case 5:
                _ref = _context.sent;
                data = _ref.data;


                _this2.seed = data.secretKey;
                _context.next = 13;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context['catch'](2);

                _this2.errorMessage = 'Can\'t get 2FA seed, please try again later';

              case 13:

                _this2.isLoading = false;

              case 14:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[2, 10]]);
      }))();
    },
    setupTfa: function setupTfa() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _ref2, data;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.isLoading = true;
                _this3.errorMessage = undefined;

                _context2.prev = 2;
                _context2.next = 5;
                return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put('/launchpad/2fa/login/setup/complete.json', { VerificationCode: _this3.codeModel });

              case 5:
                _ref2 = _context2.sent;
                data = _ref2.data;


                _this3.backupCodes = data.codes;
                _this3.isOnBackupCodesScreen = true;
                _context2.next = 14;
                break;

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2['catch'](2);

                if (_context2.t0.response.data && _context2.t0.response.data.message) {
                  _this3.errorMessage = _context2.t0.response.data.message;
                } else {
                  _this3.errorMessage = 'Can\'t setup 2FA, please try again later';
                }

              case 14:

                _this3.isLoading = false;

              case 15:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[2, 11]]);
      }))();
    }
  }
});

/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    display: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      story: false
    };
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var version, response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              version = 'undefined' || 'published';
              _context.next = 3;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('https://api.storyblok.com/v2/cdn/stories/launchpad?version=' + version + '&token=yuo9pU1v4JBrDhbERXWmTwtt');

            case 3:
              response = _context.sent;

              _this.story = response.data.story.content;

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_widgets_PageHeader_PageHeader_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_widgets_PageHeader_PageHeader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_widgets_PageHeader_PageHeader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_widgets_Loading_Loading_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_widgets_Loading_Loading_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_widgets_Loading_Loading_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_widgets_TwSelect_vue__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_widgets_TwSelect_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_widgets_TwSelect_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_images_contributor_persona_png__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_images_contributor_persona_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_images_contributor_persona_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_images_pm_persona_png__ = __webpack_require__(563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_images_pm_persona_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_images_pm_persona_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_ops_manager_persona_png__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_ops_manager_persona_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_images_ops_manager_persona_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_client_persona_png__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_client_persona_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_images_client_persona_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_images_icon_check_svg__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_images_icon_check_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_images_icon_check_svg__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    PageHeader: __WEBPACK_IMPORTED_MODULE_3__components_widgets_PageHeader_PageHeader_vue___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_4__components_widgets_Loading_Loading_vue___default.a,
    TwSelect: __WEBPACK_IMPORTED_MODULE_5__components_widgets_TwSelect_vue___default.a,
    ContributorPersona: __WEBPACK_IMPORTED_MODULE_6__assets_images_contributor_persona_png___default.a,
    ProjectManagerPersona: __WEBPACK_IMPORTED_MODULE_7__assets_images_pm_persona_png___default.a,
    OpsManagerPersona: __WEBPACK_IMPORTED_MODULE_8__assets_images_ops_manager_persona_png___default.a,
    ClientPersona: __WEBPACK_IMPORTED_MODULE_9__assets_images_client_persona_png___default.a
  },

  data: function data() {
    return {
      checkIcon: __WEBPACK_IMPORTED_MODULE_10__assets_images_icon_check_svg___default.a,
      isLoading: false,
      errorMessage: undefined,
      personasList: [{
        label: 'Individual contributor',
        value: 'contributor',
        icon: __WEBPACK_IMPORTED_MODULE_6__assets_images_contributor_persona_png___default.a,
        description: 'I deliver work assigned to me'
      }, {
        label: 'Project manager',
        value: 'manager',
        icon: __WEBPACK_IMPORTED_MODULE_7__assets_images_pm_persona_png___default.a,
        description: 'I oversee the work of others'
      }, {
        label: 'Operations Manager',
        value: 'ops-manager',
        icon: __WEBPACK_IMPORTED_MODULE_8__assets_images_ops_manager_persona_png___default.a,
        description: 'I optimize operational workflows'
      }, {
        label: 'Client',
        value: 'client',
        icon: __WEBPACK_IMPORTED_MODULE_9__assets_images_client_persona_png___default.a,
        description: 'I commission the project'
      }],
      selectedPersona: null
    };
  },


  methods: {
    onSelect: function onSelect(value) {
      this.selectedPersona = value;
    },
    onSubmit: function onSubmit() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this.selectedPersona) {
                  _context.next = 3;
                  break;
                }

                _this.errorMessage = 'Please select a role';
                return _context.abrupt('return');

              case 3:

                _this.isLoading = true;
                _this.errorMessage = undefined;

                _context.next = 7;
                return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.patch('/launchpad/v1/user/meta.json', { userPersona: _this.selectedPersona }).then(function () {
                  _this.$emit('saved');
                }).catch(function (error) {
                  _this.errorMessage = 'Something went wrong. Please try again later. \n Details:  ' + error;
                }).finally(function () {
                  _this.isLoading = false;
                });

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },
  unmounted: function unmounted() {
    this.$store.commit('setFormState', '');
  }
});

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_images_product_icon_projects_svg__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_images_product_icon_projects_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_images_product_icon_projects_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_product_icon_chat_svg__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_product_icon_chat_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_images_product_icon_chat_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_product_icon_desk_svg__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_product_icon_desk_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_images_product_icon_desk_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_images_product_icon_crm_svg__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_images_product_icon_crm_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_images_product_icon_crm_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_images_product_icon_spaces_svg__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_images_product_icon_spaces_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_images_product_icon_spaces_svg__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// eslint-disable-next-line @teamwork/cfb-rules/component-paths






var logos = {
  projects: __WEBPACK_IMPORTED_MODULE_1__assets_images_product_icon_projects_svg___default.a,
  chat: __WEBPACK_IMPORTED_MODULE_2__assets_images_product_icon_chat_svg___default.a,
  desk: __WEBPACK_IMPORTED_MODULE_3__assets_images_product_icon_desk_svg___default.a,
  crm: __WEBPACK_IMPORTED_MODULE_4__assets_images_product_icon_crm_svg___default.a,
  spaces: __WEBPACK_IMPORTED_MODULE_5__assets_images_product_icon_spaces_svg___default.a
};

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    /** @type {{ code, url, title, description }} */
    products: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },

  computed: {
    productItems: function productItems() {
      return this.products.map(function (product) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, product, { logoUrl: logos[product.code] });
      });
    }
  }
});

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// eslint-disable-next-line @teamwork/cfb-rules/component-paths
/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    value: {
      type: null,
      required: true
    },

    name: {
      type: String,
      required: true
    },

    label: {
      type: String,
      default: ''
    },

    /** @type {{ label: string; value: string }} */
    options: {
      type: Array,
      required: true
    }
  },
  data: function data() {
    return {
      innerValue: ''
    };
  },

  computed: {
    empty: function empty() {
      return this.innerValue.length === 0;
    },
    isRequired: function isRequired() {
      return true;
    },
    fieldLabel: function fieldLabel() {
      var label = this.label || this.name;
      return this.isRequired ? label + ' *' : label;
    }
  },
  watch: {
    value: function value(newVal) {
      this.innerValue = newVal;
    }
  },
  created: function created() {
    if (this.value) {
      this.innerValue = this.value;
    }
  },

  methods: {
    blur: function blur() {
      this.$refs.select.blur();
      this.$emit('item-selected');
    }
  }
});

/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_uiHelper__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_sections_SiteNotFound_SiteNotFound_vue__ = __webpack_require__(584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_sections_SiteNotFound_SiteNotFound_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_sections_SiteNotFound_SiteNotFound_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_sections_ErrorMessage_ErrorMessage_vue__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_sections_ErrorMessage_ErrorMessage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_sections_ErrorMessage_ErrorMessage_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_widgets_Loading_Loading_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_widgets_Loading_Loading_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_widgets_Loading_Loading_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_sections_MarketingContent_MarketingContent_vue__ = __webpack_require__(583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_sections_MarketingContent_MarketingContent_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_sections_MarketingContent_MarketingContent_vue__);








// @vue/component
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Launchpad',
  components: {
    SiteNotFound: __WEBPACK_IMPORTED_MODULE_3__components_sections_SiteNotFound_SiteNotFound_vue___default.a,
    ErrorMessage: __WEBPACK_IMPORTED_MODULE_4__components_sections_ErrorMessage_ErrorMessage_vue___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_5__components_widgets_Loading_Loading_vue___default.a,
    MarketingContent: __WEBPACK_IMPORTED_MODULE_6__components_sections_MarketingContent_MarketingContent_vue___default.a
  },
  mounted: function mounted() {
    var _this = this;

    this.$store.dispatch('setupBasicInfo', {
      query: this.$route.query,
      params: this.$route.params
    }).then(function () {
      if (_this.loginType === 'account') {
        _this.$store.dispatch('getSiteInfo', _this.$route);
      } else {
        _this.$store.commit('setSiteInfo', _this.$store.state.site.siteInfo);
        _this.$store.dispatch('setPageTitle', _this.$route.meta.title);
      }
    });

    document.body.addEventListener('focus', function (e) {
      var t = e.target.closest('.w-input');
      if (t) {
        var i = t.querySelector('.w-input__input');
        if (i && i.value === '') t.classList.add('is-moved');
      }
    }, true);

    document.body.addEventListener('blur', function (e) {
      var t = e.target.closest('.w-input');
      if (t) {
        var i = t.querySelector('.w-input__input');
        if (i && i.value === '') t.classList.remove('is-moved');
      }
    }, true);

    document.querySelectorAll('.w-input .w-input__input').forEach(function (el) {
      if (el.value !== '') {
        el.parentElement.classList.add('is-moved');
      }
    });

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_uiHelper__["a" /* smartFocus */])();
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])({
    siteNotFound: function siteNotFound(state) {
      return state.site.siteNotFound;
    },
    siteLoading: function siteLoading(state) {
      if (state.login.loginType === 'generic' && !state.login.waf) return true;
      return state.site.siteLoading;
    },
    fatalError: function fatalError(state) {
      return state.login.fatalError.error;
    },
    allowBranding: function allowBranding(state) {
      return state.site.siteInfo.displayOptions.hasTeamworkBranding;
    },
    loginType: function loginType(state) {
      return state.login.loginType;
    },
    siteName: function siteName(state) {
      return state.site.siteInfo.name;
    },
    siteLogo: function siteLogo(state) {
      return state.login.meta.isIframe ? '' : state.site.siteInfo.logo;
    }, // eslint-disable-line
    isIframe: function isIframe(state) {
      return state.login.meta.isIframe;
    },
    inAppLogin: function inAppLogin(state) {
      return state.login.loginType === 'app';
    },
    inGenericLogin: function inGenericLogin(state) {
      return state.login.loginType === 'generic';
    },
    isPersonaCapture: function isPersonaCapture(state) {
      return state.login.formState === 'persona-capture';
    },
    isEmailValidation: function isEmailValidation(state) {
      return state.login.formState === 'email-validation';
    }
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    bodyClasses: 'bodyClasses'
  }), {
    showSiteLogo: function showSiteLogo() {
      return !this.siteNotFound && this.siteLogo && !this.$route.meta.hideSiteLogo;
    },
    displayMarketingContent: function displayMarketingContent() {
      return !this.siteLoading && !this.siteNotFound && !this.isIframe && !this.inAppLogin && this.inGenericLogin && this.$route.name === 'Login';
    }
  }),
  watch: {
    $route: function $route() {
      this.$store.dispatch('setPageTitle', this.$route.meta.title);
    },
    displayMarketingContent: function displayMarketingContent(value) {
      if (value) this.loadVWO();
    }
  },
  methods: {
    reload: function reload() {
      window.location.reload();
    },
    loadVWO: function loadVWO() {
      var _this2 = this;

      var script = document.createElement('script');
      script.type = 'text/javascript';
      script.id = 'vwoCode';
      script.text = '\n        window._vwo_code || (function() {\n        var account_id=720001,\n        version=2.1,\n        settings_tolerance=2000,\n        hide_element=\'body\',\n        hide_element_style = \'opacity:0 !important;filter:alpha(opacity=0) !important;background:none !important;transition:none !important;\',\n        /* DO NOT EDIT BELOW THIS LINE */\n        f=false,w=window,d=document,v=d.querySelector(\'#vwoCode\'),cK=\'_vwo_\'+account_id+\'_settings\',cc={};try{var c=JSON.parse(localStorage.getItem(\'_vwo_\'+account_id+\'_config\'));cc=c&&typeof c===\'object\'?c:{}}catch(e){}var stT=cc.stT===\'session\'?w.sessionStorage:w.localStorage;code={nonce:v&&v.nonce,use_existing_jquery:function(){return typeof use_existing_jquery!==\'undefined\'?use_existing_jquery:undefined},library_tolerance:function(){return typeof library_tolerance!==\'undefined\'?library_tolerance:undefined},settings_tolerance:function(){return cc.sT||settings_tolerance},hide_element_style:function(){return\'{\'+(cc.hES||hide_element_style)+\'}\'},hide_element:function(){if(performance.getEntriesByName(\'first-contentful-paint\')[0]){return\'\'}return typeof cc.hE===\'string\'?cc.hE:hide_element},getVersion:function(){return version},finish:function(e){if(!f){f=true;var t=d.getElementById(\'_vis_opt_path_hides\');if(t)t.parentNode.removeChild(t);if(e)(new Image).src=\'https://dev.visualwebsiteoptimizer.com/ee.gif?a=\'+account_id+e}},finished:function(){return f},addScript:function(e){var t=d.createElement(\'script\');t.type=\'text/javascript\';if(e.src){t.src=e.src}else{t.text=e.text}v&&t.setAttribute(\'nonce\',v.nonce);d.getElementsByTagName(\'head\')[0].appendChild(t)},load:function(e,t){var n=this.getSettings(),i=d.createElement(\'script\'),r=this;t=t||{};if(n){i.textContent=n;d.getElementsByTagName(\'head\')[0].appendChild(i);if(!w.VWO||VWO.caE){stT.removeItem(cK);r.load(e)}}else{var o=new XMLHttpRequest;o.open(\'GET\',e,true);o.withCredentials=!t.dSC;o.responseType=t.responseType||\'text\';o.onload=function(){if(t.onloadCb){return t.onloadCb(o,e)}if(o.status===200||o.status===304){_vwo_code.addScript({text:o.responseText})}else{_vwo_code.finish(\'&e=loading_failure:\'+e)}};o.onerror=function(){if(t.onerrorCb){return t.onerrorCb(e)}_vwo_code.finish(\'&e=loading_failure:\'+e)};o.send()}},getSettings:function(){try{var e=stT.getItem(cK);if(!e){return}e=JSON.parse(e);if(Date.now()>e.e){stT.removeItem(cK);return}return e.s}catch(e){return}},init:function(){if(d.URL.indexOf(\'__vwo_disable__\')>-1)return;var e=this.settings_tolerance();w._vwo_settings_timer=setTimeout(function(){_vwo_code.finish();stT.removeItem(cK)},e);var t;if(this.hide_element()!==\'body\'){t=d.createElement(\'style\');var n=this.hide_element(),i=n?n+this.hide_element_style():\'\',r=d.getElementsByTagName(\'head\')[0];t.setAttribute(\'id\',\'_vis_opt_path_hides\');v&&t.setAttribute(\'nonce\',v.nonce);t.setAttribute(\'type\',\'text/css\');if(t.styleSheet)t.styleSheet.cssText=i;else t.appendChild(d.createTextNode(i));r.appendChild(t)}else{t=d.getElementsByTagName(\'head\')[0];var i=d.createElement(\'div\');i.style.cssText=\'z-index: 2147483647 !important;position: fixed !important;left: 0 !important;top: 0 !important;width: 100% !important;height: 100% !important;background: white !important;display: block !important;\';i.setAttribute(\'id\',\'_vis_opt_path_hides\');i.classList.add(\'_vis_hide_layer\');t.parentNode.insertBefore(i,t.nextSibling)}var o=window._vis_opt_url||d.URL,s=\'https://dev.visualwebsiteoptimizer.com/j.php?a=\'+account_id+\'&u=\'+encodeURIComponent(o)+\'&vn=\'+version;if(w.location.search.indexOf(\'_vwo_xhr\')!==-1){this.addScript({src:s})}else{this.load(s+\'&x=true\')}}};w._vwo_code=code;code.init();})();\n      ';
      document.head.appendChild(script);

      var vwoOnVariationApplied = function vwoOnVariationApplied(data) {
        if (!data) return;
        var campaign = data[1],
            variation = data[2];

        _this2.$store.dispatch('appendExperimentTracking', { campaign: campaign, variation: variation });
      };

      window.VWO = window.VWO || [];
      window.VWO.push(['onVariationApplied', vwoOnVariationApplied]);
    }
  }
});

/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_errorHelper__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_widgets_PageHeader_PageHeader_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_widgets_PageHeader_PageHeader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_widgets_PageHeader_PageHeader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_widgets_Loading_Loading_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_widgets_Loading_Loading_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_widgets_Loading_Loading_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_PasswordInput_vue__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_PasswordInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_PasswordInput_vue__);








// @vue/component
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AcceptInvite',
  components: {
    PageHeader: __WEBPACK_IMPORTED_MODULE_4__components_widgets_PageHeader_PageHeader_vue___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_5__components_widgets_Loading_Loading_vue___default.a,
    PasswordInput: __WEBPACK_IMPORTED_MODULE_6__components_PasswordInput_vue___default.a
  },
  data: function data() {
    return {
      product: {
        name: 'Teamwork.com',
        code: '',
        url: '',
        helpDocsLink: 'https://www.teamwork.com/support'
      },

      user: {
        id: 0,
        userId: '',
        firstName: '',
        lastName: '',
        chatHandle: '',
        password: ''
      },

      expired: false,
      formError: '',
      isLoading: true,
      nameIsSetInProjects: false
    };
  },
  created: function created() {
    this.code = this.$route.query.code;
    this.product.code = this.$route.params.productCode ? this.$route.params.productCode : 'chat';
    this.getValidateInviteCode();
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])({
    siteInfo: function siteInfo(state) {
      return state.site.siteInfo;
    }
  }), {
    title: function title() {
      if (this.expired) return 'Invalid Code';
      if (!this.siteInfo.displayOptions.showSiteNameOnLoginScreen) {
        if (this.nameIsSetInProjects) return 'Welcome ' + this.user.firstName + '!';
        return 'Welcome!';
      } else if (!this.nameIsSetInProjects) return 'Hi, welcome to ' + this.siteInfo.name + '!';
      return 'Hi ' + this.user.firstName + ', welcome to ' + this.siteInfo.name + '!';
    },
    canSubmit: function canSubmit() {
      var isValid = this.user && this.user.firstName.length && this.user.lastName.length && this.user.password.length;

      if (this.isProductChat) {
        return isValid && this.user.chatHandle.length;
      }

      return isValid;
    },
    isProductChat: function isProductChat() {
      return this.product.code === 'chat';
    },
    isProductProjects: function isProductProjects() {
      return this.product.code === 'projects';
    },
    showNameInputs: function showNameInputs() {
      return !this.isProductProjects || !this.nameIsSetInProjects;
    },
    subTitle: function subTitle() {
      if (this.isProductProjects && !this.showNameInputs) {
        return 'Please choose a password to get started.';
      }
      return 'Fill out your details below to get started.';
    },
    loginLink: function loginLink() {
      var url = '/login';
      if (this.$route.params.productCode) url += '/' + this.$route.params.productCode;
      return url;
    }
  }),
  methods: {
    onSubmit: function onSubmit() {
      var _this = this;

      if (!this.canSubmit || this.isLoading) return;
      this.isLoading = true;

      var data = {
        firstName: this.user.firstName,
        lastName: this.user.lastName,
        password: this.user.password
      };

      var url = '/launchpad/v1/join.json?code=' + this.code;

      if (this.isProductChat) data.userHandle = this.user.chatHandle;else if (this.isProductProjects) {
        data.code = this.code;
        data.userId = this.user.userId;
        url = '/acceptinviteprojects.json';
      }

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(url, data).then(function (response) {
        if (_this.isProductProjects && response.data.error) {
          _this.formError = response.data.message;
          _this.isLoading = false;
        } else {
          window.location.href = response.data.redirectURL;
        }
      }).catch(function (e) {
        var apiError = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_errorHelper__["a" /* handleAPIError */])(_this.$store, e, 'An error has occurred');
        if (apiError && apiError.type === __WEBPACK_IMPORTED_MODULE_3__utils_errorHelper__["b" /* ERROR_TYPE */].FORM_ERROR && (apiError.err === 'User not invited' || apiError.err === 'User not found')) {
          _this.$store.commit('showFatalError', {
            error: 'Invalid Invite Code',
            message: 'The code may have expired, please request another invitation.'
          });
        } else if (apiError && apiError.type === __WEBPACK_IMPORTED_MODULE_3__utils_errorHelper__["b" /* ERROR_TYPE */].FORM_ERROR) {
          _this.formError = apiError.err;
        }
        _this.isLoading = false;
      });
    },
    getValidateInviteCode: function getValidateInviteCode() {
      var _this2 = this;

      var url = '/launchpad/v1/join.json?code=' + this.code;
      if (this.isProductProjects) {
        url = '/validateuserinvitecode.json?code=' + this.code;
      }

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(url).then(function (response) {
        if (response.data.error) {
          var err = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_errorHelper__["a" /* handleAPIError */])(_this2.$store, { response: response }, 'Invalid invite code.');
          if (err.type === __WEBPACK_IMPORTED_MODULE_3__utils_errorHelper__["b" /* ERROR_TYPE */].FORM_ERROR) {
            _this2.expired = true;
          } else {
            _this2.$store.commit('showFatalError', {
              error: response.data.error,
              message: response.data.message
            });
          }

          _this2.isLoading = false;
        }

        if (!_this2.isProductProjects) {
          // Save product info
          _this2.product.name = response.data.productName;
          _this2.product.code = response.data.productCode;
          _this2.product.url = response.data.productUrl;
          _this2.product.helpDocsLink = response.data.productHelpDocsLink;
        }

        // not yet accepted, show form to update details
        if (response.data.userId) {
          _this2.user.id = response.data.userId;
          _this2.user.firstName = response.data.userFirstName;
          _this2.user.lastName = response.data.userLastName;
          _this2.user.chatHandle = response.data.userChatHandle;

          // if invited without name, clear out placeholders
          if (_this2.user.firstName === 'Unknown') {
            _this2.user.firstName = '';
            _this2.user.chatHandle = '';
          }
          if (_this2.user.lastName === 'Unknown') {
            _this2.user.lastName = '';
            _this2.user.chatHandle = '';
          }
        } else if (response.data.userLogin) {
          _this2.nameIsSetInProjects = response.data.nameIsSet;
          _this2.user.userId = response.data.userLogin;
          if (_this2.nameIsSetInProjects) {
            _this2.user.firstName = response.data.firstName;
            _this2.user.lastName = response.data.lastName;
          }
        }

        _this2.isLoading = false;
      }).catch(function (e) {
        var err = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_errorHelper__["a" /* handleAPIError */])(_this2.$store, e, 'Invalid invite code.');
        // most likely, the invite code has expired, show fatal anyway
        if (err) {
          if (err.type === __WEBPACK_IMPORTED_MODULE_3__utils_errorHelper__["b" /* ERROR_TYPE */].FORM_ERROR) {
            _this2.expired = true;
          } else {
            _this2.$store.commit('showFatalError', {
              error: 'Invalid Invite Code',
              message: 'The code may have expired or has already been used, please request another invitation or try to log in.'
            });
          }
        }

        _this2.isLoading = false;
      });
    },
    reload: function reload() {
      window.location.reload();
    }
  }
});

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_uiHelper__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_widgets_PageHeader_PageHeader_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_widgets_PageHeader_PageHeader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_widgets_PageHeader_PageHeader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_widgets_Loading_Loading_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_widgets_Loading_Loading_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_widgets_Loading_Loading_vue__);








// @vue/component
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ForgotPassword',
  components: {
    PageHeader: __WEBPACK_IMPORTED_MODULE_5__components_widgets_PageHeader_PageHeader_vue___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_6__components_widgets_Loading_Loading_vue___default.a
  },
  data: function data() {
    return {
      email: '',

      passwordReset: false,
      isLoading: false,
      formError: ''
    };
  },
  created: function created() {
    if (this.$route.query.email) {
      this.email = this.$route.query.email;
      var query = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.$route.query);
      delete query.email;
      this.$router.replace({ query: query });
    }
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_uiHelper__["a" /* smartFocus */])();
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])({
    loginType: function loginType(state) {
      return state.login.loginType;
    }
  }), {
    canSubmit: function canSubmit() {
      return this.email.trim().length;
    },
    loginLink: function loginLink() {
      var url = '/login';
      if (this.$route.params.productCode) url += '/' + this.$route.params.productCode;
      return url;
    }
  }),
  methods: {
    onSubmit: function onSubmit() {
      var _this = this;

      if (!this.canSubmit || this.isLoading) return;
      this.isLoading = true;
      this.formError = '';

      var url = '/launchpad/v1/forgotpassword.json';
      if (this.loginType !== 'account') url += '?generic=true';

      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(url, { email: this.email.trim() }).then(function () {
        _this.passwordReset = true;
        _this.isLoading = false;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_uiHelper__["a" /* smartFocus */])();
      }).catch(function () {
        _this.formError = 'Failed to reset your password, please double-check your email address.';
        _this.isLoading = false;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_uiHelper__["a" /* smartFocus */])();
      });
    },
    reload: function reload() {
      window.location.reload();
    }
  }
});

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_widgets_PageHeader_PageHeader_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_widgets_PageHeader_PageHeader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_widgets_PageHeader_PageHeader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_sections_Login_StandardForm_StandardForm_vue__ = __webpack_require__(581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_sections_Login_StandardForm_StandardForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_sections_Login_StandardForm_StandardForm_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_sections_Login_SAMLStarter_SAMLStarter_vue__ = __webpack_require__(580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_sections_Login_SAMLStarter_SAMLStarter_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_sections_Login_SAMLStarter_SAMLStarter_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_sections_Login_SAMLForm_SAMLForm_vue__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_sections_Login_SAMLForm_SAMLForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_sections_Login_SAMLForm_SAMLForm_vue__);







// @vue/component
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Login',
  components: {
    PageHeader: __WEBPACK_IMPORTED_MODULE_2__components_widgets_PageHeader_PageHeader_vue___default.a,
    standard: __WEBPACK_IMPORTED_MODULE_3__components_sections_Login_StandardForm_StandardForm_vue___default.a,
    'saml-first': __WEBPACK_IMPORTED_MODULE_4__components_sections_Login_SAMLStarter_SAMLStarter_vue___default.a,
    'saml-email': __WEBPACK_IMPORTED_MODULE_5__components_sections_Login_SAMLForm_SAMLForm_vue___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    samlURL: 'samlURL',
    googleSSOURL: 'googleSSOURL'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])({
    loginType: function loginType(state) {
      return state.login.loginType;
    },
    loginState: function loginState(state) {
      return state.login.loginState;
    }
  }))
});

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_urlHelper__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_widgets_PageHeader_PageHeader_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_widgets_PageHeader_PageHeader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_widgets_PageHeader_PageHeader_vue__);





// @vue/component
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Logout',
  components: {
    PageHeader: __WEBPACK_IMPORTED_MODULE_3__components_widgets_PageHeader_PageHeader_vue___default.a
  },
  data: function data() {
    return {
      logoutMessage: 'You are now signed out. Have a great day!'
    };
  },
  created: function created() {
    if (this.$route.query.message) this.logoutMessage = this.$route.query.message;
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])({
    loggedIn: function loggedIn(state) {
      return state.login.loggedIn;
    },
    loginType: function loginType(state) {
      return state.login.loginType;
    },
    appInfo: function appInfo(state) {
      return state.login.appInfo;
    },
    siteInfo: function siteInfo(state) {
      return state.site.siteInfo;
    },
    afterLoginURL: function afterLoginURL(state) {
      return state.login.afterLoginURL;
    },
    // eslint-disable-next-line
    title: function title(state) {
      return state.site.siteInfo.displayOptions.showSiteNameOnLoginScreen ? state.site.siteInfo.name : 'Log in';
    },
    inAppLogin: function inAppLogin(state) {
      return state.login.loginType === 'app';
    }
  }), {
    logoutMessageHTML: function logoutMessageHTML() {
      return this.logoutMessage.replace(/>/g, '&gt;').replace(/</g, '&lt;').replace(/\\n/g, '<br>');
    }
  }),
  methods: {
    onSubmitLogin: function onSubmitLogin() {
      var route = '/login';
      var query = {};

      if (this.$route.params.productCode) route += '/' + this.$route.params.productCode;

      if (this.inAppLogin) {
        query.generic = true;
        query.redirect_uri = this.appInfo.redirect_uri;
        if (this.appInfo.state) query.state = this.appInfo.state;
        if (this.appInfo.client_id) query.client_id = this.appInfo.client_id;
        if (this.appInfo.scope) query.scope = this.appInfo.scope;
      }

      route += '?' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_urlHelper__["a" /* buildQueryString */])(query);

      if (this.siteInfo.sso.enabled && this.siteInfo.sso.loginStyle === 'SSO automatic-start') {
        window.location.href = '/launchpad/saml/start?SAMLAfterLoginURL=' + encodeURIComponent(this.afterLoginURL);
        return;
      }

      this.$router.push(route);
    }
  },
  watch: {
    loggedIn: function loggedIn(_loggedIn) {
      if (this.loginType === 'account' && _loggedIn) this.onSubmitLogin();
    }
  }
});

/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_widgets_PageHeader_PageHeader_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_widgets_PageHeader_PageHeader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_widgets_PageHeader_PageHeader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_widgets_Loading_Loading_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_widgets_Loading_Loading_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_widgets_Loading_Loading_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_PasswordInput_vue__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_PasswordInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_PasswordInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_errorHelper__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_uiHelper__ = __webpack_require__(31);











// @vue/component
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ForgotPassword',
  components: {
    PageHeader: __WEBPACK_IMPORTED_MODULE_3__components_widgets_PageHeader_PageHeader_vue___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_4__components_widgets_Loading_Loading_vue___default.a,
    PasswordInput: __WEBPACK_IMPORTED_MODULE_5__components_PasswordInput_vue___default.a
  },
  data: function data() {
    return {
      userId: 0,
      token: '',

      password: '',

      state: 'normal',
      formError: '',
      isLoading: false
    };
  },
  created: function created() {
    this.userId = this.$route.params.userId;
    this.token = this.$route.params.token;

    this.validateResetToken();
  },
  mounted: function mounted() {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_uiHelper__["a" /* smartFocus */])();
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])({
    apps: function apps(state) {
      return state.site.siteInfo.apps;
    },
    siteURL: function siteURL(state) {
      return state.site.siteInfo.url;
    }
  }), {
    canSubmit: function canSubmit() {
      return this.password.length;
    },
    title: function title() {
      if (this.state === 'success') return 'Password updated';
      return 'Reset password';
    },
    subTitle: function subTitle() {
      if (this.state === 'success' && this.user) {
        return this.user.FirstName + ', your password has been changed.';
      }
      return 'Please enter the desired password for your account below.';
    }
  }),
  watch: {
    isLoading: function isLoading() {
      window.parent.postMessage('pageResized', '*');
    }
  },
  methods: {
    validateResetToken: function validateResetToken() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/launchpad/v1/validatereset/' + this.userId + '/' + this.token).then(function (response) {
        _this.user = response.data.user;
        _this.isLoading = false;
      }).catch(function () {
        _this.$store.commit('showFatalError', {
          error: 'Token Expired',
          // eslint-disable-next-line
          explanation: 'Sorry we couldn\'t authorise this request. It\'s most likely that the link has expired.',
          appError: 'access_denied',
          appErrorExplanation: 'reset token has expired'
        });
        _this.isLoading = false;
      });
    },
    onSubmitReset: function onSubmitReset() {
      var _this2 = this;

      if (this.isLoading || !this.canSubmit) return false;
      this.isLoading = true;
      this.formError = '';
      return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('/launchpad/resetpassword/' + this.userId + '/' + this.token, 'password=' + encodeURIComponent(this.password)).then(function () {
        _this2.state = 'success';
        _this2.isLoading = false;
      }).catch(function (e) {
        var err = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_errorHelper__["a" /* handleAPIError */])(_this2.$store, e, 'unknown error');
        console.log(err, err.type, err.err);
        if (err && err.type === __WEBPACK_IMPORTED_MODULE_6__utils_errorHelper__["b" /* ERROR_TYPE */].FORM_ERROR && err.err !== 'unknown error') {
          _this2.formError = err.err;
        } else {
          _this2.$store.commit('showFatalError', {
            error: 'Token Expired',
            // eslint-disable-next-line
            explanation: 'Sorry we couldn\'t authorise this request. It\'s most likely that the link has expired.',
            appError: 'access_denied',
            appErrorExplanation: 'reset token has expired'
          });
        }
        _this2.isLoading = false;
      });
    },
    reload: function reload() {
      window.location.reload();
    }
  }
});

/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_appLoginHelper__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_errorHelper__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_uiHelper__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_widgets_PageHeader_PageHeader_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_widgets_PageHeader_PageHeader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_widgets_PageHeader_PageHeader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_sections_AppConsent_AppConsent_vue__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_sections_AppConsent_AppConsent_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_sections_AppConsent_AppConsent_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_sections_GDPRConsent_GDPRConsent_vue__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_sections_GDPRConsent_GDPRConsent_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_sections_GDPRConsent_GDPRConsent_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_sections_Login_CompanyInfo_vue__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_sections_Login_CompanyInfo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_sections_Login_CompanyInfo_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_widgets_Loading_Loading_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_widgets_Loading_Loading_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_widgets_Loading_Loading_vue__);














// @vue/component
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Login',
  components: {
    PageHeader: __WEBPACK_IMPORTED_MODULE_6__components_widgets_PageHeader_PageHeader_vue___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_10__components_widgets_Loading_Loading_vue___default.a,
    AppConsent: __WEBPACK_IMPORTED_MODULE_7__components_sections_AppConsent_AppConsent_vue___default.a,
    'gdpr-consent': __WEBPACK_IMPORTED_MODULE_8__components_sections_GDPRConsent_GDPRConsent_vue___default.a,
    CompanyInfo: __WEBPACK_IMPORTED_MODULE_9__components_sections_Login_CompanyInfo_vue___default.a
  },
  data: function data() {
    return {
      code: '',
      app: {},
      gdprSeen: false,
      companyInfo: undefined,

      state: 'normal',
      isLoading: true
    };
  },
  created: function created() {
    if (!this.$route.query.samlauth || !this.$route.query.iv) {
      this.$store.commit('showFatalError', {
        error: 'Login Failed',
        message: 'Invalid parameters',
        explanation: 'Missing required parameters. Please try again.',

        appError: 'server_error',
        appErrorExplanation: 'saml authentication failed, invalid parameters'
      });
      return;
    }
    this.postSAMLAuth();
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])({
    afterLoginURL: function afterLoginURL(state) {
      var baseURL = '';
      if (state.login.loginType === 'account') {
        baseURL = window.location.href.replace(/(\/launchpad\/saml\/auth)\/?/, '/');
      }
      return state.login.afterLoginURL || baseURL;
    },
    // eslint-disable-next-line
    title: function title(state) {
      return state.site.siteInfo.displayOptions.showSiteNameOnLoginScreen ? state.site.siteInfo.name : 'Log in';
    },
    loginType: function loginType(state) {
      return state.login.loginType;
    },
    loginState: function loginState(state) {
      return state.login.loginState;
    },
    appInfo: function appInfo(state) {
      return state.login.appInfo;
    },
    inAppLogin: function inAppLogin(state) {
      return state.login.loginType === 'app';
    }
  })),
  methods: {
    postSAMLAuth: function postSAMLAuth() {
      var _this = this;

      var sa = this.$route.query.samlauth;
      var iv = this.$route.query.iv;
      var data = {
        samlauth: sa.replace(/ /g, '+'),
        iv: iv.replace(/ /g, '+'),
        SAMLAfterLoginURL: this.$route.query.SAMLAfterLoginURL
      };

      var url = '/launchpad/v1/saml/auth.json';
      var appAuth = !!this.$route.query.appAuth;
      if (appAuth) {
        url += '?appAuth=true';
        data.redirect_uri = this.appInfo.redirect_uri;
        data.state = this.appInfo.state;
        data.client_id = this.appInfo.client_id;
        data.scope = this.appInfo.scope;
        data.install = this.appInfo.install;
        if (this.appInfo.nonce) data.nonce = this.appInfo.nonce;
      }

      if (this.gdprSeen) data.gdprSeen = true;

      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(url, data).then(function (response) {
        if (response.data.setupScreenRequired) {
          var _response$data = response.data,
              industryCategoryId = _response$data.industryCategoryId,
              companySizeId = _response$data.companySizeId;


          _this.companyInfo = {
            industryCategoryId: industryCategoryId || undefined,
            sizeId: companySizeId || undefined
          };

          _this.state = 'company-info';
          _this.isLoading = false;

          return;
        }

        if (!response.data.gdprSeen) {
          _this.state = 'gdpr-consent';
          _this.gdprSeen = true;
          _this.isLoading = false;
          return;
        }

        _this.code = response.data.code;

        if (_this.inAppLogin) {
          _this.app = response.data.app;

          if (_this.app.consentRequired === false) {
            // allow skipping screen for our own apps
            __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('/launchpad/v1/token/consent.json', { code: _this.code }).then(function (res) {
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_appLoginHelper__["c" /* redirectToApp */])(_this.appInfo, res.data.code);
            }).catch(function () {
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_appLoginHelper__["a" /* redirectToAppWithError */])(_this.appInfo, 'failed_to_consent', 'impossible to consent');
            });
          } else {
            _this.state = 'app-consent';
          }

          _this.isLoading = false;
          return;
        }

        _this.$store.commit('setLoggedIn', {
          loggedIn: true,
          userId: response.data.userId
        });

        if (window.opener && _this.$store.state.login.meta.hasLocalStorage && sessionStorage.getItem('shouldCloseOpener') === 'true') {
          sessionStorage.setItem('shouldCloseOpener', 'false');
          window.close();
        }

        var location = response.data.redirectURL || _this.afterLoginURL;
        window.location.href = location;
      }).catch(function (e) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_errorHelper__["a" /* handleAPIError */])(_this.$store, e, 'Sorry, something went wrong and we could not log you in.');
        _this.isLoading = false;

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_uiHelper__["a" /* smartFocus */])();
      });
    },
    reload: function reload() {
      window.location.reload();
    }
  }
});

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_widgets_PageHeader_PageHeader_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_widgets_PageHeader_PageHeader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_widgets_PageHeader_PageHeader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_widgets_Loading_Loading_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_widgets_Loading_Loading_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_widgets_Loading_Loading_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_widgets_AccountList_AccountList_vue__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_widgets_AccountList_AccountList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_widgets_AccountList_AccountList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_uiHelper__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_urlHelper__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_appLoginHelper__ = __webpack_require__(43);










// @vue/component
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SelectAccount',
  components: {
    PageHeader: __WEBPACK_IMPORTED_MODULE_3__components_widgets_PageHeader_PageHeader_vue___default.a,
    AccountList: __WEBPACK_IMPORTED_MODULE_5__components_widgets_AccountList_AccountList_vue___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_4__components_widgets_Loading_Loading_vue___default.a
  },
  data: function data() {
    return {
      accounts: [],
      gad: '',

      isLoading: false
    };
  },
  created: function created() {
    this.gad = this.$route.query.gad;

    if (!this.gad) {
      this.$store.commit('showFatalError', {
        error: 'Login Failed',
        explanation: 'Invalid parameters, Google token is missing.',
        appError: 'access_denied',
        appErrorExplanation: 'google sso failed, gad token missing'
      });
      return;
    }

    this.getGoogleAccounts();
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])({
    appInfo: function appInfo(state) {
      return state.login.appInfo;
    },
    loginType: function loginType(state) {
      return state.login.loginType;
    },
    meta: function meta(state) {
      return state.login.meta;
    },
    afterLoginURL: function afterLoginURL(state) {
      return state.login.afterLoginURL;
    },
    // eslint-disable-next-line
    title: function title(state) {
      return state.site.siteInfo.displayOptions.showSiteNameOnLoginScreen ? state.site.siteInfo.name : 'Log in';
    },
    inAppLogin: function inAppLogin(state) {
      return state.login.loginType === 'app';
    }
  }), {
    canSubmit: function canSubmit() {
      return this.email.length && this.password.length;
    }
  }),
  methods: {
    getGoogleAccounts: function getGoogleAccounts() {
      var _this = this;

      this.isLoading = true;

      var data = {
        gad: this.gad
      };

      // For app login flow, we want to allow apps to hide some accounts,
      // for example if they are already authenticated.
      if (this.inAppLogin && this.meta.ignoreInstallations) {
        data.ignoreInstallations = this.meta.ignoreInstallations;
      }

      if (this.appInfo.redirect_uri) data.redirect_uri = this.appInfo.redirect_uri;
      if (this.appInfo.client_id) data.client_id = this.appInfo.client_id;
      if (this.appInfo.scope) data.scope = this.appInfo.scope;
      if (this.appInfo.install) data.install = this.appInfo.install;
      if (this.appInfo.nonce) data.nonce = this.appInfo.nonce;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('/launchpad/v1/googleSSO/accounts.json', data).then(function (response) {
        // filter out accounts where provided product is disabled
        // note: we will do this on the backend after global data
        // for all products
        var accs = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_appLoginHelper__["b" /* filterAccounts */])(response.data.accounts, _this.meta.product);

        // If no accounts found, we redirect user to signup,
        // unless they're in app login flow
        if (accs.length === 0) {
          if (_this.inAppLogin) {
            _this.$store.commit('showFatalError', {
              error: 'Login Failed',
              // eslint-disable-next-line
              explanation: 'We did not find any Teamwork accounts associated with this Google account.',
              appError: 'access_denied',
              appErrorExplanation: 'google sso failed, no teamwork accounts found'
            });
          } else {
            window.location.href = 'https://www.teamwork.com/signup?from=launchpad_google';
          }
          return;
        }

        // If we only have one account, skip selection step
        if (accs.length === 1) {
          return _this.onAccountSelected(accs[0]); // eslint-disable-line
        }

        _this.accounts = accs;
        _this.isLoading = false;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_uiHelper__["a" /* smartFocus */])();
      }).catch(function () {
        _this.$store.commit('showFatalError', {
          error: 'Login Failed',
          explanation: 'Failed to load your Teamwork accounts, please try again.',
          appError: 'access_denied',
          appErrorExplanation: 'google sso failed, failed to load teamwork accounts'
        });
        _this.isLoading = false;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_uiHelper__["a" /* smartFocus */])();
      });
    },
    onAccountSelected: function onAccountSelected(account) {
      this.isLoading = true;
      var url = account.installation.url + 'launchpad/tokenauth';
      var params = {
        code: account.token
      };

      if (this.afterLoginURL) params.continue = this.afterLoginURL;
      if (this.appInfo.redirect_uri) params.redirect_uri = this.appInfo.redirect_uri;
      if (this.appInfo.state) params.state = this.appInfo.state;
      if (this.appInfo.client_id) params.client_id = this.appInfo.client_id;
      if (this.appInfo.scope) params.scope = this.appInfo.scope;
      if (this.appInfo.install) params.install = this.appInfo.install;
      if (this.appInfo.nonce) params.nonce = this.appInfo.nonce;

      if (this.meta.source) params.source = this.meta.source;
      if (this.meta.product) params.product = this.meta.product;
      if (this.meta.extra) params.extra = this.meta.extra;

      window.location.href = url + '?' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_urlHelper__["a" /* buildQueryString */])(params);
    },
    reload: function reload() {
      window.location.reload();
    },
    filterAccounts: function filterAccounts(accounts) {
      var key = '';
      switch (this.meta.product) {
        case 'projects':
          key = 'projectsEnabled';
          break;
        case 'desk':
          key = 'deskEnabled';
          break;
        case 'chat':
          key = 'chatEnabled';
          break;
        default:
          return accounts;
      }
      return accounts.filter(function (acc) {
        return acc.installation[key];
      });
    }
  }
});

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_widgets_PageHeader_PageHeader_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_widgets_PageHeader_PageHeader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_widgets_PageHeader_PageHeader_vue__);




// @vue/component
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Success',
  components: {
    PageHeader: __WEBPACK_IMPORTED_MODULE_2__components_widgets_PageHeader_PageHeader_vue___default.a
  },
  data: function data() {
    return {
      code: ''
    };
  },
  created: function created() {
    this.code = this.$route.query.code;
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])({
    // eslint-disable-next-line
    title: function title(state) {
      return state.site.siteInfo.displayOptions.showSiteNameOnLoginScreen ? state.site.siteInfo.name : 'Log in';
    }
  }))
});

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_appLoginHelper__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_errorHelper__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_uiHelper__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_urlHelper__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_widgets_PageHeader_PageHeader_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_widgets_PageHeader_PageHeader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_widgets_PageHeader_PageHeader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_sections_AppConsent_AppConsent_vue__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_sections_AppConsent_AppConsent_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_sections_AppConsent_AppConsent_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_sections_GDPRConsent_GDPRConsent_vue__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_sections_GDPRConsent_GDPRConsent_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_sections_GDPRConsent_GDPRConsent_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_sections_Login_CompanyInfo_vue__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_sections_Login_CompanyInfo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_sections_Login_CompanyInfo_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_widgets_Loading_Loading_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_widgets_Loading_Loading_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_widgets_Loading_Loading_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_sections_PersonaCapture_PersonaCapture_vue__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_sections_PersonaCapture_PersonaCapture_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_sections_PersonaCapture_PersonaCapture_vue__);







// @vue/component












/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TokenAuth',
  components: {
    PageHeader: __WEBPACK_IMPORTED_MODULE_10__components_widgets_PageHeader_PageHeader_vue___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_14__components_widgets_Loading_Loading_vue___default.a,
    AppConsent: __WEBPACK_IMPORTED_MODULE_11__components_sections_AppConsent_AppConsent_vue___default.a,
    'gdpr-consent': __WEBPACK_IMPORTED_MODULE_12__components_sections_GDPRConsent_GDPRConsent_vue___default.a,
    CompanyInfo: __WEBPACK_IMPORTED_MODULE_13__components_sections_Login_CompanyInfo_vue___default.a,
    PersonaCapture: __WEBPACK_IMPORTED_MODULE_15__components_sections_PersonaCapture_PersonaCapture_vue___default.a
  },
  data: function data() {
    return {
      code: '',
      app: {},
      gdprSeen: false,
      companyInfo: undefined,
      onCompanyInfoSaved: undefined,
      onPersonaInfoSaved: undefined,

      state: 'normal',
      isLoading: true
    };
  },
  created: function created() {
    this.code = this.$route.query.code;

    if (this.inAppLogin) {
      this.getAppInfo();
    } else {
      // token login
      this.loginViaToken();
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])({
    afterLoginURL: function afterLoginURL(state) {
      var baseURL = '';
      if (state.login.loginType === 'account') {
        baseURL = window.location.href.replace(/(\/launchpad\/tokenauth)\/?/, '/');
      }
      return state.login.afterLoginURL || baseURL;
    },
    // eslint-disable-next-line
    title: function title(state) {
      return state.site.siteInfo.displayOptions.showSiteNameOnLoginScreen ? state.site.siteInfo.name : 'Log in';
    },
    loginType: function loginType(state) {
      return state.login.loginType;
    },
    loginState: function loginState(state) {
      return state.login.loginState;
    },
    appInfo: function appInfo(state) {
      return state.login.appInfo;
    },
    inAppLogin: function inAppLogin(state) {
      return state.login.loginType === 'app';
    }
  })),
  methods: {
    getAppInfo: function getAppInfo() {
      var _this = this;

      this.isLoading = true;
      var payload = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, this.appInfo, {
        code: this.code
      });

      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post('/launchpad/v1/apps/validate.json', payload).then(function (response) {
        _this.app = response.data.app;

        if (_this.app.consentRequired === false) {
          // allow skipping screen for our own apps
          __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post('/launchpad/v1/token/consent.json', { code: _this.code }).then(function (res) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_appLoginHelper__["c" /* redirectToApp */])(_this.appInfo, res.data.code);
          }).catch(function () {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_appLoginHelper__["a" /* redirectToAppWithError */])(_this.appInfo, 'failed_to_consent', 'impossible to consent');
          });
        } else {
          _this.state = 'app-consent';
        }

        _this.isLoading = false;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_uiHelper__["a" /* smartFocus */])();
      }).catch(function (e) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_errorHelper__["a" /* handleAPIError */])(_this.$store, e, 'Failed to log in.');
        _this.isLoading = false;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_uiHelper__["a" /* smartFocus */])();
      });
    },
    loginViaToken: function loginViaToken() {
      var _this2 = this;

      this.isLoading = true;

      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post('/launchpad/v1/token/consent.json', { code: this.code }).then(function (response) {
        var data = {
          code: response.data.code,
          rememberMe: !!_this2.$route.query.rememberMe
        };
        if (_this2.gdprSeen) data.gdprSeen = true;

        return __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post('/launchpad/v1/token/login.json', data).then(function () {
          var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(res) {
            var _res$data, industryCategoryId, companySizeId, companyInfoSavedPromise, personaInfoSavedPromise;

            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    if (res.data.gdprSeen) {
                      _context.next = 5;
                      break;
                    }

                    _this2.state = 'gdpr-consent';
                    _this2.gdprSeen = true;
                    _this2.isLoading = false;
                    return _context.abrupt('return');

                  case 5:
                    if (!res.data.setupScreenRequired) {
                      _context.next = 15;
                      break;
                    }

                    _res$data = res.data, industryCategoryId = _res$data.industryCategoryId, companySizeId = _res$data.companySizeId;


                    _this2.companyInfo = {
                      industryCategoryId: industryCategoryId || undefined,
                      sizeId: companySizeId || undefined
                    };

                    companyInfoSavedPromise = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
                      _this2.onCompanyInfoSaved = resolve;
                    });


                    _this2.state = 'company-info';
                    _this2.isLoading = false;

                    _context.next = 13;
                    return companyInfoSavedPromise;

                  case 13:

                    _this2.isLoading = true;
                    _this2.state = 'normal';

                  case 15:
                    if (!(res.data.userPersona !== undefined && !res.data.userPersona)) {
                      _context.next = 24;
                      break;
                    }

                    personaInfoSavedPromise = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
                      _this2.onPersonaInfoSaved = resolve;
                    });

                    _this2.state = 'persona-capture';
                    _this2.$store.commit('setFormState', _this2.state);
                    _this2.isLoading = false;

                    _context.next = 22;
                    return personaInfoSavedPromise;

                  case 22:

                    _this2.isLoading = true;
                    _this2.state = 'normal';

                  case 24:

                    _this2.$store.commit('setLoggedIn', {
                      loggedIn: true,
                      userId: res.data.userId
                    });

                    if (window.opener && _this2.$store.state.login.meta.hasLocalStorage && sessionStorage.getItem('shouldCloseOpener') === 'true') {
                      sessionStorage.setItem('shouldCloseOpener', 'false');
                      window.close();
                    }

                    // eslint-disable-next-line
                    window.location.href = _this2.afterLoginURL || window.location.href.replace(/(\/launchpad\/tokenauth)\/?/, '/');

                  case 27:
                  case 'end':
                    return _context.stop();
                }
              }
            }, _callee, _this2);
          }));

          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }());
      }).catch(function (e) {
        var err = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_errorHelper__["a" /* handleAPIError */])(_this2.$store, e, 'Failed to log in.');

        if (err && err.type === __WEBPACK_IMPORTED_MODULE_7__utils_errorHelper__["b" /* ERROR_TYPE */].INSTALLATION_PROVISIONING) {
          _this2.$store.commit('showFatalError', {
            error: 'Please Wait',
            message: 'Your account is being set up, we\'re just wrapping up a few bits...',
            explanation: 'This should only take a moment. ' + 'Once everything is set up, you will be logged in automatically. ' + 'If the installation is not active after 5 minutes, please contact support.'
          });

          // This would call 'loginViaToken' in 'created' because component appears again
          setTimeout(function () {
            return _this2.$store.commit('resetFatalError');
          }, 3000);

          return;
        }

        if (err && err.type === __WEBPACK_IMPORTED_MODULE_7__utils_errorHelper__["b" /* ERROR_TYPE */].INSTALLATION_VALIDATION_PENDING) {
          var isVerifyEmail = _this2.$route.query.continue && _this2.$route.query.continue.includes('verifyemail');

          if (isVerifyEmail) {
            window.location.href = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_urlHelper__["c" /* fixProtocol */])(_this2.$route.query.continue + '?auth=' + e.response.data.unvalidatedAccountLoginCode + '&email=' + encodeURIComponent(_this2.email));
          } else {
            window.location.href = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_urlHelper__["c" /* fixProtocol */])('/launchpad/verifyemail/' + (_this2.$route.params.productCode ? _this2.$route.params.productCode : 'projects') + '/firstsend?auth=' + e.response.data.unvalidatedAccountLoginCode + '&email=' + encodeURIComponent(_this2.email));
          }
        }

        // most likely, the token has expired, show fatal anyway
        if (err && err.type === __WEBPACK_IMPORTED_MODULE_7__utils_errorHelper__["b" /* ERROR_TYPE */].FORM_ERROR) {
          _this2.$store.commit('showFatalError', {
            error: 'Login Failed',
            message: 'Login token has expired, please try again.',
            appError: 'access_denied',
            appErrorExplanation: 'google sso access token expired'
          });
        }

        _this2.isLoading = false;
      });
    },
    reload: function reload() {
      window.location.reload();
    }
  }
});

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_widgets_PageHeader_PageHeader_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_widgets_PageHeader_PageHeader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_widgets_PageHeader_PageHeader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_widgets_Loading_Loading_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_widgets_Loading_Loading_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_widgets_Loading_Loading_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_widgets_ProductList_vue__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_widgets_ProductList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_widgets_ProductList_vue__);







// @vue/component
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Welcome',
  components: {
    PageHeader: __WEBPACK_IMPORTED_MODULE_2__components_widgets_PageHeader_PageHeader_vue___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_3__components_widgets_Loading_Loading_vue___default.a,
    ProductList: __WEBPACK_IMPORTED_MODULE_4__components_widgets_ProductList_vue___default.a
  },
  data: function data() {
    return {
      utm_content: ''
    };
  },
  mounted: function mounted() {
    var _this = this;

    if (this.$route.query.utm_content) this.utm_content = this.$route.query.utm_content;
    this.$nextTick(function () {
      if (_this.products.length === 1) {
        window.location.href = (_this.loggedIn ? '/' : '/launchpad/login/') + _this.products[0].code;
      }
    });
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])({
    loggedIn: function loggedIn(state) {
      return state.login.loggedIn;
    },
    siteInfo: function siteInfo(state) {
      return state.site.siteInfo;
    },
    productInfo: function productInfo(state) {
      return state.site.productInfo;
    }
  }), {
    title: function title() {
      if (this.siteInfo.displayOptions.showSiteNameOnLoginScreen) {
        return 'Welcome to ' + this.siteInfo.name;
      }
      return 'Welcome';
    },
    subtitle: function subtitle() {
      return 'Select the app you want to start with.<br>Use them together for greater team productivity.';
    },
    products: function products() {
      var _this2 = this;

      return this.productInfo.filter(function (v) {
        return _this2.siteInfo.apps[v.code];
      }).map(function (v) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, v, {

          url: (_this2.loggedIn ? '/' : '/launchpad/login/') + (v.code === 'projects' ? 'app' : v.code) + (_this2.utm_content ? '/?utm_content=' + _this2.utm_content : '')
        });
      });
    }
  })
});

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_appLoginHelper__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_widgets_PageHeader_PageHeader_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_widgets_PageHeader_PageHeader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_widgets_PageHeader_PageHeader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_images_product_icon_projects_svg__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_images_product_icon_projects_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_images_product_icon_projects_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_images_product_icon_chat_svg__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_images_product_icon_chat_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_images_product_icon_chat_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_images_product_icon_desk_svg__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_images_product_icon_desk_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_images_product_icon_desk_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_product_icon_crm_svg__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_product_icon_crm_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_images_product_icon_crm_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_product_icon_spaces_svg__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_images_product_icon_spaces_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_images_product_icon_spaces_svg__);












var icons = {
  projects: __WEBPACK_IMPORTED_MODULE_5__assets_images_product_icon_projects_svg___default.a,
  chat: __WEBPACK_IMPORTED_MODULE_6__assets_images_product_icon_chat_svg___default.a,
  desk: __WEBPACK_IMPORTED_MODULE_7__assets_images_product_icon_desk_svg___default.a,
  crm: __WEBPACK_IMPORTED_MODULE_8__assets_images_product_icon_crm_svg___default.a,
  spaces: __WEBPACK_IMPORTED_MODULE_9__assets_images_product_icon_spaces_svg___default.a
};

// @vue/component
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AppConsent',
  components: {
    PageHeader: __WEBPACK_IMPORTED_MODULE_4__components_widgets_PageHeader_PageHeader_vue___default.a
  },
  props: {
    code: {
      type: String,
      required: true
    },
    app: {
      type: Object,
      default: function _default() {
        return {
          id: 0,
          ownerId: 0,
          code: '',
          clientId: '',
          scope: [],
          name: '',
          logo: '',
          url: '',
          dateCreated: null,
          dateUpdated: null,
          isValidated: true,
          description: '',
          publisher: { // could be null
            name: '',
            url: '',
            privacyUrl: '',
            termsUrl: '',
            logoUrl: ''
          }
        };
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])({
    appInfo: function appInfo(state) {
      return state.login.appInfo;
    },
    selectedAccount: function selectedAccount(state) {
      return state.login.selectedAccount;
    }
  }), {
    requestedScope: function requestedScope() {
      if (this.appInfo.scope.length) {
        // openid is a scope, but not an app scope, so we filter it out if it's in the list
        return this.appInfo.scope.filter(function (scope) {
          return scope.toLowerCase() !== 'openid';
        });
      }
      // default to full app scope if none requested
      if (this.app.scope.length) {
        return this.app.scope;
      }
      return [];
    },
    showAppDetails: function showAppDetails() {
      return this.app.clientId; // we know it's a devportal app with a name
    },
    appIsLocal: function appIsLocal() {
      return this.app.name !== 'localhost' && this.app.name !== '127.0.0.1';
    },
    logoUrl: function logoUrl() {
      if (this.app.logo) return this.app.logo;
      if (this.app.publisher && this.app.publisher.logoUrl) return this.app.publisher.logoUrl;
      return '';
    }
  }),
  methods: {
    onAllow: function onAllow() {
      var _this = this;

      var url = (this.selectedAccount.installation.apiEndPoint || '/') + 'launchpad/v1/token/consent.json';
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(url, { code: this.code }).then(function (response) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_appLoginHelper__["c" /* redirectToApp */])(_this.appInfo, response.data.code);
      }).catch(function () {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_appLoginHelper__["a" /* redirectToAppWithError */])(_this.appInfo, 'failed_to_consent', 'impossible to consent');
      });
    },
    onDeny: function onDeny() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_appLoginHelper__["a" /* redirectToAppWithError */])(this.appInfo, 'access_denied', 'user did not consent');
    },
    getAppName: function getAppName(productCode) {
      switch (productCode) {// eslint-disable-line
        case 'projects':
          return 'Teamwork';
        case 'desk':
          return 'Teamwork Desk';
        case 'chat':
          return 'Teamwork Chat';
        case 'crm':
          return 'Teamwork CRM';
        case 'spaces':
          return 'Teamwork Spaces';
      }
      return productCode;
    },
    getAppIcon: function getAppIcon(code) {
      if (!icons[code]) return '';
      return icons[code];
    }
  }
});

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_widgets_PageHeader_PageHeader_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_widgets_PageHeader_PageHeader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_widgets_PageHeader_PageHeader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_appLoginHelper__ = __webpack_require__(43);





// @vue/component
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ErrorMessage',
  components: {
    PageHeader: __WEBPACK_IMPORTED_MODULE_2__components_widgets_PageHeader_PageHeader_vue___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])({
    error: function error(state) {
      return state.login.fatalError.error;
    },
    message: function message(state) {
      return state.login.fatalError.message;
    },
    explanation: function explanation(state) {
      return state.login.fatalError.explanation;
    },

    inAppLogin: function inAppLogin(state) {
      return state.login.loginType === 'app';
    },
    appInfo: function appInfo(state) {
      return state.login.appInfo;
    },
    appError: function appError(state) {
      return state.login.fatalError.appError;
    },
    appErrorExplanation: function appErrorExplanation(state) {
      return state.login.fatalError.appErrorExplanation;
    }
  }), {
    explanationHTML: function explanationHTML() {
      return this.explanation.replace(/>/g, '&gt;').replace(/</g, '&lt;').replace(/\\n/g, '<br>');
    }
  }),
  methods: {
    onClickBackToApp: function onClickBackToApp() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_appLoginHelper__["a" /* redirectToAppWithError */])(this.appInfo, this.appError, this.appErrorExplanation);
    }
  }
});

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_widgets_PageHeader_PageHeader_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_widgets_PageHeader_PageHeader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_widgets_PageHeader_PageHeader_vue__);


// @vue/component
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'GDPRConsent',
  components: {
    PageHeader: __WEBPACK_IMPORTED_MODULE_0__components_widgets_PageHeader_PageHeader_vue___default.a
  }
});

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_errorHelper__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_uiHelper__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_widgets_PageHeader_PageHeader_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_widgets_PageHeader_PageHeader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_widgets_PageHeader_PageHeader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_widgets_Loading_Loading_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_widgets_Loading_Loading_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_widgets_Loading_Loading_vue__);









// @vue/component
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SAMLForm',
  components: {
    PageHeader: __WEBPACK_IMPORTED_MODULE_6__components_widgets_PageHeader_PageHeader_vue___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_7__components_widgets_Loading_Loading_vue___default.a
  },
  data: function data() {
    return {
      email: '',

      formError: '',
      isLoading: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])({
    samlURL: 'samlURL'
  }), {
    canSubmit: function canSubmit() {
      return this.email.length > 0;
    }
  }),
  methods: {
    onSubmit: function onSubmit() {
      var _this = this;

      if (!this.canSubmit) return;

      this.formError = '';
      this.isLoading = true;

      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/launchpad/saml/account.json?userEmail=' + this.email).then(function (response) {
        _this.$store.commit('setSAMLBaseURL', response.data.baseHref);
        __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].nextTick(function () {
          window.location.href = _this.samlURL;
        });
      }).catch(function (e) {
        var err = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_errorHelper__["a" /* handleAPIError */])(_this.$store, e, 'No associated accounts found, please double-check your email address.');
        if (err && err.type === __WEBPACK_IMPORTED_MODULE_4__utils_errorHelper__["b" /* ERROR_TYPE */].FORM_ERROR) _this.formError = err.err;
        _this.isLoading = false;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_uiHelper__["a" /* smartFocus */])();
      });
    },
    reload: function reload() {
      window.location.reload();
    }
  }
});

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_urlHelper__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_widgets_PageHeader_PageHeader_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_widgets_PageHeader_PageHeader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_widgets_PageHeader_PageHeader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_widgets_Loading_Loading_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_widgets_Loading_Loading_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_widgets_Loading_Loading_vue__);






// @vue/component
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SAMLForm',
  components: {
    PageHeader: __WEBPACK_IMPORTED_MODULE_3__components_widgets_PageHeader_PageHeader_vue___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_4__components_widgets_Loading_Loading_vue___default.a
  },
  data: function data() {
    return {
      email: '',

      formError: '',
      isLoading: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])({
    // eslint-disable-next-line
    title: function title(state) {
      return state.site.siteInfo.displayOptions.showSiteNameOnLoginScreen ? state.site.siteInfo.name : 'Log in';
    },
    isIframe: function isIframe(state) {
      return state.login.meta.isIframe;
    }
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])({
    samlURL: 'samlURL',
    allowStandardLogin: 'allowStandardLogin'
  })),
  mounted: function mounted() {
    if (this.isIframe) {
      window.parent.postMessage('pageResized', '*');
    }
  },

  methods: {
    onSubmit: function onSubmit() {
      if (this.isLoading) return false;
      this.isLoading = true;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_urlHelper__["d" /* navigateExternalURL */])(this.samlURL, this.isIframe);
    },
    reload: function reload() {
      window.location.reload();
    }
  }
});

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_errorHelper__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_appLoginHelper__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_urlHelper__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_uiHelper__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_sections_GDPRConsent_GDPRConsent_vue__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_sections_GDPRConsent_GDPRConsent_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_sections_GDPRConsent_GDPRConsent_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_sections_AppConsent_AppConsent_vue__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_sections_AppConsent_AppConsent_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_sections_AppConsent_AppConsent_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_widgets_AccountList_AccountList_vue__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_widgets_AccountList_AccountList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_widgets_AccountList_AccountList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_widgets_PageHeader_PageHeader_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_widgets_PageHeader_PageHeader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_widgets_PageHeader_PageHeader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_sections_Login_CompanyInfo_vue__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_sections_Login_CompanyInfo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_sections_Login_CompanyInfo_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_widgets_Loading_Loading_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_widgets_Loading_Loading_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_widgets_Loading_Loading_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_sections_Login_TfaSetup_vue__ = __webpack_require__(582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_sections_Login_TfaSetup_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_sections_Login_TfaSetup_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_PasswordInput_vue__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_PasswordInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_PasswordInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_sections_PersonaCapture_PersonaCapture_vue__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_sections_PersonaCapture_PersonaCapture_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_sections_PersonaCapture_PersonaCapture_vue__);


















// @vue/component
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Login',
  components: {
    'gdpr-consent': __WEBPACK_IMPORTED_MODULE_8__components_sections_GDPRConsent_GDPRConsent_vue___default.a,
    AppConsent: __WEBPACK_IMPORTED_MODULE_9__components_sections_AppConsent_AppConsent_vue___default.a,
    CompanyInfo: __WEBPACK_IMPORTED_MODULE_12__components_sections_Login_CompanyInfo_vue___default.a,
    AccountList: __WEBPACK_IMPORTED_MODULE_10__components_widgets_AccountList_AccountList_vue___default.a,
    PageHeader: __WEBPACK_IMPORTED_MODULE_11__components_widgets_PageHeader_PageHeader_vue___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_13__components_widgets_Loading_Loading_vue___default.a,
    TfaSetup: __WEBPACK_IMPORTED_MODULE_14__components_sections_Login_TfaSetup_vue___default.a,
    PasswordInput: __WEBPACK_IMPORTED_MODULE_15__components_PasswordInput_vue___default.a,
    PersonaCapture: __WEBPACK_IMPORTED_MODULE_16__components_sections_PersonaCapture_PersonaCapture_vue___default.a
  },
  data: function data() {
    return {
      rememberMe: false,
      twoFactorPasscode: '',
      gdprSeen: false,
      companyInfo: undefined,

      passwordEncrypted: false, // for legacy form support

      code: '',
      accounts: [],
      selectedAccount: '',

      state: 'normal',
      formError: '',
      isLoading: false,

      email: undefined,
      password: undefined,
      forced: false
    };
  },
  created: function created() {
    // Get query params submitted via legacy forms
    if (this.$route.query.email) this.email = this.$route.query.email;
    if (this.$route.query.password) this.password = this.$route.query.password;
    if (this.$route.query.automaticSubmit) this.automaticSubmit = true;
    if (this.$route.query.product) this.product = this.$route.query.product;
    this.passwordEncrypted = !!this.$route.query.encrypted;

    // hide legacy params
    var newParams = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.$route.query);
    delete newParams.email;
    delete newParams.password;
    delete newParams.automaticSubmit;
    delete newParams.encrypted;
    delete newParams.product;
    this.$router.replace({ query: newParams });

    if (this.automaticSubmit) {
      this.$nextTick(function () {
        // eslint-disable-line func-names
        this.onSubmit();
      });
    }
  },
  mounted: function mounted() {
    window.parent.postMessage('pageResized', '*');
    if (this.loggedIn) this.continueToProduct();
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_uiHelper__["a" /* smartFocus */])();
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])({
    samlURL: 'samlURL',
    googleSSOURL: 'googleSSOURL',
    allowStandardLogin: 'allowStandardLogin'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])({
    loginType: function loginType(state) {
      return state.login.loginType;
    },
    appInfo: function appInfo(state) {
      return state.login.appInfo;
    },
    meta: function meta(state) {
      return state.login.meta;
    },
    loggedIn: function loggedIn(state) {
      return state.login.loggedIn;
    },
    ignoreInstallations: function ignoreInstallations(state) {
      return state.login.meta.ignoreInstallations;
    },
    /* eslint-disable */
    afterLoginURL: function afterLoginURL(state) {
      var baseURL = state.login.loginType === 'account' ? window.location.href.replace(/(\/launchpad\/login)\/?/, '/') : '';
      return state.login.afterLoginURL || baseURL;
    },
    showRememberMe: function showRememberMe(state) {
      return state.site.siteInfo.displayOptions.allowRememberMe || state.login.loginType === 'generic';
    },
    showGoogleSSO: function showGoogleSSO(state) {
      return state.site.siteInfo.integrations.googleSignIn.enabled || state.login.loginType !== 'account';
    },
    showSAML: function showSAML(state) {
      return state.site.siteInfo.sso.enabled || state.login.loginType !== 'account';
    },
    startText: function startText(state) {
      return state.site.siteInfo.displayOptions.startText || '';
    },
    title: function title(state) {
      return state.site.siteInfo.displayOptions.showSiteNameOnLoginScreen ? state.site.siteInfo.name : 'Log in';
    },
    isEnterprise: function isEnterprise(state) {
      return state.site.siteInfo.isEnterprise;
    },
    inAppLogin: function inAppLogin(state) {
      return state.login.loginType === 'app';
    },
    isValidationPending: function isValidationPending(state) {
      return state.site.siteInfo.installationState === 'validation-pending';
    }
    /* eslint-enable */
  }), {
    forgotPasswordLink: function forgotPasswordLink() {
      var url = '/forgotpassword';
      if (this.$route.params.productCode) url += '/' + this.$route.params.productCode;
      return url;
    }
  }),
  methods: {
    onSubmit: function onSubmit() {
      this.isLoading = true;
      this.formError = '';

      var data = {
        email: this.email,
        password: this.password,
        rememberMe: this.rememberMe,
        product: this.product
      };

      // For app login flow, we want to allow apps to hide some accounts,
      // for example if they are already authenticated.
      if (this.inAppLogin && this.ignoreInstallations) {
        data.ignoreInstallations = this.ignoreInstallations;
      }

      if (this.gdprSeen) data.gdprSeen = true;
      if (this.inAppLogin) {
        data.redirect_uri = this.appInfo.redirect_uri;
        data.state = this.appInfo.state;
        data.client_id = this.appInfo.client_id;
        data.scope = this.appInfo.scope;
        data.install = this.appInfo.install;
        data.nonce = this.appInfo.nonce;
      }
      if (this.passwordEncrypted) data.passwordEncrypted = true;

      if (this.loginType === 'account') {
        this.submitLogin('', data);
      } else if (this.selectedAccount) {
        this.onAccountSelected(this.selectedAccount);
      } else if (this.password === 'xxx' && this.email.indexOf('@') === -1) {
        // logging in via API old key on generic login
        this.submitLogin('', data);
      } else if (this.loginType === 'app' && !this.meta.generic) {
        this.submitLogin('', data);
      } else {
        this.submitGetAccounts(data);
      }
    },
    initSAML: function initSAML() {
      if (this.loginType === 'account') {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_urlHelper__["d" /* navigateExternalURL */])(this.samlURL, this.$store.state.login.meta.isIframe);
      } else {
        this.$store.commit('setLoginState', 'saml-email');
      }
    },
    submitLogin: function submitLogin(baseURL, data) {
      var _this = this;

      var url = baseURL + '/launchpad/v1/login.json';
      if (this.loginType !== 'account') url += '?appAuth=true';

      /* eslint-disable */
      if (this.twoFactorPasscode) data.twoFactorPasscode = this.twoFactorPasscode;
      if (this.gdprSeen) data.gdprSeen = this.gdprSeen;
      if (this.inAppLogin) {
        data.redirect_uri = this.appInfo.redirect_uri;
        data.state = this.appInfo.state;
        data.client_id = this.appInfo.client_id;
        data.scope = this.appInfo.scope;
        data.install = this.appInfo.install;
        data.nonce = this.appInfo.nonce;
      }
      /* eslint-enable */
      var loginTypeTemp = this.loginType;

      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(url, data).then(function (response) {
        _this.code = response.data.code;

        if (response.data.setupScreenRequired) {
          var _response$data = response.data,
              industryCategoryId = _response$data.industryCategoryId,
              companySizeId = _response$data.companySizeId;


          _this.companyInfo = {
            industryCategoryId: industryCategoryId || undefined,
            sizeId: companySizeId || undefined
          };

          _this.state = 'company-info';
          _this.isLoading = false;

          return;
        }

        if (!response.data.gdprSeen) {
          _this.state = 'gdpr-consent';
          _this.gdprSeen = true;
          _this.isLoading = false;
          return;
        }

        if (response.data.userPersona !== undefined && !response.data.userPersona && loginTypeTemp !== 'generic') {
          _this.state = 'persona-capture';
          _this.$store.commit('setFormState', _this.state);
          _this.isLoading = false;
          return;
        }

        switch (_this.loginType) {// eslint-disable-line
          case 'app':
            _this.app = response.data.app;
            if (_this.app.consentRequired === false) {
              // allow skipping screen for our own apps
              _this.state = 'app-success';
              __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(baseURL + '/launchpad/v1/token/consent.json', { code: _this.code }).then(function (resp) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_appLoginHelper__["c" /* redirectToApp */])(_this.appInfo, resp.data.code);
              }).catch(function () {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_appLoginHelper__["a" /* redirectToAppWithError */])(_this.appInfo, 'failed_to_consent', 'impossible to consent');
              });
            } else {
              _this.state = 'app-consent';
            }
            _this.isLoading = false;
            return;
          case 'generic':
            // eslint-disable-line
            // baseURL in this case is account URL without trailing slash
            var _continueURL = '';
            if (_this.$route.params.productCode) _continueURL += baseURL + '/' + _this.$route.params.productCode;

            var params = {
              code: _this.code,
              continue: _this.afterLoginURL || data.continue || _continueURL
            };

            window.location.href = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_urlHelper__["c" /* fixProtocol */])(baseURL + '/launchpad/tokenauth?' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_urlHelper__["a" /* buildQueryString */])(params));
            return;
        }

        _this.$store.commit('setLoggedIn', {
          loggedIn: true,
          userId: response.data.userId
        });

        // eslint-disable-next-line
        var continueURL = _this.afterLoginURL || data.continue || window.location.href.replace(/(\/launchpad\/login)\/?/, '/');
        window.location.href = continueURL;
      }).catch(function (e) {
        var err = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_errorHelper__["a" /* handleAPIError */])(_this.$store, e, 'Please make sure you have the correct email or password.');

        if (err && err.type === __WEBPACK_IMPORTED_MODULE_4__utils_errorHelper__["b" /* ERROR_TYPE */].FORM_ERROR) _this.formError = err.err;
        if (err && err.type === __WEBPACK_IMPORTED_MODULE_4__utils_errorHelper__["b" /* ERROR_TYPE */].TFA_REQUIRED) _this.state = '2fa';
        if (err && err.type === __WEBPACK_IMPORTED_MODULE_4__utils_errorHelper__["b" /* ERROR_TYPE */].TFA_SETUP_REQUIRED) {
          _this.state = '2fa-setup';
          _this.forced = true;
        }
        if (err && err.type === __WEBPACK_IMPORTED_MODULE_4__utils_errorHelper__["b" /* ERROR_TYPE */].INSTALLATION_VALIDATION_PENDING) {
          var isVerifyEmail = _this.$route.query.continue && _this.$route.query.continue.includes('verifyemail');

          if (isVerifyEmail) {
            window.location.href = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_urlHelper__["c" /* fixProtocol */])('' + baseURL + _this.$route.query.continue + '?auth=' + e.response.data.unvalidatedAccountLoginCode + '&email=' + encodeURIComponent(_this.email));
          } else {
            window.location.href = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_urlHelper__["c" /* fixProtocol */])(baseURL + '/launchpad/verifyemail/' + (_this.$route.params.productCode ? _this.$route.params.productCode : 'projects') + '/firstsend?auth=' + e.response.data.unvalidatedAccountLoginCode + '&email=' + encodeURIComponent(_this.email));
          }
        }

        _this.isLoading = false;
        _this.passwordEncrypted = false;
        if (_this.state === 'select-account') _this.state = 'normal';
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_uiHelper__["a" /* smartFocus */])();
      });
    },
    submitGetAccounts: function submitGetAccounts(data) {
      var _this2 = this;

      this.$store.dispatch('getWafToken').then(function (token) {
        var headers = { 'Launchpad-Version': "v2f2573d" };
        if (token !== null) headers['x-aws-waf-token'] = token;
        return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('/launchpad/v1/accounts.json?generic=true', data, { headers: headers });
      }).then(function (response) {
        // filter out accounts where provided product is disabled
        // note: we will do this on the backend after global data
        // for all products
        var accs = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_appLoginHelper__["b" /* filterAccounts */])(response.data.accounts, _this2.meta.product);

        // If no accounts found, we either have wrong details or ignoring all accounts
        if (accs.length === 0) {
          _this2.formError = 'Please make sure you have the correct email or password.';
          if (response.data.ignoredAccounts === data.ignoreInstallations) {
            _this2.formError = 'You have already authenticated with all available Teamwork accounts.';
          }
          _this2.isLoading = false;
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_uiHelper__["a" /* smartFocus */])();
          return;
        }

        // If we only have one account, skip selection step
        if (accs.length === 1) {
          _this2.onAccountSelected(accs[0]);
          return;
        }

        _this2.accounts = accs;
        _this2.state = 'select-account';
        _this2.isLoading = false;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_uiHelper__["a" /* smartFocus */])();
      }).catch(function (e) {
        var err = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_errorHelper__["a" /* handleAPIError */])(_this2.$store, e, 'Please make sure you have the correct email or password.');
        if (err.type === __WEBPACK_IMPORTED_MODULE_4__utils_errorHelper__["b" /* ERROR_TYPE */].FORM_ERROR) _this2.formError = err.err;
        _this2.isLoading = false;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_uiHelper__["a" /* smartFocus */])();
      });
    },
    onAccountSelected: function onAccountSelected(account) {
      var url = account.installation.apiEndPoint;
      // eslint-disable-next-line
      if ("production" === 'development' || window.location.href.indexOf('sunbeam.teamwork.localhost') > -1) {
        url = account.installation.url.replace('https://', 'http://');
      }

      // remove trailing slash
      if (url[url.length - 1] === '/') url = url.substr(0, url.length - 1);

      this.selectedAccount = account;
      this.$store.commit('setSelectedAccount', account);

      this.submitLogin(url, {
        email: this.email,
        password: this.password,
        rememberMe: this.rememberMe
      });
    },
    onClickGoogleSSO: function onClickGoogleSSO(e) {
      this.isLoading = true;
      var isIframe = this.$store.state.login.meta.isIframe;
      if (isIframe) e.preventDefault();
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_urlHelper__["d" /* navigateExternalURL */])(this.googleSSOURL, isIframe);
    },
    reset: function reset() {
      this.formError = '';
      this.state = 'normal';
      this.twoFactorPasscode = '';
      this.selectedAccount = null;
      this.isLoading = false;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_uiHelper__["a" /* smartFocus */])();
    },
    continueToProduct: function continueToProduct() {
      // eslint-disable-next-line
      if (this.loginType !== 'account' || !this.loggedIn || !this.$route.params.productCode || this.isValidationPending) return;
      this.isLoading = true;
      window.location.href = this.afterLoginURL;
    }
  },
  watch: {
    isLoading: function isLoading() {
      window.parent.postMessage('pageResized', '*');
    },
    loggedIn: function loggedIn(_loggedIn) {
      if (_loggedIn) this.continueToProduct();
    }
  }
});

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_widgets_PageHeader_PageHeader_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_widgets_PageHeader_PageHeader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_widgets_PageHeader_PageHeader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_appLoginHelper__ = __webpack_require__(43);





// @vue/component
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SiteNotFound',
  components: {
    PageHeader: __WEBPACK_IMPORTED_MODULE_2__components_widgets_PageHeader_PageHeader_vue___default.a
  },
  data: function data() {
    return {
      siteAddress: window.location.hostname
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])({
    inAppLogin: function inAppLogin(state) {
      return state.login.loginType === 'app';
    },
    appInfo: function appInfo(state) {
      return state.login.appInfo;
    }
  })),
  methods: {
    onClickBackToApp: function onClickBackToApp() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_appLoginHelper__["a" /* redirectToAppWithError */])(this.appInfo, 'server_error', 'users installation could not be found');
    }
  }
});

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
// @vue/component
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AccountList',
  props: {
    accounts: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  methods: {
    onSelectAccount: function onSelectAccount(account) {
      this.$emit('account-selected', account);
    },
    getBackgroundImage: function getBackgroundImage(account) {
      return account.installation.logo ? 'url(\'' + account.installation.logo + '\')' : '';
    }
  }
});

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_appLoginHelper__ = __webpack_require__(43);




// @vue/component
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Loading',
  props: {
    isLoading: {
      type: Boolean,
      required: true
    }
  },
  data: function data() {
    return {
      showTryAgain: false,
      tryAgainTimeout: null
    };
  },
  created: function created() {
    this.setupTryAgain(this.isLoading);
  },

  watch: {
    isLoading: function isLoading(newVal) {
      this.setupTryAgain(newVal);
    }
  },
  methods: {
    setupTryAgain: function setupTryAgain(isLoading) {
      var _this = this;

      if (isLoading) {
        this.tryAgainTimeout = setTimeout(function () {
          _this.showTryAgain = true;
        }, 8000);
      } else {
        clearTimeout(this.tryAgainTimeout);
      }
    },
    onCancel: function onCancel() {
      if (!this.inAppLogin) return false;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_appLoginHelper__["a" /* redirectToAppWithError */])(this.appInfo, 'access_denied', 'user cancelled the login process');
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])({
    appInfo: function appInfo(state) {
      return state.login.appInfo;
    },
    inAppLogin: function inAppLogin(state) {
      return state.login.loginType === 'app';
    }
  }))
});

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
// @vue/component
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PageHeader',
  props: {
    title: {
      type: String,
      default: 'Log in'
    },
    subTitle: {
      type: String,
      default: ''
    },
    error: {
      type: String,
      default: ''
    },
    hideable: { // can be hidden by `hide-title` extra property
      type: Boolean,
      default: true
    }
  }
});

/***/ }),
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 532 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 533 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 534 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 535 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 536 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 537 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 538 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 539 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 540 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 541 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/client-persona.cfaa813.png";

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/contributor-persona.a9ff0be.png";

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/email-expired.7e71ad6.png";

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/email-send.1977181.png";

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/email-verified.22eff19.png";

/***/ }),
/* 557 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 558 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAABwRJREFUWAnFV3lsXMUZ/76Z9/by2o7xKWoEhiYYIlAp5fgDiClJhEEBiogbFZBcytFKUJoiDgkERhWHFFKIAAESAYQCiFgorVRqcihdUqhTUloaYkUoITgkgTgbfNu7772Z+frN27zau/YGg4QYafXezPuO33fPAnzPC7+p/qHOa+bB8MQpOpg8FTQ1EVJKGpEXiAPKlf1OZXpv9etvj7BgMxfZcwKw54474jV7/nWRMNhBqNtIUUtMomuZIwFEAD6QJsKDAmGbFvJN8mLvNmQy48cDEvGXpcm2X7xIGn8lK79MAKUVGdBMbRWWLitMMCRXIhCQr4zYSsKsGvNT/2jJZPKl9HZfFsCR5W1pGPHvdEDfjkRNbBqYWZTOJjQSHBOCX+moR+IplMFL9Rs//LKU3lLMWF8sW1Ynx7zVSdB3gzFNAWsup7ycBRZr3hjrkTpHwM0KnFZavlyWKnNKD/Zc317lZrOPugA/942p0iVWW4UxFGCNC/ibYc9IRHD4A/G74l/EE2c6JbDfoLxLVZrt2N1to1e0igBQV5c40rvxdwmAq32ji5RHijXCeCCwl1BuJkf2SekMB0alQekF7KkljlaLODuruSrAIOwDR64cm3A3tbwzhxwY+OklS+OOv0YZ3Trd5Va5wwJJineEk1g9lvLeP6m7N1dkCm+sAYP/2XYhTk48SAJPMhLvraN5m7GnxyuljfZWdriorz49sqbxRb0/ebUJMMH1HZ4XlAttXPE0efBE3dbeQ8dYyj6+bG+vV9KLNScHstjd55cl5A9TALZVXUnG/2NuR+2C3HsNYEY5CwSBy3Fky58nUo/Wbtpx4HjCvs23sAo4eTAI9BIUuiF+3gBUXPM5OM0T4DI+g2KHMvjCd6HcAi6U4QfNJyDps7WPlZy24LSMQPra/RD70aCmKrXOIe+zb2PdXHjCKggmgmbXwTqtQXIVQQii1gNxxcHP3PyRf7pXjo6WE7b0sdGbUMYv18pUQtgjy1FOnQtHWkVrHakyIQAErw6ESYTjo5B7TI0gHNqt4t4QJ8r/T6fEFN6IxEJAZzE4VAPEeTOHhQxAa38XotgZAqDkyQvI/3QeUFDEzqmRJUZXdFi6QQiM4UatFTeiOQ1AlpCwjasOtEqFACQg2TIvlf1d7S3QZJyaEq5JhwD8XP+ehKNG2OsN02EwYQM3hPjxgHB4uN3z+OOSBXZX6Qq9EibW1BfkPj7hm/1+EB8OAQgnngXj53mcT1HxIFHktg4LtwbAs5Jn9ZAQcognwCFDZhxnhMAOMa4shCrGMDX4eIOARw3kciGAWPyEQ3p8LMsWcKvntoMGDvhpWJs/s+XfqvEnP1yX2r33htdmrYSmhsSTwsAz3gTLLFkV8SHcN+SuIoqt4NKqjC4RZALSKA6JZPVoCAB6VgzRoic+lqjPRWOqe/0meG78DNgNNZJNuLE2Yf6+F2Bnifxw+8ov0V40Zr1sLH4sfyo77kwgVREpR8ETmfQgt7hPAQ6Mhm7Bri7jQGKLJ+MDr+fmQ9foObBLVTMfz3NBFzDDbResu7Z5NgDlzmx3FUbfREK2cklPuV84wBN0J4/xgz2/ne9NfRg9/d3ff3Xhf5+dXJg/auIcMBsnjiEPdwN0KybkynPeuOrEcgqnn5/LDWHJ494tRro3gg5qi8rT5gnRJieRPmx5iuL24/Wdl0uZe5KUbo1cFgpmmNw0bLH+lblXsxN7ezu6Z4xjS3v++mUtscnFv44NXsfBqa3nBsGnhfxFGeNiMbuE8H618d6qHSy1uG66qEts7v7kgcAxtxul60vvYcJlJARj7JL32cVb+I7QZ4wY5otniivgFEXiYiHMZVyVJ4rJFpnIdoDIncEA2E5uNFwxgRD6LmOSr265D0cs4CIP2IPF62+tHhfDq0jACh1wfy+pYVtMQrIPmJM0B4cNRLuVhWgazpuwpaMPQtdAfOhnEBtZxN26irt1sNYPcn/Y+kDNfqvLLmYtXvu6P/TO6jx/u+/rRnDFfLY0fsyDBULbb/i6xP8AIs+GT7svOmPRJHKgUx8DJvPgBtUbHL/64U33V+6brnGGB6KPV/35nsqj6vM7teFwIDUWhM/aiyKWGU/k6zB73uer/auxlHkk0/6n/lKisgAiwrYNN7T5Sq1UHFt2e4VhtxembhkwUYg4dFKIj1DJNSkINmzp6A5jHsmNnl8LwBJ2/q0zsXfQXGQw6ODkvJQjfzI4gi9M7HbGgWymfeG+wXdRzEqUH/A/t7fS2nm7p+PlbKRstuecAExn/MVfflPzBXqnQaBOk8b8wJUVNYGaHAuQDjtS9rv8L9Lb/lE205VR0/nKvX9jALbDXZp5WNZn+8R4ugkbk7U4kPuK0uOHKVu/0LS1gXkIHuLxfuxaXU7zsfP/AcVdOIL39WLnAAAAAElFTkSuQmCC"

/***/ }),
/* 559 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yMC44MDAzIDYuMjQwNTNDMjEuMDgxNyA2LjU0NDUxIDIxLjA2MzQgNy4wMTkwMyAyMC43NTk0IDcuMzAwNEw5LjQxNTcyIDE3LjgwMDNDOS4xMjgyIDE4LjA2NjYgOC42ODQyOSAxOC4wNjY2IDguMzk2NzggMTcuODAwM0wzLjI0MDUzIDEzLjAyNzdDMi45MzY1NiAxMi43NDYzIDIuOTE4MjMgMTIuMjcxOCAzLjE5OTYgMTEuOTY3OEMzLjQ4MDk3IDExLjY2MzggMy45NTU0OCAxMS42NDU1IDQuMjU5NDcgMTEuOTI2OUw4LjkwNjI0IDE2LjIyOEwxOS43NDA2IDYuMTk5NkMyMC4wNDQ1IDUuOTE4MjMgMjAuNTE5MSA1LjkzNjU2IDIwLjgwMDMgNi4yNDA1M1oiIGZpbGw9IiM0NDYxRDciLz4KPC9zdmc+Cg=="

/***/ }),
/* 560 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+CiAgPHBhdGggZD0iTTEyIDdjMi43NiAwIDUgMi4yNCA1IDUgMCAuNjUtLjEzIDEuMjYtLjM2IDEuODNsMi45MiAyLjkyYzEuNTEtMS4yNiAyLjctMi44OSAzLjQzLTQuNzUtMS43My00LjM5LTYtNy41LTExLTcuNS0xLjQgMC0yLjc0LjI1LTMuOTguN2wyLjE2IDIuMTZDMTAuNzQgNy4xMyAxMS4zNSA3IDEyIDd6TTIgNC4yN2wyLjI4IDIuMjguNDYuNDZDMy4wOCA4LjMgMS43OCAxMC4wMiAxIDEyYzEuNzMgNC4zOSA2IDcuNSAxMSA3LjUgMS41NSAwIDMuMDMtLjMgNC4zOC0uODRsLjQyLjQyTDE5LjczIDIyIDIxIDIwLjczIDMuMjcgMyAyIDQuMjd6TTcuNTMgOS44bDEuNTUgMS41NWMtLjA1LjIxLS4wOC40My0uMDguNjUgMCAxLjY2IDEuMzQgMyAzIDMgLjIyIDAgLjQ0LS4wMy42NS0uMDhsMS41NSAxLjU1Yy0uNjcuMzMtMS40MS41My0yLjIuNTMtMi43NiAwLTUtMi4yNC01LTUgMC0uNzkuMi0xLjUzLjUzLTIuMnptNC4zMS0uNzggMy4xNSAzLjE1LjAyLS4xNmMwLTEuNjYtMS4zNC0zLTMtM2wtLjE3LjAxeiIgLz4KPC9zdmc+Cg=="

/***/ }),
/* 561 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+CiAgPHBhdGggZD0iTTEyIDQuNUM3IDQuNSAyLjczIDcuNjEgMSAxMmMxLjczIDQuMzkgNiA3LjUgMTEgNy41czkuMjctMy4xMSAxMS03LjVjLTEuNzMtNC4zOS02LTcuNS0xMS03LjV6TTEyIDE3Yy0yLjc2IDAtNS0yLjI0LTUtNXMyLjI0LTUgNS01IDUgMi4yNCA1IDUtMi4yNCA1LTUgNXptMC04Yy0xLjY2IDAtMyAxLjM0LTMgM3MxLjM0IDMgMyAzIDMtMS4zNCAzLTMtMS4zNC0zLTMtM3oiIC8+Cjwvc3ZnPgo="

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ops-manager-persona.2c7f148.png";

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/pm-persona.458a377.png";

/***/ }),
/* 564 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(541)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(253),
  /* template */
  __webpack_require__(611),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(254),
  /* template */
  __webpack_require__(597),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(532)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(245),
  /* template */
  __webpack_require__(589),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-218b5a9d",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(255),
  /* template */
  __webpack_require__(612),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(256),
  /* template */
  __webpack_require__(610),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(257),
  /* template */
  __webpack_require__(586),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(258),
  /* template */
  __webpack_require__(607),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(259),
  /* template */
  __webpack_require__(606),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(536)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(260),
  /* template */
  __webpack_require__(596),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3e3ad059",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(261),
  /* template */
  __webpack_require__(605),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(262),
  /* template */
  __webpack_require__(595),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(263),
  /* template */
  __webpack_require__(585),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(537)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(246),
  /* template */
  __webpack_require__(602),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6513d779",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(265),
  /* template */
  __webpack_require__(614),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(267),
  /* template */
  __webpack_require__(613),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(268),
  /* template */
  __webpack_require__(604),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(269),
  /* template */
  __webpack_require__(598),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(539)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(248),
  /* template */
  __webpack_require__(608),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-81519574",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(540)
}
var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(249),
  /* template */
  __webpack_require__(609),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-8e143b26",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(4)(
  /* script */
  __webpack_require__(270),
  /* template */
  __webpack_require__(592),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 585 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-welcome"
  }, [_c('page-header', {
    attrs: {
      "title": _vm.title,
      "subTitle": _vm.subtitle
    }
  }), _c('div', {
    staticClass: "content"
  }, [_c('product-list', {
    attrs: {
      "products": _vm.products
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 586 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-logout"
  }, [_c('page-header', {
    attrs: {
      "title": _vm.title,
      "subTitle": _vm.logoutMessageHTML
    }
  }), _c('form', {
    staticClass: "w-login-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmitLogin.apply(null, arguments)
      }
    }
  }, [_vm._m(0)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-login-form__row w-login-form__row--action"
  }, [_c('button', {
    staticClass: "w-button w-button--blue",
    attrs: {
      "type": "submit",
      "autofocus": "autofocus"
    }
  }, [_c('span', {
    staticClass: "w-button__label"
  }, [_vm._v("Log in again")])])])
}]}

/***/ }),
/* 587 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isLoading) ? _c('loading', {
    attrs: {
      "is-loading": "is-loading"
    }
  }) : [_c('page-header', {
    attrs: {
      "title": "We'd love to know a bit more about you",
      "error": _vm.errorMessage
    }
  }), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.save.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "w-login-form__row"
  }, [_c('p', [_vm._v("Heya! We're working on improving some key areas of Teamwork and to ensure we offer the best version for your team, we'd love to know a few things about your \norganization. As you are an Administrator we thought you may be the best to help us.")])]), _c('div', {
    staticClass: "w-login-form__row"
  }, [_c('TwSelect', {
    attrs: {
      "label": "Industry category",
      "name": "industry-category",
      "options": _vm.industryCategoryOptions
    },
    model: {
      value: (_vm.model.industryCategory),
      callback: function($$v) {
        _vm.$set(_vm.model, "industryCategory", $$v)
      },
      expression: "model.industryCategory"
    }
  }), _c('TwSelect', {
    attrs: {
      "label": "Company size",
      "name": "company-size",
      "options": _vm.sizeOptions
    },
    model: {
      value: (_vm.model.size),
      callback: function($$v) {
        _vm.$set(_vm.model, "size", $$v)
      },
      expression: "model.size"
    }
  })], 1), _c('div', {
    staticClass: "w-login-form__row"
  }, [_c('p', [_vm._v("We appreciate your help on this,"), _c('br'), _vm._v("Dan & Peter.")])]), _c('button', {
    staticClass: "w-button w-button--blue",
    attrs: {
      "type": "submit"
    }
  }, [_c('span', {
    staticClass: "w-button__label"
  }, [_vm._v("Save")])])])]], 2)
},staticRenderFns: []}

/***/ }),
/* 588 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-page-header",
    class: {
      'no-subtitle': _vm.subTitle.length === 0, 'hideable': _vm.hideable
    }
  }, [_c('h1', {
    staticClass: "w-page-header__title",
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }), _c('p', {
    staticClass: "w-page-header__description",
    class: {
      'is-invalid': _vm.error
    }
  }, [(!_vm.error) ? _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.subTitle)
    }
  }) : _vm._e(), (_vm.error) ? _c('span', [_vm._v(_vm._s(_vm.error))]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 589 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-account-not-set-up"
  }, [_c('PageHeader', {
    attrs: {
      "title": _vm.title,
      "sub-title": _vm.subTitle
    }
  }), _vm._v(" "), _c('form', {
    staticClass: "w-login-form"
  }, [_c('div', {
    staticClass: "w-login-form__row"
  }, [(_vm.customMessage) ? _c('p', {
    domProps: {
      "textContent": _vm._s(_vm.customMessage)
    }
  }) : _c('p', [_vm._v("\n        Your account is not set up to use " + _vm._s(_vm.productName) + ".\n        Please contact your site administrator.\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "w-login-form__row"
  }, [_c('ProductList', {
    attrs: {
      "products": _vm.continueItems
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "w-login-form__row"
  }, [_c('router-link', {
    staticClass: "w-button w-button--blue",
    attrs: {
      "to": "/login"
    }
  }, [_c('span', {
    staticClass: "w-button__label"
  }, [_vm._v("\n          Back to login\n        ")])])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 590 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "textfield"
  }, [_c('select', _vm._b({
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.innerValue),
      expression: "innerValue"
    }],
    ref: "select",
    staticClass: "textfield__input",
    on: {
      "input": function($event) {
        return _vm.$emit('input', $event.target.value)
      },
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.innerValue = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.blur]
    }
  }, 'select', _vm.$attrs, false), [_c('option', {
    attrs: {
      "disabled": "",
      "selected": "",
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.options), function(option, key) {
    return _c('option', {
      key: key,
      domProps: {
        "value": option.value
      }
    }, [_vm._v("\n      " + _vm._s(option.label) + "\n    ")])
  })], 2), _vm._v(" "), _c('label', {
    staticClass: "textfield__label",
    class: {
      'textfield__label--filled': !_vm.empty
    },
    attrs: {
      "for": _vm.name
    }
  }, [_vm._v("\n    " + _vm._s(_vm.fieldLabel) + "\n  ")]), _vm._v(" "), _c('svg', {
    staticClass: "textfield__icon",
    attrs: {
      "height": "24px",
      "viewBox": "0 0 24 24",
      "width": "24px"
    }
  }, [_c('path', {
    attrs: {
      "d": "M7 10l5 5 5-5H7z"
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 591 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-consent"
  }, [_c('page-header', {
    staticClass: "compressed"
  }, [(_vm.showAppDetails) ? [(_vm.app.url) ? [_vm._v("Log in to "), _c('a', {
    attrs: {
      "href": _vm.app.url,
      "_target": "blank"
    }
  }, [_vm._v(_vm._s(_vm.app.name))])] : [_vm._v("Log in to " + _vm._s(_vm.app.name))]] : (_vm.appIsLocal) ? [_vm._v("Log in to " + _vm._s(_vm.app.name))] : [_vm._v("Log in")]], 2), (_vm.showAppDetails && _vm.app.publisher) ? _c('div', {
    staticClass: "app-consent__publisher"
  }, [(_vm.logoUrl) ? _c('div', {
    staticClass: "app-consent__publisher-logo"
  }, [_c('img', {
    attrs: {
      "src": _vm.logoUrl,
      "alt": "Logo"
    }
  })]) : _vm._e(), _c('div', {
    staticClass: "app-consent__publisher-details"
  }, [_c('div', [_vm._v(_vm._s(_vm.app.publisher.name))]), (_vm.app.publisher.url) ? _c('div', [_c('a', {
    attrs: {
      "href": _vm.app.publisher.url
    }
  }, [_vm._v(_vm._s(_vm.app.publisher.url))])]) : _vm._e(), _c('div', {
    staticClass: "app-consent__publisher-links"
  }, [(_vm.app.publisher.privacyUrl) ? _c('small', [_c('a', {
    attrs: {
      "href": _vm.app.publisher.privacyUrl,
      "target": "_blank"
    }
  }, [_vm._v("Privacy")])]) : _vm._e(), (_vm.app.publisher.termsUrl) ? _c('small', [_c('a', {
    attrs: {
      "href": _vm.app.publisher.termsUrl,
      "target": "_blank"
    }
  }, [_vm._v("Terms")])]) : _vm._e()])])]) : _vm._e(), _c('form', {
    staticClass: "w-login-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onAllow.apply(null, arguments)
      }
    }
  }, [(_vm.showAppDetails) ? _c('div', {
    staticClass: "w-login-form__app-details"
  }, [_c('div', {
    staticClass: "w-login-form__row"
  }, [(_vm.app.description) ? _c('p', [_vm._v(_vm._s(_vm.app.description))]) : _vm._e()]), _c('div', {
    staticClass: "w-login-form__row access"
  }, [_c('p', [_c('strong', [_vm._v(_vm._s(_vm.app.name) + " requires access to:")])])])]) : _c('div', {
    staticClass: "w-login-form__app-details"
  }, [_vm._m(0)]), _c('div', {
    staticClass: "w-login-form__row"
  }, [_c('ul', {
    staticClass: "scope-list"
  }, _vm._l((_vm.requestedScope), function(productCode) {
    return _c('li', [_c('span', {
      staticClass: "app-icon"
    }, [_c('img', {
      attrs: {
        "src": _vm.getAppIcon(productCode)
      }
    })]), _c('span', [_vm._v("Read and write your " + _vm._s(_vm.getAppName(productCode)) + " data")])])
  }), 0)]), _vm._m(1)]), _c('div', {
    staticClass: "w-page-footer"
  }, [_c('button', {
    staticClass: "w-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.onDeny.apply(null, arguments)
      }
    }
  }, [_c('span', {
    staticClass: "w-button__label"
  }, [_vm._v("Deny")])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-login-form__row access"
  }, [_c('p', [_c('strong', [_vm._v("A third-party application requires access to:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-login-form__row w-login-form__row--action"
  }, [_c('button', {
    staticClass: "w-button w-button--blue",
    attrs: {
      "type": "submit"
    }
  }, [_c('span', {
    staticClass: "w-button__label"
  }, [_vm._v("Allow")])])])
}]}

/***/ }),
/* 592 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "site-not-found"
  }, [_c('page-header', {
    attrs: {
      "title": "Oops - We didn't find your site.",
      "subTitle": "But don't panic, we're here to help!"
    }
  }), _c('form', {
    staticClass: "w-login-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmitLogin.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "w-login-form__row"
  }, [_c('p', [_vm._v("1. Most likely, you have probably just slightly misspelt the address"), _c('strong', [_vm._v(" " + _vm._s(_vm.siteAddress) + " ")]), _vm._v("so before we go any further please check that.")])]), _vm._m(0), _vm._m(1), _vm._m(2), _vm._m(3)]), (_vm.inAppLogin) ? _c('div', {
    staticClass: "w-page-footer"
  }, [_c('button', {
    staticClass: "w-button w-button--blue",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.onClickBackToApp.apply(null, arguments)
      }
    }
  }, [_c('span', {
    staticClass: "w-button__label"
  }, [_vm._v("Back to app")])])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-login-form__row"
  }, [_c('p', [_vm._v("2. Still here? Hmmm, perhaps you can't think of the correct address for the site you want;\n that's no problem, "), _c('a', {
    attrs: {
      "href": "https://teamwork.com/launchpad/login"
    }
  }, [_vm._v("you can use our generic login page")]), _vm._v(".")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-login-form__row"
  }, [_c('p', [_vm._v("3. Oh dear, you're still here... OK, there is also the slim possibility that\n the account may have been cancelled, in which case we can restore it if there\n has been a mistake.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-login-form__row"
  }, [_c('p', [_vm._v("4. Custom domain?: If you've added a custom domain to your account,\n you may have missed the last step... "), _c('a', {
    attrs: {
      "href": "https://support.teamwork.com/projects/general-settings/using-a-custom-domain-name"
    }
  }, [_vm._v("Setting up your custom domain")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-login-form__row"
  }, [_c('p', [_vm._v("5. Contact Us: If something has gone wrong, just "), _c('a', {
    attrs: {
      "href": "https://www.teamwork.com/contact"
    }
  }, [_vm._v("drop us a quick note")]), _vm._v(" and we'll do our best to help.")])])
}]}

/***/ }),
/* 593 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "password-input w-input"
  }, [(_vm.label) ? _c('label', {
    staticClass: "w-input__label",
    attrs: {
      "for": "loginpassword"
    }
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _c('input', _vm._b({
    staticClass: "w-input__input",
    attrs: {
      "id": "loginpassword",
      "type": _vm.isVisible ? 'text' : 'password'
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input', $event.target.value)
      }
    }
  }, 'input', _vm.$attrs, false)), _c('div', {
    staticClass: "w-input__right-block"
  }, [(_vm.isVisible) ? _c('img', {
    staticClass: "icon",
    attrs: {
      "role": "button",
      "title": "Hide password",
      "src": _vm.iconInvisible
    },
    on: {
      "click": function($event) {
        _vm.isVisible = false
      }
    }
  }) : _c('img', {
    staticClass: "icon",
    attrs: {
      "role": "button",
      "title": "Show password",
      "src": _vm.iconVisible
    },
    on: {
      "click": function($event) {
        _vm.isVisible = true
      }
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-select-account"
  }, _vm._l((_vm.accounts), function(account) {
    return _c('a', {
      staticClass: "w-select-account__row",
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.onSelectAccount(account)
        }
      }
    }, [_c('span', {
      staticClass: "w-select-account__image",
      style: ({
        backgroundImage: _vm.getBackgroundImage(account)
      })
    }), _c('span', {
      staticClass: "w-select-account__row-content"
    }, [_c('strong', {
      staticClass: "w-select-account__name"
    }, [_vm._v(_vm._s(account.installation.name))]), _c('span', {
      staticClass: "w-select-account__owner"
    }, [_vm._v(_vm._s(account.user.firstName + ' ' + account.user.lastName))]), _c('span', {
      staticClass: "w-select-account__url"
    }, [_vm._v(_vm._s(account.installation.url))])]), (account.installation.region === 'EU') ? _c('span', {
      staticClass: "w-select-account__eu-flag"
    }, [_c('img', {
      attrs: {
        "src": __webpack_require__(557),
        "alt": "EU"
      }
    })]) : _vm._e(), (account.installation.region === 'AU') ? _c('span', {
      staticClass: "w-select-account__au-flag"
    }, [_vm._v("AU")]) : _vm._e()])
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 595 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-token-auth"
  }, [_c('loading', {
    attrs: {
      "isLoading": _vm.isLoading
    },
    on: {
      "reset": _vm.reload
    }
  }), (!_vm.isLoading) ? _c('div', {
    staticClass: "content"
  }, [(_vm.state === 'company-info') ? _c('company-info', {
    attrs: {
      "default-info": _vm.companyInfo
    },
    on: {
      "saved": _vm.onCompanyInfoSaved
    }
  }) : _vm._e(), (_vm.state === 'gdpr-consent') ? _c('gdpr-consent', {
    on: {
      "seen": _vm.loginViaToken
    }
  }) : _vm._e(), (_vm.state === 'app-consent') ? _c('app-consent', {
    attrs: {
      "code": _vm.code,
      "app": _vm.app
    }
  }) : _vm._e(), (_vm.state === 'persona-capture') ? _c('persona-capture', {
    attrs: {
      "code": _vm.code,
      "app": _vm.app
    },
    on: {
      "saved": _vm.onPersonaInfoSaved
    }
  }) : _vm._e(), (_vm.state === 'normal') ? _c('div', {
    staticClass: "content"
  }, [_c('page-header', {
    attrs: {
      "title": _vm.title
    }
  }), _c('form', {
    staticClass: "w-login-form"
  }, [_c('div', {
    staticClass: "w-login-form__row"
  }, [_c('p', [_vm._v("Login successful")]), _c('div', {
    staticClass: "auth-token",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v(_vm._s(_vm.code))])])])], 1) : _vm._e()], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 596 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-select-account"
  }, [_c('page-header', {
    attrs: {
      "title": _vm.title
    }
  }), _c('loading', {
    attrs: {
      "isLoading": _vm.isLoading
    },
    on: {
      "reset": _vm.reload
    }
  }), (!_vm.isLoading) ? _c('div', {
    staticClass: "content"
  }, [_c('account-list', {
    attrs: {
      "accounts": _vm.accounts
    },
    on: {
      "account-selected": _vm.onAccountSelected
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 597 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-accept-invite"
  }, [_c('loading', {
    attrs: {
      "isLoading": _vm.isLoading
    },
    on: {
      "reset": _vm.reload
    }
  }), (!_vm.isLoading) ? _c('div', {
    staticClass: "content"
  }, [_c('page-header', {
    attrs: {
      "title": _vm.title,
      "subTitle": _vm.subTitle,
      "error": _vm.formError
    }
  }), (!_vm.expired) ? _c('form', {
    staticClass: "w-login-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [(_vm.showNameInputs) ? _c('div', [_c('div', {
    staticClass: "w-login-form__row"
  }, [_c('div', {
    staticClass: "w-input"
  }, [_c('label', {
    staticClass: "w-input__label",
    attrs: {
      "for": "firstName"
    }
  }, [_vm._v("First Name")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.firstName),
      expression: "user.firstName"
    }],
    staticClass: "w-input__input",
    attrs: {
      "id": "firstName",
      "type": "text",
      "required": "required"
    },
    domProps: {
      "value": (_vm.user.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "firstName", $event.target.value)
      }
    }
  })])]), _c('div', {
    staticClass: "w-login-form__row"
  }, [_c('div', {
    staticClass: "w-input"
  }, [_c('label', {
    staticClass: "w-input__label",
    attrs: {
      "for": "lastName"
    }
  }, [_vm._v("Last Name")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.lastName),
      expression: "user.lastName"
    }],
    staticClass: "w-input__input",
    attrs: {
      "id": "lastName",
      "type": "text",
      "required": "required"
    },
    domProps: {
      "value": (_vm.user.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "lastName", $event.target.value)
      }
    }
  })])])]) : _vm._e(), (_vm.isProductChat) ? _c('div', [_c('div', {
    staticClass: "w-login-form__row"
  }, [_c('div', {
    staticClass: "w-input"
  }, [_c('label', {
    staticClass: "w-input__label",
    attrs: {
      "for": "chatHandle"
    }
  }, [_vm._v("Chat Handle")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.chatHandle),
      expression: "user.chatHandle"
    }],
    staticClass: "w-input__input",
    attrs: {
      "id": "chatHandle",
      "type": "text",
      "required": "required"
    },
    domProps: {
      "value": (_vm.user.chatHandle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "chatHandle", $event.target.value)
      }
    }
  })])])]) : _vm._e(), _c('div', {
    staticClass: "w-login-form__row w-login-form__row--password"
  }, [_c('password-input', {
    attrs: {
      "label": "Password",
      "autocomplete": "new-password",
      "required": "required"
    },
    model: {
      value: (_vm.user.password),
      callback: function($$v) {
        _vm.$set(_vm.user, "password", $$v)
      },
      expression: "user.password"
    }
  })], 1), _c('div', {
    staticClass: "w-login-form__row w-login-form__row--action"
  }, [_c('button', {
    staticClass: "w-button",
    class: {
      'w-button--gray': !_vm.canSubmit, 'w-button--blue': _vm.canSubmit
    },
    attrs: {
      "type": "submit",
      "disabled": !_vm.canSubmit
    }
  }, [_c('span', {
    staticClass: "w-button__label"
  }, [_vm._v("Get started")])])])]) : _vm._e(), (_vm.expired) ? _c('form', {
    staticClass: "w-login-form"
  }, [_vm._m(0), _c('div', {
    staticClass: "w-login-form__row w-login-form__row--action"
  }, [_c('router-link', {
    staticClass: "w-button w-button--blue",
    attrs: {
      "to": {
        path: _vm.loginLink,
        query: _vm.$route.query
      },
      "tag": "button",
      "type": "button"
    }
  }, [_c('span', {
    staticClass: "w-button__label"
  }, [_vm._v("Log in")])])], 1)]) : _vm._e()], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-login-form__row"
  }, [_c('p', [_vm._v("Invite code is not valid, it may have expired or has already been used.\nPlease request a new invitation or try to log in.")])])
}]}

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "standard-form"
  }, [_c('loading', {
    attrs: {
      "isLoading": _vm.isLoading
    },
    on: {
      "reset": _vm.reset
    }
  }), (!_vm.isLoading) ? _c('div', {
    staticClass: "content"
  }, [(_vm.state === 'company-info') ? _c('company-info', {
    attrs: {
      "default-info": _vm.companyInfo
    },
    on: {
      "saved": _vm.onSubmit
    }
  }) : _vm._e(), (_vm.state === 'gdpr-consent') ? _c('gdpr-consent', {
    on: {
      "seen": _vm.onSubmit
    }
  }) : _vm._e(), (_vm.state === 'app-consent') ? _c('app-consent', {
    attrs: {
      "code": _vm.code,
      "app": _vm.app
    }
  }) : _vm._e(), (_vm.state === 'persona-capture') ? _c('persona-capture', {
    attrs: {
      "code": _vm.code,
      "app": _vm.app
    },
    on: {
      "saved": _vm.onSubmit
    }
  }) : _vm._e(), (_vm.state === 'select-account') ? _c('div', {
    staticClass: "login-form"
  }, [_c('account-list', {
    attrs: {
      "accounts": _vm.accounts
    },
    on: {
      "account-selected": _vm.onAccountSelected
    }
  }), _c('div', {
    staticClass: "w-page-footer w-page-footer--mb"
  }, [_c('button', {
    staticClass: "w-button w-button--link",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.reset
    }
  }, [_c('span', {
    staticClass: "w-button__label"
  }, [_vm._v("Return to login")])])])], 1) : _vm._e(), (_vm.state === 'app-success') ? _c('div', {
    staticClass: "app-success"
  }, [_c('form', {
    staticClass: "w-login-form"
  }, [_c('div', {
    staticClass: "w-login-form__row"
  }, [_c('p', [_vm._v("Login successful")]), _c('div', {
    staticClass: "auth-token",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v(_vm._s(_vm.code))])])])]) : _vm._e(), (_vm.state === 'normal') ? _c('div', {
    staticClass: "login-form"
  }, [_c('page-header', {
    attrs: {
      "title": _vm.title,
      "error": _vm.formError
    }
  }), (_vm.allowStandardLogin) ? _c('form', {
    staticClass: "w-login-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [(_vm.state === 'normal') ? _c('div', {
    staticClass: "login-fields"
  }, [_c('div', {
    staticClass: "w-login-form__row w-login-form__row--email"
  }, [_c('div', {
    staticClass: "w-input"
  }, [_c('label', {
    staticClass: "w-input__label",
    attrs: {
      "for": "loginemail"
    }
  }, [_vm._v("Email address")]), ((_vm.loginType === 'account' || _vm.password === 'xxx' ? 'text' : 'email') === 'checkbox') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "w-input__input",
    attrs: {
      "id": "loginemail",
      "placehoder": "",
      "autocomplete": _vm.isEnterprise ? 'off' : 'username',
      "required": "required",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.email) ? _vm._i(_vm.email, null) > -1 : (_vm.email)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.email,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.email = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.email = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.email = $$c
        }
      }
    }
  }) : ((_vm.loginType === 'account' || _vm.password === 'xxx' ? 'text' : 'email') === 'radio') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "w-input__input",
    attrs: {
      "id": "loginemail",
      "placehoder": "",
      "autocomplete": _vm.isEnterprise ? 'off' : 'username',
      "required": "required",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.email, null)
    },
    on: {
      "change": function($event) {
        _vm.email = null
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "w-input__input",
    attrs: {
      "id": "loginemail",
      "placehoder": "",
      "autocomplete": _vm.isEnterprise ? 'off' : 'username',
      "required": "required",
      "type": _vm.loginType === 'account' || _vm.password === 'xxx' ? 'text' : 'email'
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })])]), _c('div', {
    staticClass: "w-login-form__row w-login-form__row--password"
  }, [_c('password-input', {
    attrs: {
      "label": "Password",
      "autocomplete": _vm.isEnterprise ? 'off' : 'current-password',
      "required": "required"
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  })], 1), (_vm.showRememberMe || !_vm.inAppLogin) ? _c('div', {
    staticClass: "w-login-form__row w-login-form__row--remember"
  }, [(_vm.showRememberMe) ? _c('label', {
    staticClass: "w-checkbox",
    attrs: {
      "for": "rememberMe"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rememberMe),
      expression: "rememberMe"
    }],
    staticClass: "w-checkbox__input",
    attrs: {
      "id": "rememberMe",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.rememberMe) ? _vm._i(_vm.rememberMe, null) > -1 : (_vm.rememberMe)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.rememberMe,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.rememberMe = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.rememberMe = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.rememberMe = $$c
        }
      }
    }
  }), _c('span', {
    staticClass: "w-checkbox__label"
  }, [_vm._v("Remember me")])]) : _vm._e(), (!_vm.inAppLogin) ? _c('router-link', {
    attrs: {
      "to": {
        path: _vm.forgotPasswordLink,
        query: Object.assign(_vm.$route.query, {
          email: _vm.email
        })
      }
    }
  }, [_vm._v("Forgot password?")]) : _vm._e()], 1) : _vm._e()]) : _vm._e(), _vm._m(0)]) : _vm._e(), _c('div', {
    staticClass: "w-page-footer"
  }, [(_vm.showGoogleSSO) ? _c('a', {
    staticClass: "w-button",
    attrs: {
      "href": _vm.googleSSOURL
    },
    on: {
      "click": _vm.onClickGoogleSSO
    }
  }, [_vm._m(1), _c('span', {
    staticClass: "w-button__label"
  }, [_vm._v("Log in with Google")])]) : _vm._e(), (_vm.showSAML) ? _c('a', {
    staticClass: "w-button w-button--link",
    on: {
      "click": _vm.initSAML
    }
  }, [_c('span', {
    staticClass: "w-button__label"
  }, [_vm._v("Single Sign On (SSO)")])]) : _vm._e(), (_vm.startText) ? _c('div', {
    staticClass: "w-page-footer__start-text",
    domProps: {
      "innerHTML": _vm._s(_vm.startText)
    }
  }) : _vm._e()])], 1) : _vm._e(), (_vm.state === '2fa') ? _c('div', {
    staticClass: "login-form__two-factor-auth"
  }, [_c('form', {
    staticClass: "w-login-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('page-header', {
    attrs: {
      "title": "Two Factor Authentication",
      "subTitle": "Please enter your six-digit number from your authenticator app.",
      "error": _vm.formError,
      "hideable": false
    }
  }), _c('div', {
    staticClass: "w-auth-code w-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.twoFactorPasscode),
      expression: "twoFactorPasscode"
    }],
    staticClass: "w-auth-code__input w-input__input",
    attrs: {
      "type": "text",
      "inputmode": "numeric",
      "pattern": "[0-9]*",
      "maxlength": "8",
      "placeholder": "Authentication Passcode",
      "autocomplete": "off",
      "required": "required"
    },
    domProps: {
      "value": (_vm.twoFactorPasscode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.twoFactorPasscode = $event.target.value
      }
    }
  })]), _vm._m(2), _c('div', {
    staticClass: "w-page-footer"
  }, [_c('button', {
    staticClass: "w-button w-button--link",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.reset
    }
  }, [_c('span', {
    staticClass: "w-button__label"
  }, [_vm._v("Cancel")])])])], 1)]) : _vm._e(), (_vm.state === '2fa-setup') ? _c('tfa-setup', {
    attrs: {
      "forced": _vm.forced
    },
    on: {
      "cancel": _vm.reset,
      "setup-complete": _vm.onSubmit
    }
  }) : _vm._e()], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-login-form__row w-login-form__row--action"
  }, [_c('button', {
    staticClass: "w-button w-button--blue",
    attrs: {
      "type": "submit"
    }
  }, [_c('span', {
    staticClass: "w-button__label"
  }, [_vm._v("Log in")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "w-button__icon"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(558),
      "alt": "Google",
      "width": "16",
      "height": "16"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-login-form"
  }, [_c('div', {
    staticClass: "w-login-form__row w-login-form__row--action"
  }, [_c('button', {
    staticClass: "w-button w-button--blue",
    attrs: {
      "type": "submit"
    }
  }, [_c('span', {
    staticClass: "w-button__label"
  }, [_vm._v("Log in")])])])])
}]}

/***/ }),
/* 599 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-product-list"
  }, _vm._l((_vm.productItems), function(product) {
    return _c('a', {
      key: product.code,
      staticClass: "w-product-list__item",
      attrs: {
        "href": product.url
      }
    }, [_c('img', {
      staticClass: "w-product-list__item-image",
      attrs: {
        "src": product.logoUrl
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "w-product-list__item-content"
    }, [_c('h5', {
      staticClass: "w-product-list__item--title"
    }, [_vm._v(_vm._s(product.title))]), _vm._v(" "), _c('div', {
      staticClass: "w-product-list__item--description"
    }, [_vm._v(_vm._s(product.description))])])])
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 600 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isLoading) ? _c('div', {
    staticClass: "loading"
  }, [_vm._m(0), (_vm.showTryAgain) ? _c('div', {
    staticClass: "try-again"
  }, [_c('div', {
    staticClass: "try-again__link"
  }, [_c('button', {
    staticClass: "w-button w-button--link",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('reset')
      }
    }
  }, [_c('span', {
    staticClass: "w-button__label"
  }, [_vm._v("Try again")])])]), (_vm.inAppLogin) ? _c('div', {
    staticClass: "try-again__link"
  }, [_c('button', {
    staticClass: "w-button w-button--link",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onCancel
    }
  }, [_c('span', {
    staticClass: "w-button__label"
  }, [_vm._v("Cancel")])])]) : _vm._e()]) : _vm._e()]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-preloader"
  }, [_c('div', {
    staticClass: "w-preloader__spinner--large"
  })])
}]}

/***/ }),
/* 601 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gdpr-consent"
  }, [_c('page-header', {
    attrs: {
      "title": "We're Updating How We Manage Data"
    }
  }), _c('form', {
    staticClass: "w-login-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.$emit('seen')
      }
    }
  }, [_vm._m(0), _vm._m(1), _vm._m(2), _vm._m(3)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-login-form__row"
  }, [_c('p', [_vm._v("We really appreciate you using our Teamwork.com collaboration\n products to power your business. Your success is important to us\n and we are constantly striving to improve our products performance\n and enable better productivity for all our customers.\n As part of this improvement we have made some important changes to\n how we protect data within Teamwork.com and we want to share these with you.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-login-form__row"
  }, [_c('p', [_vm._v("We would like to share with you our updated "), _c('a', {
    attrs: {
      "href": "https://www.teamwork.com/privacy-statement",
      "target": "_blank"
    }
  }, [_vm._v("Privacy Statement")]), _vm._v(". We are committed to the highest standards of data security\n & management and all our processes and systems have been\n updated to include the new provisions of GDPR.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-login-form__row"
  }, [_c('p', [_vm._v("The new practices came into effect on "), _c('strong', [_vm._v("May 25, 2018")]), _vm._v(". If you have any questions about these changes please reach out to us at "), _c('a', {
    attrs: {
      "href": "mailto:privacy@teamwork.com"
    }
  }, [_vm._v("privacy@teamwork.com")]), _vm._v(".")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-login-form__row w-login-form__row--action"
  }, [_c('button', {
    staticClass: "w-button w-button--blue",
    attrs: {
      "type": "submit",
      "autofocus": "autofocus"
    }
  }, [_c('span', {
    staticClass: "w-button__label"
  }, [_vm._v("OK")])])])
}]}

/***/ }),
/* 602 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isLoading) ? _c('Loading', {
    attrs: {
      "is-loading": ""
    }
  }) : [_c('div', {
    staticClass: "content"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "src": _vm.stateContent[_vm.state].image
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "header"
  }, [_vm._v("\n        " + _vm._s(_vm.stateContent[_vm.state].headerText) + "\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "body-text",
    domProps: {
      "innerHTML": _vm._s(_vm.stateContent[_vm.state].bodyText)
    }
  }), _vm._v(" "), (_vm.stateContent[_vm.state].footerText) ? _c('strong', {
    staticClass: "footer-text"
  }, [_vm._v("\n        " + _vm._s(_vm.stateContent[_vm.state].footerText) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.stateContent[_vm.state].nextText) ? _c('p', {
    staticClass: "body-text"
  }, [_vm._v("\n        " + _vm._s(_vm.stateContent[_vm.state].nextText) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('button', {
    staticClass: "w-button w-button--blue continue-cta",
    class: {
      'w-button--gray': _vm.isCTALoading
    },
    attrs: {
      "disabled": _vm.isCTALoading,
      "data-identifier": _vm.stateContent[_vm.state].dataIdentifier
    },
    on: {
      "click": _vm.stateContent[_vm.state].ctaAction
    }
  }, [_c('span', {
    staticClass: "w-button__label"
  }, [_vm._v(_vm._s(_vm.stateContent[_vm.state].ctaText))])])]), _vm._v(" "), (_vm.errorMessage) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v("\n        " + _vm._s(_vm.errorMessage) + "\n      ")]) : _vm._e()])]], 2)
},staticRenderFns: []}

/***/ }),
/* 603 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isLoading) ? _c('Loading', {
    attrs: {
      "is-loading": ""
    }
  }) : [_c('h1', {
    staticClass: "persona-view-header"
  }, [_vm._v("\n      Excuse us for jumping in... we have a quick question. Don’t worry, we won’t ask again.\n    ")]), _vm._v(" "), _c('h3', [_vm._v("How would you best describe your role?")]), _vm._v(" "), _c('div', {
    staticClass: "persona-view-radio-group",
    attrs: {
      "role": "radiogroup",
      "aria-label": 'Select your default project view'
    }
  }, _vm._l((_vm.personasList), function(persona, index) {
    return _c('div', {
      key: ("persona-view-option-" + index),
      ref: ("persona-view-option-" + index),
      refInFor: true,
      staticClass: "persona-view__item",
      class: {
        'persona-view__item--selected': persona.value === _vm.selectedPersona
      },
      attrs: {
        "role": "radio",
        "aria-checked": persona.value === _vm.selectedPersona,
        "tabindex": "0",
        "aria-label": persona.description,
        "data-identifier": persona.value
      },
      on: {
        "click": function($event) {
          return _vm.onSelect(persona.value)
        },
        "keyup": function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          return _vm.onSelect(persona.value)
        }
      }
    }, [_c('div', {
      staticClass: "persona-view-icon-wrapper",
      class: {
        'persona-view__item-text--selected': persona.value === _vm.selectedPersona
      }
    }, [(persona.value === _vm.selectedPersona) ? _c('img', {
      staticClass: "persona-view__item-check",
      attrs: {
        "src": _vm.checkIcon
      }
    }) : _vm._e(), _vm._v(" "), _c('img', {
      staticClass: "persona-view__item-icon",
      attrs: {
        "src": persona.icon
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "persona-view__item-text"
    }, [_vm._v(_vm._s(persona.label))]), _vm._v(" "), _c('label', {
      staticClass: "persona-view__item-text-description"
    }, [_vm._v(_vm._s(persona.description))])])])
  }), 0), _vm._v(" "), (_vm.errorMessage) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v("\n      " + _vm._s(_vm.errorMessage) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "persona-view-info"
  }, [_vm._v("\n      We use this information to personalize your\n      experience, tailoring it to suit your needs perfectly.\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "persona-view__actions"
  }, [_c('button', {
    staticClass: "w-button w-button--blue persona-view__submit",
    attrs: {
      "data-identifier": "persona-submit"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_c('span', {
    staticClass: "w-button__label"
  }, [_vm._v("Next")])])])]], 2)
},staticRenderFns: []}

/***/ }),
/* 604 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "saml-starter"
  }, [_c('loading', {
    attrs: {
      "isLoading": _vm.isLoading
    },
    on: {
      "reset": _vm.reload
    }
  }), (!_vm.isLoading) ? _c('div', {
    staticClass: "content"
  }, [_c('page-header', {
    attrs: {
      "title": _vm.title
    }
  }), _c('form', {
    staticClass: "w-login-form w-login-form--sso",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_vm._m(0)]), _c('div', {
    staticClass: "w-page-footer"
  }, [(_vm.allowStandardLogin) ? _c('button', {
    staticClass: "w-button w-button--link",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$store.commit('setLoginState', 'standard')
      }
    }
  }, [_c('span', {
    staticClass: "w-button__label"
  }, [_vm._v("Standard login")])]) : _vm._e()])], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-login-form__row w-login-form__row--action"
  }, [_c('button', {
    staticClass: "w-button w-button--blue",
    attrs: {
      "type": "submit"
    }
  }, [_c('span', {
    staticClass: "w-button__label"
  }, [_vm._v("Single Sign On")])])])
}]}

/***/ }),
/* 605 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-success"
  }, [_c('page-header', {
    attrs: {
      "title": _vm.title
    }
  }), _c('div', {
    staticClass: "content"
  }, [_c('form', {
    staticClass: "w-login-form"
  }, [_c('div', {
    staticClass: "w-login-form__row"
  }, [_c('p', [_vm._v("Login successful")]), _c('div', {
    staticClass: "auth-token",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v(_vm._s(_vm.code))])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 606 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-token-auth"
  }, [_c('loading', {
    attrs: {
      "isLoading": _vm.isLoading
    },
    on: {
      "reset": _vm.reload
    }
  }), (!_vm.isLoading) ? _c('div', {
    staticClass: "content"
  }, [(_vm.state === 'company-info') ? _c('company-info', {
    attrs: {
      "default-info": _vm.companyInfo
    },
    on: {
      "saved": _vm.postSAMLAuth
    }
  }) : _vm._e(), (_vm.state === 'gdpr-consent') ? _c('gdpr-consent', {
    on: {
      "seen": _vm.postSAMLAuth
    }
  }) : _vm._e(), (_vm.state === 'app-consent') ? _c('app-consent', {
    attrs: {
      "code": _vm.code,
      "app": _vm.app
    }
  }) : _vm._e(), (_vm.state === 'normal') ? _c('div', {
    staticClass: "content"
  }, [_c('page-header', {
    attrs: {
      "title": _vm.title
    }
  }), _c('form', {
    staticClass: "w-login-form"
  }, [_c('div', {
    staticClass: "w-login-form__row"
  }, [_c('p', [_vm._v("Login successful")]), _c('div', {
    staticClass: "auth-token",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v(_vm._s(_vm.code))])])])], 1) : _vm._e()], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 607 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-reset-password"
  }, [_c('loading', {
    attrs: {
      "isLoading": _vm.isLoading
    },
    on: {
      "reset": _vm.reload
    }
  }), (!_vm.isLoading) ? _c('div', {
    staticClass: "content"
  }, [_c('page-header', {
    attrs: {
      "title": _vm.title,
      "subTitle": _vm.subTitle,
      "error": _vm.formError
    }
  }), _c('form', {
    staticClass: "w-login-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmitReset.apply(null, arguments)
      }
    }
  }, [(_vm.state === 'normal') ? _c('div', {
    staticClass: "password-form"
  }, [_c('div', {
    staticClass: "w-login-form__row w-login-form__row--email"
  }, [_c('password-input', {
    attrs: {
      "label": "New password",
      "autocomplete": "new-password",
      "required": "required"
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  })], 1), _c('div', {
    staticClass: "w-login-form__row w-login-form__row--action"
  }, [_c('button', {
    staticClass: "w-button",
    class: {
      'w-button--gray': !_vm.canSubmit, 'w-button--blue': _vm.canSubmit
    },
    attrs: {
      "type": "submit",
      "disabled": !_vm.canSubmit
    }
  }, [_c('span', {
    staticClass: "w-button__label"
  }, [_vm._v("Set new password")])])])]) : _vm._e(), (_vm.state === 'success') ? _c('div', {
    staticClass: "reset-success"
  }, [_c('ul', [(_vm.apps.projects) ? _c('li', [_c('a', {
    attrs: {
      "href": _vm.siteURL
    }
  }, [_vm._v("Continue to Teamwork")])]) : _vm._e(), (_vm.apps.desk) ? _c('li', [_c('a', {
    attrs: {
      "href": _vm.siteURL + 'desk/'
    }
  }, [_vm._v("Continue to Teamwork Desk")])]) : _vm._e(), (_vm.apps.chat) ? _c('li', [_c('a', {
    attrs: {
      "href": _vm.siteURL + 'chat/'
    }
  }, [_vm._v("Continue to Teamwork Chat")])]) : _vm._e(), (_vm.apps.spaces) ? _c('li', [_c('a', {
    attrs: {
      "href": _vm.siteURL + 'spaces/'
    }
  }, [_vm._v("Continue to Teamwork Spaces")])]) : _vm._e(), (_vm.apps.crm) ? _c('li', [_c('a', {
    attrs: {
      "href": _vm.siteURL + 'crm/'
    }
  }, [_vm._v("Continue to Teamwork CRM")])]) : _vm._e()])]) : _vm._e()])], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 608 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isLoading) ? _c('loading', {
    attrs: {
      "is-loading": "is-loading"
    }
  }) : (_vm.isOnBackupCodesScreen) ? [_c('p', {
    staticClass: "section"
  }, [_vm._v("Setup complete!")]), _c('p', {
    staticClass: "section"
  }, [_vm._v("Please write down these backup codes. They allow you to restore access to your account if you \nlose access to your two-factor authentication codes. You \ncan then enter one of these instead. Note that eaach of these \ncodes can only be used once.")]), _c('pre', {
    staticClass: "section backup-codes"
  }, [_vm._v(_vm._s(_vm.backupCodesFormatted))]), _c('button', {
    staticClass: "w-button w-button--blue",
    on: {
      "click": function($event) {
        return _vm.$emit('setup-complete')
      }
    }
  }, [_vm._v("Ok")])] : [(_vm.forced) ? _c('div', {
    staticClass: "section"
  }, [_c('p', [_vm._v("An administrator has enforced two factor authentication on this site. ")])]) : _vm._e(), _c('p', {
    staticClass: "section"
  }, [_vm._v("Two-factor authentication setup is required to proceed. Please download "), _c('b', [_vm._v("Google Authenticator")]), _vm._v(" app for "), _c('a', {
    attrs: {
      "href": "https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=en"
    }
  }, [_vm._v("Android ")]), _vm._v("or "), _c('a', {
    attrs: {
      "href": "https://itunes.apple.com/us/app/google-authenticator/id388497605"
    }
  }, [_vm._v("iPhone")]), _vm._v(".")]), (_vm.seed) ? _c('div', {
    staticClass: "section"
  }, [_c('p', [_vm._v("Enter the provided key into the app: "), _c('b', {
    domProps: {
      "textContent": _vm._s(_vm.seed)
    }
  })])]) : _c('div', {
    staticClass: "section"
  }, [_c('p', [_vm._v("Scan the barcode with the app:")]), _c('img', {
    staticClass: "qr",
    attrs: {
      "src": "/launchpad/2fa/login/setup/qr"
    }
  }), _c('p', [_vm._v("If you're unable to scan the barcode, you can "), _c('a', {
    staticClass: "seed-button",
    on: {
      "click": _vm.getSeed
    }
  }, [_vm._v("enter the key manually")]), _vm._v(".")])]), _c('p', {
    staticClass: "section"
  }, [_vm._v("After that, enter the 6-digit code that is shown in the app below:")]), _c('div', {
    staticClass: "w-input code-input"
  }, [_c('label', {
    staticClass: "w-input__label",
    attrs: {
      "for": "tfa-code"
    }
  }, [_vm._v("Authentication code")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.codeModel),
      expression: "codeModel"
    }],
    staticClass: "w-input__input",
    attrs: {
      "id": "tfa-code",
      "autocomplete": "one-time-code"
    },
    domProps: {
      "value": (_vm.codeModel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.codeModel = $event.target.value
      }
    }
  })]), (_vm.errorMessage) ? _c('p', {
    staticClass: "error is-invalid"
  }, [_vm._v("Error: " + _vm._s(_vm.errorMessage))]) : _vm._e(), _c('button', {
    staticClass: "w-button w-button--blue",
    on: {
      "click": _vm.setupTfa
    }
  }, [_vm._v("Verify")]), _c('button', {
    staticClass: "w-button w-button--link",
    on: {
      "click": function($event) {
        return _vm.$emit('cancel')
      }
    }
  }, [_vm._v("Cancel")])]], 2)
},staticRenderFns: []}

/***/ }),
/* 609 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "marketing-content",
    class: {
      'marketing-content--loaded': _vm.story && !_vm.story.hidden && _vm.display
    }
  }, [_c('div', {
    staticClass: "marketing-content__bg"
  }), _vm._v(" "), (_vm.story) ? _c('div', {
    staticClass: "marketing-content__wrap"
  }, [(_vm.story.title) ? _c('h3', {
    staticClass: "marketing-content__title"
  }, [_vm._v("\n      " + _vm._s(_vm.story.title) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.story.image && _vm.story.image.filename) ? _c('img', {
    staticClass: "marketing-content__picture",
    attrs: {
      "width": "500",
      "height": "347",
      "alt": "",
      "src": ((_vm.story.image.filename) + "/m/fit-in/1000x694/filters:format(webm):quality(90)")
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "marketing-content__text"
  }, [(_vm.story.firstParagraph) ? _c('p', [_vm._v("\n        " + _vm._s(_vm.story.firstParagraph) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('ul', [(_vm.story.bullet1) ? _c('li', [_vm._v("\n          " + _vm._s(_vm.story.bullet1) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.story.bullet2) ? _c('li', [_vm._v("\n          " + _vm._s(_vm.story.bullet2) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.story.bullet3) ? _c('li', [_vm._v("\n          " + _vm._s(_vm.story.bullet3) + "\n        ")]) : _vm._e()]), _vm._v(" "), (_vm.story.secondParagraph) ? _c('p', [_vm._v("\n        " + _vm._s(_vm.story.secondParagraph) + "\n      ")]) : _vm._e()])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 610 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-login"
  }, [_c(_vm.loginState, {
    tag: "component"
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "b-app-structure",
    class: [_vm.bodyClasses],
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "b-app-structure__main"
  }, [_c('section', {
    staticClass: "b-login-holder"
  }, [_c('div', {
    staticClass: "w-app-login-logo"
  }, [(_vm.loginType !== 'account' || _vm.allowBranding) ? _c('img', {
    staticClass: "w-app-login-logo__image",
    attrs: {
      "src": __webpack_require__(564),
      "alt": "Teamwork.com"
    }
  }) : _vm._e()]), _c('loading', {
    attrs: {
      "isLoading": _vm.siteLoading
    },
    on: {
      "reset": _vm.reload
    }
  }), (!_vm.siteLoading) ? _c('div', {
    staticClass: "content",
    class: {
      'content-persona': _vm.isPersonaCapture, 'content-verify-email': _vm.isEmailValidation
    }
  }, [(_vm.siteNotFound && !_vm.fatalError) ? _c('site-not-found') : _vm._e(), (_vm.showSiteLogo) ? _c('div', {
    staticClass: "w-app-login-site-logo"
  }, [_c('img', {
    staticClass: "w-app-login-site-logo__image",
    attrs: {
      "src": _vm.siteLogo,
      "alt": _vm.siteName
    }
  })]) : _vm._e(), (!_vm.siteNotFound && _vm.fatalError) ? _c('error-message') : _vm._e(), (!_vm.siteNotFound && !_vm.fatalError) ? _c('router-view') : _vm._e()], 1) : _vm._e()], 1)]), (!_vm.isEmailValidation) ? _c('div', {
    staticClass: "b-app-structure__secondary"
  }, [(_vm.inGenericLogin) ? _c('div', {
    staticClass: "b-app-structure__secondary-content"
  }, [_c('p', [_vm._v(_vm._s("Don't have an account yet?"))]), _vm._m(0)]) : _vm._e(), _c('MarketingContent', {
    attrs: {
      "display": _vm.displayMarketingContent
    }
  })], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "w-button",
    attrs: {
      "href": "https://www.teamwork.com/signup"
    }
  }, [_c('span', {
    staticClass: "w-button__label"
  }, [_vm._v("Sign up")])])
}]}

/***/ }),
/* 612 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-forgot-password"
  }, [_c('loading', {
    attrs: {
      "isLoading": _vm.isLoading
    },
    on: {
      "reset": _vm.reload
    }
  }), (!_vm.isLoading) ? _c('div', {
    staticClass: "content"
  }, [_c('page-header', {
    attrs: {
      "title": "Recover password",
      "error": _vm.formError
    }
  }), (!_vm.passwordReset) ? _c('form', {
    staticClass: "w-login-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "w-login-form__row w-login-form__row--email"
  }, [_c('div', {
    staticClass: "w-input"
  }, [_c('label', {
    staticClass: "w-input__label",
    attrs: {
      "for": "loginemail"
    }
  }, [_vm._v("Email address")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "w-input__input",
    attrs: {
      "id": "loginemail",
      "type": "email",
      "placehoder": "",
      "autocomplete": "username",
      "required": "required"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })])]), _c('div', {
    staticClass: "w-login-form__row w-login-form__row--action"
  }, [_c('button', {
    staticClass: "w-button",
    class: {
      'w-button--gray': !_vm.canSubmit, 'w-button--blue': _vm.canSubmit
    },
    attrs: {
      "type": "submit",
      "disabled": !_vm.canSubmit
    }
  }, [_c('span', {
    staticClass: "w-button__label"
  }, [_vm._v("Recover password")])])])]) : _vm._e(), (_vm.passwordReset) ? _c('form', {
    staticClass: "w-login-form"
  }, [_c('div', {
    staticClass: "w-login-form__row"
  }, [(_vm.loginType === 'account') ? _c('p', [_vm._v("Please check your email inbox and follow the instructions to reset your password.")]) : _c('p', [_vm._v("If you have a Teamwork account you should receive an email from us.\nPlease check your email inbox and follow the instructions to reset your password.")])])]) : _vm._e(), _c('div', {
    staticClass: "w-page-footer"
  }, [_c('router-link', {
    staticClass: "w-button w-button--link",
    attrs: {
      "to": {
        path: _vm.loginLink,
        query: Object.assign(_vm.$route.query, {
          email: _vm.email
        })
      },
      "tag": "button",
      "type": "button"
    }
  }, [_c('span', {
    staticClass: "w-button__label"
  }, [_vm._v("Return to login")])])], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 613 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "saml-form"
  }, [_c('loading', {
    attrs: {
      "isLoading": _vm.isLoading
    },
    on: {
      "reset": _vm.reload
    }
  }), (!_vm.isLoading) ? _c('div', {
    staticClass: "content"
  }, [_c('page-header', {
    attrs: {
      "title": "Single Sign On",
      "subTitle": "Log in and let's get productive!",
      "error": _vm.formError
    }
  }), _c('form', {
    staticClass: "w-login-form w-login-form--sso",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "w-login-form__row w-login-form__row--email"
  }, [_c('div', {
    staticClass: "w-input"
  }, [_c('label', {
    staticClass: "w-input__label",
    attrs: {
      "for": "loginemail"
    }
  }, [_vm._v("Email address")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "w-input__input",
    attrs: {
      "id": "loginemail",
      "type": "email",
      "placehoder": "",
      "autocomplete": "username",
      "required": "required"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })])]), _c('div', {
    staticClass: "w-login-form__row w-login-form__row--action"
  }, [_c('button', {
    staticClass: "w-button",
    class: {
      'w-button--gray': !_vm.canSubmit, 'w-button--blue': _vm.canSubmit
    },
    attrs: {
      "type": "submit",
      "disabled": !_vm.canSubmit
    }
  }, [_c('span', {
    staticClass: "w-button__label"
  }, [_vm._v("Log in")])])])]), _c('div', {
    staticClass: "w-page-footer"
  }, [_c('button', {
    staticClass: "w-button w-button--link",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$store.commit('setLoginState', 'standard')
      }
    }
  }, [_c('span', {
    staticClass: "w-button__label"
  }, [_vm._v("Return to login")])])])], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 614 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "error-message"
  }, [_c('page-header', {
    attrs: {
      "title": _vm.error,
      "subTitle": _vm.message
    }
  }), _c('form', {
    staticClass: "w-login-form"
  }, [_c('div', {
    staticClass: "w-login-form__row"
  }, [(_vm.explanation) ? _c('div', {
    staticClass: "explanation"
  }, [_c('p', [_vm._v(_vm._s(_vm.explanationHTML))])]) : _vm._e(), (!_vm.explanation.length) ? _c('div', {
    staticClass: "default-explanation"
  }, [_c('p', [_vm._v("But don't panic, we are here to help...")]), _vm._m(0)]) : _vm._e()])]), (_vm.inAppLogin) ? _c('div', {
    staticClass: "w-page-footer"
  }, [_c('button', {
    staticClass: "w-button w-button--blue",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.onClickBackToApp.apply(null, arguments)
      }
    }
  }, [_c('span', {
    staticClass: "w-button__label"
  }, [_vm._v("Back to app")])])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("If something has gone wrong and you're not sure why, just "), _c('a', {
    attrs: {
      "href": "https://www.teamwork.com/contact",
      "target": "_blank"
    }
  }, [_vm._v("drop us a quick note")]), _vm._v(" and we will do our best to help.")])
}]}

/***/ }),
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(221);
module.exports = __webpack_require__(220);


/***/ })
],[618]);


// WEBPACK FOOTER //
// static/js/app.46fa4d6cf11573948111.js